import i18next from "i18next";
import { initReactI18next } from "react-i18next";
const resources = {
    en: {
        translation: {
            // Menu
            "Energy Communities": "Energy Communities",
            "Administration": "Administration",
            "Manage Entities": "Manage Entities",
            "Manage Members": "Manage Members",
            "Manage Delivery Points": "Manage Delivery Points",
            "Member": "Member",
            "Community of": "Community of",
            "Energy": "Energy",
            "Surplus": "Surplus",
            "Potência": "Power",
            "Storage": "Storage",
            "Active Members": "Active Members",
            "All": "All",
            "Building": "Under Construction",
            "Prospecting-Communities": "Under Construction",
            "Add Community": "Add Community",
            "Communities": "Communities",
            "Reports": "Reports",
            "Forming": "Project",
            "Statistics": "Statistics",
            "Members": "Members",
            "Account": "Account",
            "All Members": "All",
            "Consumers": "Consumers",
            "Add New Member": "Add New Member",
            "Logout": "Logout",
            "Delivery Points": "Delivery Points",
            "Production Units": "Production",
            "Installations": "Installations",
            "Invoices": "Invoices",
            "Hi": "Hi",
            "Add": "Add",
            "Consumption Instalations": "Consumption",
            "Storage Installations": "Storage",
            // Membros

            "Name": "Name",
            "Community": "Community",
            "Zip Code": "Zip Code",
            "Status": "Status",
            "Selling Price": "Selling Price",
            "Start Date": "Start Date",
            "End Date": "End Date",
            "Network Buying Price": "Network Buying Price",
            "Community Buying Price": "Community Buying Price",
            "New Price": "New Price",
            "Installation": "Installation",
            "Invoicing Entities": "Invoicing Entities",
            "Member Installation": "Installation Data",
            "Consumtion Delivery Point": "Consumption Delivery Point",
            "Production Delivery Point": "Production Delivery Point",
            "Storage Delivery Point": "Storage Delivery Point",
            "Billing Period": "Billing Period",
            "City": "City",
            "Fiscal Number": "Tax Number",
            "Company?": "Company?",
            // Comunidades
            "Overview": "Overview",
            "View Community": "View Community",
            "Community Details": "Details",
            "Sales": "Sales",
            "Documents": "Documents",

            "Document List": "Uploaded Documents",
            "Production": "Production",
            // Delivery Points
            "Consumption Installations": "Consumption Installations",
            "Address": "Address",
            "Country": "Country",
            "View Consumption Installation": "View Consumption Installation",
            "Add Consumption Installation": "Add Consumption Installation",
            "Meter Type": "Meter Type",
            "Capacity": "Capacity",
            "Unit of Measure": "Unit of Measure",
            //Layout
            "label.layout.greeting": "Hi",
            "label.title.testIntegration": "Test Integration",
            "label.title.invoicing": "Tariff Model and Invoicing",
            "label.title.viewTariffModel": "View Tariff Model",
            "label.title.type": "Type",
            "label.title.communityDetails": "Community Details",
            "label.title.communityManagement": "Community Management",
            "label.title.consumption": "Consumption",
            "label.title.configureTariffPlan": "Configure Tariff Plan",
            "label.title.personalCompanyInformation": "Personal / Company Information",
            "label.title.personalInformation": "Personal Information",
            "label.title.addressInformation": "Address",
            "label.title.fiscalFinancialInformation": "Fiscal / Financial Information",
            "label.title.receiptInvoicingData": "Invoicing Information",
            "label.title.receiptHistory": "Receipt History",
            "label.title.newPowertradingContract": "New Tariff Plan",
            "label.title.updateOMIECertificate": "Update OMIE Certificate",
            "label.title.agents": "Agents",
            "label.title.users": "Users",
            "label.title.userIdentity": "User Identity",
            "label.title.accountStatus": "Account Status",
            "label.title.agentAuthorizations": "Agent Authorizations",
            "label.title.groupMemberships": "Groups",
            "label.title.userClients": "Client Access",
            "label.menu.permissions": "Permissions",
            "label.form.agent": "Agent",
            "label.form.allAgents": "All Agents",
            "label.form.isActive": "Active",
            "label.table.header.group": "Group",
            "label.table.header.groups": "Groups",
            "label.table.header.lastLogin": "Last Login",
            "label.button.addAgentAuthorization": "Add Authorization",
            "label.button.addGroup": "Add Group",
            "label.button.addClient": "Add Client",
            "label.title.preRegisterAgent": "Agent Pre-Registration",
            "label.agent.newEntity.step1": "Entity Type",
            "label.agent.newEntity.step1Subtitle": "Please select the type of entity you want to create.",
            "label.agent.newEntity.step2": "Entity Data",
            "label.agent.newEntity.step2Subtitle": "Please fill in the fields below with the data of the entity you want to create.",
            "label.agent.newEntity.step3": "Entity Responsible Data",
            "label.agent.newEntity.step3Subtitle": "Please fill in the fields below with the data of the responsible person for the entity you want to create.",
            "label.agent.newEntity.step4": "Confirmation",
            "label.agent.newEntity.step4Subtitle": "Please confirm the entered data.",
            "label.agent.preRegister.step1": "Agent Type",
            "label.agent.preRegister.step1Subtitle": "Before starting, please select one or more agent types for which you want to register.",
            "label.agent.preRegister.step2": "Agent Data",
            "label.agent.preRegister.step2Subtitle": "Please fill in the fields below with the agent data you want to register.",
            "label.agent.preRegister.step3": "Confirmation",
            "label.agent.type.aggregator": "Aggregator",
            "label.agent.type.aggregatorDescription": "Entity responsible for aggregating electricity produced, consumed, and stored by multiple clients for wholesale market trading or system services.",
            "label.agent.type.egac": "EGAC",
            "label.agent.type.egacDescription": "Collective Self-Consumption Manager Entity (EGAC) is responsible for the operational management of the day-to-day activity of Collective Self-Consumption (ACC).",
            "label.agent.type.marketer": "Marketer",
            "label.agent.type.marketerDescription": "Entity responsible for purchasing electricity in the wholesale market and direct sale to end consumers.",
            "label.agent.type.ese": "ESE",
            "label.agent.type.eseDescription": "Energy Services Company (ESE), responsible for developing energy efficiency projects.",
            "label.title.tariffModels": "Tariff Model Templates",
            "label.title.newTariffModel": "New Tariff Model",
            "label.step.newTariffModel.businessType": "Business Type",
            "label.step.newTariffModel.name": "Model Name",
            "label.step.newTariffModel.planType": "Tariff Plan Model Type",
            "label.step.newTariffModel.energy": "Energy",
            "label.title.markets": "Day-Ahead / Intraday Market",
            "label.title.paymentsAndReceiptsDetails": "Payments and Receipts Details",
            "label.title.results": "Results",
            "label.title.wholesaleResults": "Wholesale Results",
            "label.title.receivable": "Payments and Receipts",
            "label.title.energy": "Energy",
            "label.title.programmeResults": "Program Results",
            "label.title.programmeDate": "Program Date",
            "label.title.intradayMarkets": "Intraday Markets",
            "label.title.integrationsConfiguration": "Integrations Configuration",
            "label.title.reports": "Reports",
            "label.title.preRegistration": "Pre-Registration",
            "label.title.activation": "Activating",
            "label.title.activeContracts": "Active",
            "label.title.refused": "Refused",
            "label.title.closed": "Closed",
            "label.title.dgegData": "Reserved Area Access Data at DGEG",
            "label.title.egacEredesData": "EGAC Reserved Area Access Data at E-Redes",
            "label.text.sensitiveDataAccessibleIndie": "The data entered in this area is sensitive and may be viewed by an Indie Energy platform administrator for purposes related to obtaining data related to your activity.",
            "label.title.issueDate": "Issue Date",
            "label.title.dataUpload": "Energy Data Upload",
            "label.title.uploadDocuments": "Upload Documents",
            "label.title.dialog.actionLog": "Action History",
            "label.title.dialog.secretValue": "View Sensitive Data",
            "label.title.dialog.documentUpload": "Upload Documents",
            "label.title.dialog.validationLog": "Contract Validation",
            "label.title.editFinancialDocument": "Edit Document",
            "label.title.editOffer": "Edit Offer",
            "label.title.viewFinancialDocument": "View Document",
            "label.title.notAddress": "No Address",
            "label.title.noPlanSelected": "No Plan",
            "label.title.noProductSelected": "No Product",
            "label.title.noExternalMeterId": "Meter Code Not Available",
            "label.title.noInstalledPower": "N/A",
            "label.title.termsAndConditions": "Indie Energy App Terms and Conditions",
            "label.title.privacyPolicy": "Privacy Policy",
            "label.title.dataTreatment": "Scope of our Privacy Policy and data controller",
            "label.title.dataHandling": "For what purposes are the user's personal data collected?",
            "label.title.dataAccess": "Who has access to the user's personal data?",
            "label.title.dataRights": "What are the rights of personal data holders?",
            "label.title.dataSave": "Where is the user's data stored?",
            "label.title.webCookies": "Does the Indie Energy team use cookies on its website?",
            "label.title.authorizedUse": "Use of the Indie Energy App",
            "label.title.lawsAndLitigations": "Applicable Law and Dispute Resolution",
            "label.title.conditionModifications": "Modification of Conditions",
            "label.title.personalDataProtection": "Personal Data Protection",
            "label.title.clientObligations": "Client Obligations",
            "label.title.responsabilities": "Responsibility",
            "label.title.definitions": "Definitions",
            "label.title.overview": "Overview",
            "label.title.ownership": "Ownership",
            "label.title.loginForm": "Login",
            "label.title.registrationForm": "Registration Form",
            "label.title.search": "Search",
            "label.title.offers": "Offers",
            "label.title.offerDetails": "Offer Details",
            "label.title.offerSubmission": "Offer Submission",
            "label.title.offerView": "Offer Consultation",
            "label.title.physicalUnitSchedule": "Physical Unit Schedule",
            "label.title.submitTechnicalConstraint": "Submit Constraints",
            "label.title.searchTechnicalConstraint": "Consult Constraints",
            "label.title.TechnicalConstraintResolution": "Technical Constraint Resolution",
            "label.technicalConstraintsOffers.strategies.maxpower": "Maximum Power",
            "label.technicalConstraintsOffers.strategies.fixedprice": "Fixed Price",
            "label.validationResults.title": "Validation Results",
            "label.validationResults.summary.latestRun": "Latest run",
            "label.validationResults.summary.source": "Source",
            "label.validationResults.summary.totalIssues": "Total issues",
            "label.validationResults.subtitle.issues": "Errors",
            "label.validationResults.triggerSource.init": "Automatic Offer Creation",
            "label.validationResults.triggerSource.updateOrCreate": "Manual Offer Creation/Update",
            "label.validationResults.triggerSource.submit": "Offer Submission",
            "label.validationResults.table.severity": "Severity",
            "label.validationResults.table.rule": "Rule",
            "label.validationResults.table.period": "Period",
            "label.validationResults.table.offerUnit": "Offer Unit",
            "label.validationResults.table.message": "Message",
            "label.validationResults.table.validationDate": "Validation Date",
            "label.validationResults.severity.warning": "Warning",
            "label.validationResults.severity.error": "Error",
            "label.validationResults.severity.info": "Info",
            "label.validationResults.rule.TC_REQUIRED_DIRECTIONS": "Required Directions",
            "label.validationResults.rule.TC_NON_ZERO_DECLARED_POWER": "Non-zero Declared Power",
            "label.validationResults.rule.TC_DOWNWARD_FEASIBILITY": "Downward Feasibility",
            "label.validationResults.rule.TC_UPWARD_FEASIBILITY": "Upward Feasibility",
            "label.validationResults.message.TC_REQUIRED_DIRECTIONS": "Both upward and downward directions must be represented for the period.",
            "label.validationResults.message.TC_NON_ZERO_DECLARED_POWER": "Declared power must be different from zero.",
            "label.validationResults.message.TC_DOWNWARD_FEASIBILITY": "Declared downward power exceeds downward feasible power.",
            "label.validationResults.message.TC_UPWARD_FEASIBILITY": "Declared upward power exceeds upward feasible power.",
            "label.validationResults.rule.BAND_NEED_EXCEEDED": "Band Need Exceeded",
            "label.validationResults.rule.MIN_OFFER_VALUE": "Minimum Offer Value",
            "label.validationResults.rule.BAND_PRICE_RANGE": "Band Price Range",
            "label.validationResults.rule.ENERGY_PRICE_RANGE": "Energy Price Range",
            "label.validationResults.rule.BAND_POWER_RANGE": "Band Power Range",
            "label.validationResults.rule.UNAVAILABILITY_CONFLICT": "Unavailability Conflict",
            "label.validationResults.rule.BLOCK_1_REQUIRED": "Block 1 Required",
            "label.validationResults.message.BAND_NEED_EXCEEDED": "The sum of total power across all units exceeds the band need for this period.",
            "label.validationResults.message.MIN_OFFER_VALUE": "Average power is below the minimum required value of 1 MW.",
            "label.validationResults.message.BAND_PRICE_RANGE": "Band price is outside the allowed range [0, 999.99] EUR/MW.",
            "label.validationResults.message.ENERGY_PRICE_RANGE": "Energy price is outside the allowed range [-9999.99, 9999.99] EUR/MWh.",
            "label.validationResults.message.BAND_POWER_RANGE": "Total up or total down power is outside the allowed range [0, max_power].",
            "label.validationResults.message.UNAVAILABILITY_CONFLICT": "The physical unit has an active unavailability overlapping this period.",
            "label.validationResults.message.BLOCK_1_REQUIRED": "Block 1 is required but missing for this period.",
            "label.validationResults.state.noOffer": "Select Programming Horizon, BSP, and Programming Unit to load the corresponding validations.",
            "label.validationResults.state.contextReady": "Validation information is being presented for the selected context.",
            "label.validationResults.state.noValidationRun": "The selected offer does not have a validation run yet.",
            "label.validationResults.state.noIssues": "There are no validation errors for the current context.",
            "label.title.PDBF": "PDBF",
            "label.title.submitPhysicalUnitSchedule": "Submit Schedules",
            "label.title.marketAgent": "Market Agent",
            "label.title.marketProgramme": "Market Program",
            "label.title.contractTerms": "Contract Terms",
            "label.title.contractSigningandEndDates": "Contract Signing / Termination",
            "label.title.newReportRequest": "New Report Request",
            "label.title.newForecastTypeInstance": "New Forecast",
            "label.title.editForecastTypeInstance": "Edit Forecast",
            "label.title.exportSurplusData": "Download Surplus Document",
            "label.title.description": "Description",
            "label.title.ggsDeviations": "Global System Management (GGS) - Deviations",
            "label.title.deviations": "Deviations",
            "label.title.referenceStartDate": "Reference Start Date",
            "label.title.referenceEndDate": "Reference End Date",
            "label.title.documentsUpload": "Upload Documents",
            "label.title.documentType": "Document Type",
            "label.title.documentHeader": "Document Header",
            "label.title.documentDetails": "Document Details",
            "label.title.productionUnits": "Production Units",
            "label.title.producerExists": "Producer Exists",
            "label.title.viewProductionUnit": "View Production Unit",
            "label.title.viewProcessDetails": "View Process Details",
            "label.title.energyKWh": "Energy (kWh)",
            "label.title.quantity": "Quantity",
            "label.title.entities": "Entities",
            "label.title.newEntity": "New Entity",
            "label.title.newFinancialDocument": "New Document",
            "label.title.viewEntity": "View Entity",
            "label.title.members": "Members",
            "label.title.newMember": "New Member",
            "label.title.viewMember": "View Member",
            "label.title.contactInformation": "Contact Information",
            "label.title.agentInformation": "Agent Information",
            "label.title.consumptionInstallation": "Consumption Installation",
            "label.title.technicalDetails": "Technical Information",
            "label.title.solarPanels": "Solar Panels",
            "label.title.inverters": "Inverters",
            "label.title.installationLicencing": "Installation Licensing",
            "label.title.identity": "Identity",
            "label.title.productionUnit": "Production Unit (UPAC)",
            "label.title.registrationInformation": "Registration Information",
            "label.title.receivingConditions": "Receiving Data and Conditions",
            "label.title.others": "Other Information",
            "label.title.invoicingInformation": "Invoicing Data",
            "label.title.paymentInformation": "Receiving Data",
            "label.title.memberCommunity": "Community Data",
            "label.title.viewInvoice": "View Invoice",
            "label.title.invoiceInfo": "Invoice Data",
            "label.title.invoices": "Invoices",
            "label.title.due": "Due",
            "label.title.unpaid": "Unpaid",
            "label.title.unitValue": "Unit Value",
            "label.title.netTotal": "Net Value",
            "label.title.taxes": "Taxes",
            "label.title.programming": "Programming",
            "label.title.discountPercentage": "Discount",
            "label.title.discountValue": "Total with Discount",
            "label.title.totalEnergy": "Total Contracted Energy",
            "label.title.totalAmmount": "Amount to Receive/Pay",
            "label.title.averagePrice": "Average Price",
            "label.title.total": "Total",
            "label.title.all": "All",
            "label.title.upacOwner": "UPAC Owner",
            "label.title.communities": "Communities",
            "label.title.communityOf": "Community of",
            "label.title.newPrice": "Update Prices",
            "label.title.producers": "Producers",
            "label.title.address": "Address",
            "label.title.meter": "Meter",
            "label.title.contactInfo": "Contact Information",
            "label.title.lastReceipt": "Last Receipt",
            "label.title.goBackConfirmation": "Are you sure you want to go back?",
            "label.title.deleteConfirmation": "Are you sure you want to remove?",
            "label.title.physicalUnitDetails": "Physical Unit Details",
            "label.title.commercialAgentData": "Commercial Agent Data",
            "label.title.fileName": "File Name",
            "label.title.fileTitle": "Title",
            "label.title.fileType": "File Type",
            "label.title.forecastTypes": "Forecast Types",
            "label.title.uploadFiles": "Upload Documents",
            "label.title.contractDocuments": "Document List",
            "label.title.noPhysicalUnit": "No Installation",
            "label.title.paid": "Paid",
            "label.title.pending": "Pending",
            "label.title.processed": "Processed",
            "label.title.viewAggregator": "View Aggregator",
            "label.title.viewAgent": "View Market Agent",
            "label.title.processingResult": "Document Processing Result",
            "label.title.approvalResult": "Document Processing Result",
            "label.title.agentCodes": "REN / OMIE Codes",
            "label.title.omieCertificate": "OMIE Certificate",
            "label.title.certificatePassword": "OMIE Certificate Password",
            "label.title.marketPhysicalUnits": "Physical Units",
            "label.title.offerUnits": "Offer Units",
            "label.title.offerAreas": "Offer Areas",
            "label.title.newPhysicalUnit": "New Physical Unit",
            "label.title.newOfferingUnit": "New Offer Unit",
            "label.title.newOfferingArea": "New Offer Area",
            "label.title.viewMarketUnit": "View Physical Unit",
            "label.title.viewOfferUnit": "View Offer Unit",
            "label.title.viewOfferArea": "View Offer Area",
            "label.title.installations": "Installations",
            "label.title.details": "Data",
            "label.title.wholesale": "Wholesale",
            "label.title.technicalConstraints": "Technical Constraints",
            "label.title.priceSettings": "Offer Settings",
            "message.priceSettings.phase4Placeholder": "Market Settings base page is ready for feature wiring.",
            "message.priceSettings.defaultMarketFamily": "Default market family",
            "message.priceSettings.phase5TablePending": "Configurations table will be connected in the next phase.",
            "message.priceSettings.sessionsLoaded": "Sessions loaded",
            "message.priceSettings.verifyIdle": "Select a file and run template verification.",
            "message.priceSettings.verifyRunning": "Verifying template...",
            "message.priceSettings.verifySuccess": "Template verified successfully.",
            "message.priceSettings.verifyFailedWithIssues": "The template has validation issues and cannot be uploaded. Please review the issues below.",
            "message.priceSettings.uploadWarning": "After confirming the new template, the new prices will replace the current prices for the selected session.",
            "label.priceSettings.uploadDialogTitle": "Upload New Template",
            "label.priceSettings.session": "Session",
            "label.priceSettings.selectTemplateFile": "Select Template File",
            "label.priceSettings.verifyTemplate": "Verify Template",
            "label.priceSettings.detectedRows": "Detected rows",
            "label.priceSettings.blocksDetected": "Detected blocks",
            "label.priceSettings.periodsDetected": "Detected periods",
            "label.priceSettings.validationIssuesByBlock": "Validation issues by block and period:",
            "message.priceSettings.validationIssueLineBlockPeriod": "Block {{block}}, Period {{period}}: {{error}}",
            "message.priceSettings.validationIssueLineBlock": "Block {{block}}: {{error}}",
            "message.priceSettings.validationIssueLinePeriod": "Period {{period}}: {{error}}",
            "message.priceSettings.validationIssueLineGeneric": "{{error}}",
            "api.error.strategy.configuration.invalidTemplateFile": "The uploaded template is invalid or unreadable.",
            "api.error.strategy.configuration.emptyTemplate": "The template is empty. Please fill at least one valid block.",
            "api.error.strategy.configuration.uploadFileRequired": "Please select a template file.",
            "api.error.strategy.configuration.offeringUnitNotFound": "Offering unit not found or access denied.",
            "api.error.strategy.configuration.marketSessionNotFound": "Market session not found.",
            "api.error.strategy.configuration.strategyNotFound": "Strategy not found.",
            "api.error.strategy.configuration.strategyDisabled": "Selected strategy is disabled.",
            "api.error.strategy.configuration.missingFields": "Missing required fields for this operation.",
            "api.error.strategy.configuration.fileMustBeVerified": "You must verify the selected file before confirming upload.",
            "api.error.strategy.wh_default_prices.invalid_price": "Invalid price detected. Prices must be numeric values (Ex: 10.5).",
            "api.error.strategy.wh_default_prices.invalid_block": "Invalid block. Block must be between B1 and B10.",
            "api.error.strategy.wh_default_prices.invalid_period": "Invalid period. Period must be between H1Q1 and H25Q4.",
            "api.error.strategy.wh_default_prices.price_out_of_range": "Price out of range. Allowed values must be between 0 and 9999.9.",
            "api.error.strategy.wh_default_prices.duplicate_period_block": "Duplicate block/period combination detected.",
            "api.error.strategy.wh_default_prices.partial_block": "Partial block detected. Each filled block must contain all 100 periods.",
            "api.error.strategy.wh_default_prices.non_sequential_blocks": "Blocks should be filled sequentially with no gaps.",
            "api.error.strategy.tc_default_prices.direction_not_allowed": "Direction column is not allowed for technical constraints default prices.",
            "api.error.strategy.tc_default_prices.invalid_price": "Invalid price detected. Prices must be numeric values (Ex: 10.5).",
            "api.error.strategy.tc_default_prices.invalid_block": "Invalid block. Block must be between B1 and B10.",
            "api.error.strategy.tc_default_prices.invalid_period": "Invalid period. Period must be between H1Q1 and H25Q4.",
            "api.error.strategy.tc_default_prices.price_out_of_range": "Price out of range. Allowed values must be between 0 and 9999.9.",
            "api.error.strategy.tc_default_prices.duplicate_period_block": "Duplicate block/period combination detected.",
            "api.error.strategy.tc_default_prices.partial_block": "Partial block detected. Each filled block must contain all 100 periods.",
            "api.error.strategy.tc_default_prices.non_sequential_blocks": "Blocks should be filled sequentially with no gaps.",
            "api.error.technicalConstraintOfferManager.createVersion.noProgrammeResults": "No PDBF programme found for the selected date.",
            "api.error.techRestrictionsOffer.strategy.configurationNotFound": "Offer price configuration not defined. Please configure it in the Offering Unit page.",
            "api.error.techRestrictionsOffer.offerChanged": "This offer changed since you started editing. Review the latest version before continuing.",
            "api.error.techRestrictionsOffer.incompleteOfferingUnits": "Some Offering Units have not been generated yet. Generate them before submitting.",
            "api.error.techRestrictionsOffer.missingPDBF": "There is no PDBF for at least one of the selected offering units. If you continue, a programme will be generated using the unit's max power.",
            "api.error.techRestrictionsOffer.notPending": "This offer can no longer be edited directly. Create a new version to continue editing.",
            "label.title.offerChanged": "Offer Changed",
            "label.title.incompleteOfferingUnits": "Missing Offering Units",
            "label.title.missingPDBF": "No PDBF Available",
            "label.button.quit": "Quit",
            "label.button.generateMissing": "Generate Missing",
            "label.button.generateWithMaxPower": "Generate with Max Power",
            "label.text.missingUnitsGenerated": "Missing Offering Units were generated. Review the offer and submit again.",
            "error.api.createTariffPlan.installation.activeContractExist": "There are active tariff plans for this installation. Please close them before creating a new one.",
            "error.api.createTariffPlan.surplusCommunity.activeContractExist": "There are active tariff plans for this community. Please close them before creating a new one.",
            "label.title.viewInstallation": "View Installation",
            "label.title.production": "Production",
            "label.title.offersConfig": "Offers Configuration",
            "label.title.mfrr": "mFRR",
            "label.title.surplus": "Surplus",
            "label.title.viewForecastType": "View Forecast Type",
            "label.title.name": "Name",
            "label.title.required": "Required?",
            "label.title.value": "Value",
            "label.title.userProfile": "Access Data",
            "label.title.fiscalNumber": "Tax Number",
            "label.title.erpId": "ERP Reference",
            "label.title.default": "Use as Default",
            "label.title.active": "Active",
            "label.title.fiscalEntities": "Fiscal Entities",
            "label.title.notZipCode": "No Zip Code",
            "label.section.agentDetails": "Agent Details",
            "label.section.agentType": "Agent Type",
            "label.section.respPartyDetails": "Responsible Party Details",
            "label.section.automaticOffers": "Automatic Offers",
            "label.title.2FAAuthConfig.step1": "2-Factor Authentication",
            "label.text.2FAAuthConfig.intro": "To ensure your account's security, Indie Energy provides 2-factor authentication.",
            "label.text.2FAAuthConfig.intro2": "Please follow the steps below to configure 2-factor authentication. This authentication will be used, at this stage, only for certain actions on the platform.",
            "label.text.2FAAuthConfig.intro3": "Before proceeding, make sure you have an app like Google Authenticator or Microsoft Authenticator installed on your phone to generate authentication codes.",
            "label.title.2FAAuthConfig.step2": "Password Confirmation",
            "label.text.2FAAuthConfig.enterPassword": "Please enter your current password to continue.",
            "label.title.2FAAuthConfig.step3": "Authenticator App Configuration",
            "label.title.twoFactorAuth": "2-Factor Authentication Configuration",
            "label.text.twoFactorAuth.usage": "At Indie Energy, your data security is a priority. To ensure your account's security, Indie Energy provides 2-factor authentication for secure actions.",
            "label.title.fiscalAuthorityData": "Tax Authority Access Data",
            "label.text.fiscalAuthDataNotAccessibleIndie": "Tax Authority access data is not accessible on the Indie Energy platform by any user. It will only be used for SAF-T file integration with the Tax Authority when the feature is available.",
            "label.title.registrationData": "Registration Data",
            "label.title.agentData": "Agent Data",
            "label.title.respPartyData": "Responsible Party Data",
            "label.title.communityInvoiceDetail": "Invoice Details",
            "label.title.documentDate": "Document Date",
            "label.title.memberProfile": "Member Profile",
            "label.title.paymentMethods": "Payment Methods",
            "label.title.paymentReceivingMethods": "Payment and Receiving Methods",
            "label.title.contactData": "Contact Data",
            "label.title.afrrOfferSubmission": "Offer Submission",
            "label.title.afrrBandNeeds": "Band Needs",
            "label.title.afrrBandSwap": "Band Swap",
            "label.title.afrrBandPrice": "Band Price",
            "label.title.afrrBandResults": "Band Results",
            "label.title.afrrBandSwitching": "Band Switching",
            "label.title.switchingRequest": "Switching Request",
            "label.title.selectAgentAndDate": "Select an agent and date to view switching requests",
            "label.title.selectPeriod": "Select a period to view details",
            "label.title.responseAt": "Response at",
            "label.title.requestHour": "Hour",
            "label.title.afrrOfferSubmissionFilter": "Offer Configuration",
            "label.button.viewDocumentHistory": "View History",
            "label.button.viewDocument": "View Document",
            "label.button.editDocument": "Edit Document",
            "label.button.downloadDocument": "Download Document",
            "label.button.edit": "Edit",
            "label.button.autoInvoicing": "Self-Billing",
            "label.button.salesDocuments": "Sales Invoices",
            "label.button.newAutoInvoiceAgreement": "Register Self-Billing Agreement",
            "label.button.newPaymentMethod": "Add Payment Method",
            "label.button.inactivate": "Deactivate",
            "label.button.updateManagingEntity": "Change Managing Entity",
            "label.button.updateStatus": "Change Status",
            "label.button.updateCertificate": "Update Certificate",
            "label.button.configure2FA": "Configure Two-Factor Authentication",
            "label.button.registrationEmail": "Resend Registration Email",
            "label.button.preRegisterAgent": "Pre-Register Agent",
            "label.button.downloadExcel": "Download Excel",
            "label.button.cancelOffer": "Cancel Offer",
            "label.button.submitOffer": "Submit Offer",
            "label.button.submitSwitchingRequest": "Submit Request",
            "label.button.newRequest": "New Request",
            "label.button.newVersion": "New Version",
            "label.button.addLines": "Add Lines",
            "label.button.addPartition": "Add Partition",
            "label.button.addLine": "Add Row",
            "label.title.addSwitchingLines": "Add Switching Lines",
            "label.periodDetail": "Period {{period}} detail",
            "label.original": "Original",
            "label.current": "Current",
            "label.manualMode": "Manual Mode",
            "label.assistedMode": "Assisted Mode",
            "label.totalsMatch": "Totals match",
            "label.totalsMismatch": "Totals do not match",
            "label.title.editLine": "Edit Line",
            "label.button.createOffer": "Create Offer",
            "label.button.createOffers": "Create Offers",
            "label.button.createPartition": "Create Partition",
            "label.button.assistedOffer": "Assisted Offer",
            "label.button.assistedPartition": "Assisted Partition",
            "label.text.confirmAssistedPartition": "An assisted partition will be created for every period if {{programmeCode}} is available. Otherwise the partition will be empty.",
            "label.button.copyOffer": "Copy Offer",
            "label.text.confirmCopyOffer": "An editable copy of the current version will be created.",
            "label.button.manualOffer": "Manual Offer",
            "label.button.confirm": "Confirm",
            "label.button.configureMember": "Configure Installation Member(s)",
            "label.title.configureClient": "Configure Client",
            "label.button.createClient": "Create Client",
            "api.error.createClient.clientAlreadyExists": "A client with this fiscal number already exists. Close this window and search for that fiscal number in the clients table to select it.",
            "label.button.createInstallation": "Create Installation",
            "label.button.createMember": "Configure New Client",
            "label.button.configureNewInstallation": "Configure New Installation",
            "label.step.selectClient": "Select or Create Client",
            "label.step.selectClient.subtitle": "Search for the client in the table below and press Enter, or create a new one.",
            "label.step.newCommunityMember.selectOrCreatePhysicalUnitStep": "Select or Create Installation",
            "label.step.newCommunityMember.selectOrCreatePhysicalUnitStep.subtitle": "Search for the installation in the table below and press Enter, or create a new one.",
            "label.button.continue": "Continue",
            "label.button.delete": "Remove",
            "label.button.newReportRequest": "New Report Request",
            "label.button.actionLog": "Action History",
            "label.button.actions": "Other Actions",
            "label.button.changeSignEndContract": "Change Signature / Termination",
            "label.button.closeContract": "Close",
            "label.button.reopenContract": "Reopen",
            "label.button.updateContractTerms": "Change Terms",
            "label.button.newPurchaseDocument": "New Purchase Document / Self-Bill",
            "label.button.newAutoInvoice": "New Self-Bill",
            "label.button.saveNewPassword": "Save New Password",
            "label.success.completeRegistration.completed": "Your password has been set successfully. You can now log in.",
            "label.error.completeRegistration.tokenExpired": "This registration link has expired. Please contact an administrator for a new one.",
            "label.error.completeRegistration.tokenInvalid": "This registration link is invalid or has already been used.",
            "label.error.completeRegistration.failed": "We couldn't complete your registration. Please try again later or contact support.",
            "label.title.completeRegistration": "Complete Your Registration",
            "label.subtitle.completeRegistration": "Welcome, {{username}}! Choose a password below to finish setting up your account and start using the Indie Energy platform.",
            "label.title.completeRegistrationError": "Registration Link Invalid",
            "label.completeRegistration.alreadyRegistered": "Already completed your registration? Log in",
            "label.completeRegistration.needHelp": "Need help? Contact our support team.",
            "label.message.validatingInvitation": "Validating your invitation…",
            "label.button.recoverPassword": "Send Password Recovery Email",
            "label.button.recoverRegistration": "Send Registration Recovery Email",
            "label.button.agreeTermsAndConditions": "I Confirm I Have Read and Accept the Terms and Conditions",
            "label.button.processForecasts": "Process Forecasts",
            "label.button.newLocation": "New Location",
            "label.button.process": "Process",
            "label.button.back": "Back",
            "label.button.save": "Save",
            "label.button.assign": "Assign",
            "label.button.savePassword": "Save Password",
            "label.button.yes": "Yes",
            "label.button.no": "No",
            "label.button.stay": "Stay",
            "label.button.doNotStay": "Proceed",
            "label.button.update": "Update",
            "label.button.upload": "Upload Document",
            "label.button.remove": "Remove",
            "label.button.search": "Search",
            "label.button.previous": "Previous",
            "label.button.procuration": "Power of Attorney",
            "label.button.next": "Next",
            "label.button.newProductionUnit": "New Production Unit",
            "label.button.newLine": "New Line",
            "label.button.newEntity": "New Entity",
            "label.button.newMember": "New Member",
            "label.button.newProducer": "New Producer",
            "label.button.newContract": "New Contract",
            "label.button.newBilateralContract": "New Bilateral Contract",
            "label.button.approve": "Approve",
            "label.button.reprocess": "Reprocess",
            "label.button.cancel": "Cancel",
            "label.button.submit": "Submit",
            "label.button.export": "Export",
            "label.button.newInvoice": "New Document",
            "label.button.new": "New",
            "label.button.newUser": "New User",
            "label.button.signin": "Sign In",
            "label.button.register": "Register",
            "label.button.viewProducer": "View Producer",
            "label.button.expCertificate": "Operating License",
            "label.button.viewDetails": "View Details",
            "label.button.validateActivation": "Validate Contract Activation",
            "label.button.contract": "View Contract",
            "label.button.contracts": "Contracts",
            "label.button.download": "Download",
            "label.button.downloadBlankTemplate": "Download Template",
            "label.button.uploadNewTemplate": "Upload New Template",
            "label.button.uploadConfiguration": "Upload Configuration",
            "label.button.newAggregator": "New Aggregator",
            "label.button.close": "Close",
            "label.button.createNewB021PProcess": "New REN Registration Process",
            "label.button.saveInvoicingData": "Update Invoicing Data",
            "label.button.createPhysicalUnit": "Create Physical Unit",
            "label.button.createOfferingUnit": "Create Offer Unit",
            "label.button.createOfferingArea": "Create Offer Area",
            "label.button.copy": "Copy",
            "label.button.submitPhysicalUnitSchedule": "Submit Allocation",
            "label.button.submitTechnicalConstraint": "Submit Resolution",
            "label.button.testEmail": "Testar Envio",
            "label.text.createTechRestOffersDialod.subtitle": "Select the Programming Units you want to use to create new automatic offer.",
            // Labels Forms
            "label.text.twoFactorAuth.enabled": "Two-factor authentication is enabled on your account.",
            "label.text.twoFactorAuth.notEnabled": "Two-factor authentication is not enabled on your account.",
            "label.text.noProductionDeliveryPointNotRequired": "The selected installation does not have a Production CPE. This information is not required.",
            "label.text.productTaxesNotRequired": "The selected product does not allow the application of taxes.",
            "label.text.2FAAuthConfig.scanQR": "Please scan the QR code below with the authentication app on your phone.",
            "label.form.userName": "User",
            "label.form.request": "Request",
            "label.form.response": "Response",
            "label.form.fixedPriceTariff": "Fixed Tariff (€/MWh)",
            "label.form.contract": "Contract",
            "label.form.energyFee": "Variable Energy Term",
            "label.form.erpId": "ERP ID",
            "label.form.powerFee": "Fixed Term",
            "label.form.value": "Value",
            "label.form.fee": "Tariff",
            "label.table.header.configurationStatus": "Configuration Status",
            "label.table.header.configuredAt": "Configured At",
            "label.table.header.populatedTemplate": "Populated Template",
            "label.table.header.uploadNewTemplate": "Upload New Template",
            "label.table.value.configured": "Configured",
            "label.table.value.notConfigured": "Not Configured",
            "message.priceSettings.noConfigurations": "No configurations found for the selected market family.",
            "label.mfrr.defaultConfig.uploadDialogTitle": "Upload mFRR Default Configuration",
            "label.mfrr.defaultConfig.selectTemplateFile": "Select Template File (.xlsx)",
            "label.mfrr.defaultConfig.verifyTemplate": "Verify Template",
            "label.mfrr.defaultConfig.version": "Version",
            "label.mfrr.flowDirection.U": "Up (A subir)",
            "label.mfrr.flowDirection.D": "Down (A baixar)",
            "label.mfrr.activationType.P": "Programmed",
            "label.mfrr.activationType.D": "Direct",
            "label.mfrr.offerType.SD": "Simple Divisible",
            "label.mfrr.offerType.SI": "Simple Indivisible",
            "label.table.header.flowDirection": "Flow Direction",
            "label.table.header.activationType": "Activation Type",
            "label.table.header.offerType": "Offer Type",
            "message.mfrr.defaultConfig.verifyIdle": "Select a file and run template verification.",
            "message.mfrr.defaultConfig.verifyRunning": "Verifying template...",
            "message.mfrr.defaultConfig.verifySuccess": "Template verified successfully.",
            "message.mfrr.defaultConfig.verifyFailedWithIssues": "The template has validation issues and cannot be uploaded. Please review the issues below.",
            "message.mfrr.defaultConfig.uploadWarning": "After confirming, the new configuration will replace the current active configuration.",
            "message.mfrr.defaultConfig.uploadDescription": "Upload an Excel file with the default bid parameters for this physical unit.",
            "message.mfrr.defaultConfig.noActiveConfig": "No active configuration found. Upload a template to configure default bids.",
            "message.mfrr.defaultConfig.noRows": "No configuration rows found.",
            "api.error.mfrr.bid.notEditable": "This bid can no longer be edited.",
            "api.error.mfrr.defaultConfig.invalidTemplateFile": "Invalid template file. Please upload a valid .xlsx file.",
            "api.error.mfrr.defaultConfig.emptyTemplate": "The template file is empty.",
            "api.error.mfrr.defaultConfig.missingPeriods": "All 100 periods must be present for each flow direction.",
            "api.error.mfrr.defaultConfig.duplicatePeriodDirection": "Duplicate (period, flow direction) combination detected.",
            "api.error.mfrr.defaultConfig.invalidPeriod": "Invalid period value. Must be an integer between 1 and 100.",
            "api.error.mfrr.defaultConfig.invalidFlowDirection": "Invalid flow direction. Use 'A subir' (U) or 'A baixar' (D).",
            "api.error.mfrr.defaultConfig.invalidActivationType": "Invalid activation type. Use 'Programada' (P) or 'Direta' (D).",
            "api.error.mfrr.defaultConfig.invalidOfferType": "Invalid offer type. Use 'Simples divisível' (SD) or 'Simples indivisível' (SI).",
            "api.error.mfrr.defaultConfig.priceOutOfRange": "Price out of range. Must be between -9999.99 and 9999.99 €/MWh.",
            "api.error.mfrr.defaultConfig.invalidPrice": "Invalid price value.",
            "api.error.mfrr.defaultConfig.missingFields": "Missing required fields.",
            "api.error.mfrr.defaultConfig.physicalUnitNotFound": "Physical unit not found.",
            "api.error.mfrr.defaultConfig.noDocumentAttached": "No document attached to this configuration.",
            "api.error.unavailability.missingGeneratorGroupCode": "This physical unit does not have a GGS generator group code configured. Please set the generator group code before submitting.",
            "label.form.fee.power": "Fixed Term",
            "label.form.fee.energy": "Variable Term",
            "label.form.energy": "Energy",
            "label.form.energyTransaction": "Transacted Energy",
            "label.form.duration": "Duration (Months)",
            "label.form.manualInput": "Fill Manually",
            "label.form.noProducer": "No Producer Member",
            "label.form.managingEntity": "Managing Entity",
            "label.form.installationOwner": "Installation Owner?",
            "label.form.sameAsConsumer": "Use Consumer Member Data?",
            "label.form.uploadPhoto": "Upload Photo",
            "label.form.delete": "Delete",
            "label.form.type": "Type",
            "label.form.billingPeriod": "Billing Cycle",
            "label.form.classification": "Classification",
            "label.form.ownerName": "Owner Name",
            "label.form.ownerNIF": "Owner NIF",
            "label.form.storagePowerKWh": "Storage Power (kWh)",
            "label.form.storageCapacityKWh": "Storage Capacity (kWh)",
            "label.form.storageCapacityKWhTotal": "Total Storage Capacity (kWh)",
            "label.form.hasEvcp": "Has EV Charging Point?",
            "label.form.dgegid": "DGEG ID",
            "label.table.header.dgegID": "DGEG ID",
            "label.table.header.puClassification": "Classification",
            "label.form.permanentCertificate": "Permanent Certificate Code",
            "label.form.omieReferenceId": "OMIE Code",
            "label.form.omieReferenceId.helper": "This code is assigned by OMIE to the aggregator for market participation. It will be used by the Indie Energy platform for processing data related to market participation.",
            "label.form.ordReferenceId": "ORT Code",
            "label.form.ordReferenceId.helper": "This code is assigned by REN to the aggregator. It will be used by the Indie Energy platform for integrations with ORD.",
            "label.form.2FACode": "Authentication Code",
            "label.form.marketAgentCompanies": "Company",
            "label.form.contractPowerFee": "Power Fee (€/MW/Day)",
            "label.form.contracts": "Contracts",
            "label.form.id": "ID",
            "label.form.uploadedBy": "Uploaded by",
            "label.form.uploadedDate": "Upload Date",
            "label.form.renewContract": "Renew Contract",
            "label.form.code": "Code",
            "label.form.fiscalEntity": "Invoicing Fiscal Entity",
            "label.form.marketSession": "Program",
            "label.form.programmeDate": "Program Date",
            "label.form.siteid": "Site ID",
            "label.form.maxInstances": "Maximum Number of Instances",
            "label.form.processingResult": "Result",
            "label.form.singleService": "Single Act",
            "label.form.autoinvoicing": "Self-Billing",
            "label.form.hasAutoInvoicingAgreement": "Has Self-Billing Agreement?",
            "label.form.isAutoInvoicingAgreement": "Self-Billing Regime?",
            "label.title.receivingInformation": "Receiving Information",
            "label.title.paymentsInformation": "Payment Information",
            "label.form.atcud": "ATCUD",
            "label.form.hasOpenActivity": "Open Activity",
            "label.form.hasNegativePrices": "Has Negative Prices?",
            "label.form.contractPriceDiscount": "Commercial Discount (%)",
            "label.form.quarterHour": "Quarter-Hourly",
            "label.form.hourly": "Hourly",
            "label.form.energy": "Energy",
            "label.form.endDate": "End Date",
            "label.form.search": "Search",
            "label.form.selectValue": "Select a value from the list.",
            "label.form.sessionNumber": "Session Number",
            "label.form.programmeStartDate": "Horizon Start Date",
            "label.form.programmeEndDate": "Horizon End Date",
            "label.form.hourlyOption": "Hourly Option",
            "label.form.certifiedPower": "Certified Power (kW)",
            "label.form.estAnnualConsumption": "Estimated Annual Consumption",
            "label.form.title": "Title",
            "label.form.tensionLevel": "Voltage Level",
            "label.tensionLevel.BT": "Low Voltage",
            "label.tensionLevel.MT": "Medium Voltage",
            "label.tensionLevel.AT": "High Voltage",
            "label.tensionLevel.MAT": "Very High Voltage",
            "label.form.deliveryPoint": "CPE",
            "label.reportParameter.allDeliveryPoints": "All Delivery Points",
            "label.reportParameter.deliveryPoints": "Delivery Points",
            "label.form.zipCode": "Postal Code",
            "label.form.country": "Country",
            "label.form.regulatorReferenceNumber": "DGEG Registration Number",
            "label.form.registrationNumber": "Registration No.",
            "label.form.recordNumber": "Record No.",
            "label.form.recordReferenceNumber": "Record Reference Number",
            "label.form.referenceDate": "Reference Date",
            "label.form.referenceStartDate": "Billing Period Start Date",
            "label.form.referenceEndDate": "Billing Period End Date",
            "label.form.productionCompanyName": "Producer Name",
            "label.form.productionDeliveryPoint": "Production CPE",
            "label.form.productionType": "Production Type",
            "label.form.processCode": "Process Code",
            "label.form.oldSignDate": "Current Signature Date",
            "label.form.oldActDate": "Current Activation Date",
            "label.form.newSignDate": "New Signature Date",
            "label.form.newActDate": "New Activation Date",
            "label.form.newEndDate": "New Termination Date",
            "label.form.newTermDate": "New Notice Date",
            "label.form.omieSolicitude": "OMIE Solicitude Code",
            "label.form.consumptionDeliveryPoint": "Consumption CPE",
            "label.form.injectsEnergy": "Injects Energy into the Grid?",
            "label.form.installationType": "Installation Type",
            "label.form.installedPowerKWp": "Installed Power (kWp)",
            "label.form.installedPowerKWh": "Installed Power (kW)",
            "label.form.installedPowerKva": "Installed Power (kVA)",
            "label.form.primaryRenewableSource": "Primary Renewable Source",
            "label.form.technologyType": "Technology Type Used",
            "label.form.systemNominalPower": "System Nominal Power (kWp)",
            "label.form.numberOfPanels": "Number of Panels",
            "label.form.panelPower": "Panel Power (Wp)",
            "label.form.panelManufacturer": "Panel Manufacturer",
            "label.form.panelModel": "Panel Model",
            "label.form.connectedPowerKWh": "Connection Power (kW)",
            "label.form.injectionPower": "Injection Power into RESP (kW)",
            "label.form.connectedPowerKva": "Connection Power (kVA)",
            "label.form.generatorPowerKWh": "Generator Power (kW)",
            "label.form.generatorGroupCode": "GGS Generator Group Code",
            "label.form.numberOfInverters": "Number of Inverters",
            "label.form.invertersPower": "Inverter Power (kW)",
            "label.form.inverterManufacturer": "Inverter Manufacturer(s)",
            "label.form.inverterModel": "Inverter Model",
            "label.form.connectedToNetwork": "Installation Connected to RESP?",
            "label.form.expStartDate": "Start of Operation Date",
            "label.form.surfaceAreaAvailable": "Available Surface Area",
            "label.form.surfaceAreaCovered": "Surface Area Covered by UPAC",
            "label.form.surfaceType": "Surface Type",
            "label.form.phone": "Phone Number",
            "label.form.short.phone": "Phone",
            "label.form.physicalUnitClassification": "Installation Classification",
            "label.form.email": "Email",
            "label.form.name": "Name",
            "label.form.firstName": "First Name",
            "label.form.lastName": "Last Name",
            "label.form.agentName": "Agent Name",
            "label.form.contractStatus": "Status",
            "label.form.agentEntityName": "Agent Entity Name",
            "label.form.address": "Address",
            "label.form.respPartyName": "Responsible Name",
            "label.form.respPartyEmail": "Responsible Email",
            "label.form.respPartyPhone": "Responsible Phone",
            "label.form.aggregator": "Aggregator",
            "label.form.city": "City",
            "label.form.fiscalNumber": "Tax Number",
            "label.form.NIF": "NIF",
            "label.form.isClient": "Is Client?",
            "label.form.isAgent": "Is Agent?",
            "label.form.isManagingEntity": "Is EGAC?",
            "label.form.isSupplier": "Is Supplier?",
            "label.form.erpSupplierID": "ERP Supplier ID",
            "label.form.erpCompanyID": "ERP Company ID",
            "label.form.erpClientID": "ERP Client ID",
            "label.form.community": "Community",
            "label.form.companyName": "Company / Corporate Name",
            "label.form.status": "Status",
            "label.form.version": "Version",
            "label.form.add": "Create",
            "label.form.active": "Active",
            "label.form.startDate": "Start Date",
            "label.form.purchasingEntityFiscalNumber": "Purchasing Entity Fiscal Number",
            "label.form.purchasingEntityName": "Purchasing Entity Name",
            "label.form.sellingEntityFiscalNumber": "Selling Entity Fiscal Number",
            "label.form.sellingEntityName": "Selling Entity Name",
            "label.form.maxContractEnergy": "Maximum Contract Energy (MW)",
            "label.form.initialCommunityBuyingPrice": "Initial Community Purchase Price",
            "label.form.initialNetworkBuyingPrice": "Initial Network Purchase Price",
            "label.form.initialSellingPrice": "Initial Selling Price",
            "label.form.billingPeriod": "Billing Cycle",
            "label.form.invoiceNumber": "# Invoice",
            "label.form.orderDate": "Invoice Date",
            "label.form.billTo": "Invoice To",
            "label.form.billFrom": "Invoice From",
            "label.form.itemName": "Item",
            "label.form.itemQuantity": "Quantity",
            "label.form.unitPrice": "Unit Price",
            "label.form.useProducerData": "Use Producer Data",
            "label.form.price": "Price",
            "label.form.period": "Period",
            "label.form.activationType": "Activation Type",
            "label.form.divisible": "Divisibility",
            "label.form.flowDirection": "Direction",
            "label.form.powerStrategy": "Power Strategy",
            "label.form.priceStrategy": "Price Strategy",
            "label.form.fixedPrice": "Fixed Price",
            "label.form.activeEnergy": "Active Energy",
            "label.form.amount": "Amount",
            "label.form.total": "Total",
            "label.form.nextInvoiceDate": "Next Invoice Date",
            "label.form.currencyCode": "Currency",
            "label.form.power": "Installed Power",
            "label.form.storage": "Storage",
            "label.form.prosumers": "Producers",
            "label.form.consumers": "Consumers",
            "label.form.members": "Members",
            "label.form.findCommunity": "Search Community",
            "label.form.invoiceIBAN": "Invoicing IBAN",
            "label.form.paymentIBAN": "Receiving IBAN",
            "label.form.paymentMethod": "Payment Method",
            "label.form.paymentTerms": "Payment Terms",
            "label.form.receiptMethod": "Receipt Method",
            "label.form.receiptTerms": "Receipt Terms",
            "label.form.cae": "CAE",
            "label.form.username": "User",
            "label.form.password": "Password",
            "label.form.rememberMe": "Remember Access",
            "label.form.forgotPassword": "Forgot your Password? Request a new one here",
            "label.form.eInvoiceEmail": "E-Invoice Email",
            "label.form.upload": "Upload Documents",
            "label.form.networkPrice": "Energy in RESP",
            "label.form.invoiceNetworkCosts": "Invoice Network Access Costs",
            "label.form.selfConsPrice": "Self-Consumption",
            "label.form.sellingPrice": "Surplus Sale",
            "label.form.locality": "Locality",
            "label.form.district": "District",
            "label.form.longitude": "Longitude (°)",
            "label.form.latitude": "Latitude (°)",
            "label.form.description": "Description",
            "label.form.documentType": "Document Type",
            "label.form.documentNumber": "Document Code",
            "label.form.doorNumber": "Door",
            "label.form.apartmentNumber": "Apartment",
            "label.form.stay": "Stay",
            "label.form.goToProducer": "Go To Producer",
            "label.form.gcsCode": "Physical Unit Code",
            "label.form.product": "Product",
            "label.form.planType": "Plan Type",
            "label.form.plan": "Plan",
            "label.form.energyVariableTerm": "Variable Energy Term",
            "label.form.planCommission": "Management Fee (€/MWh)",
            "label.form.fixPlanPrice": "Price (€/MWh)",
            "label.form.indexPlanPrcntg": "Management - Variable Term",
            "label.form.signatureDate": "Signature Date",
            "label.form.isAutoTermination": "Contract termination on contract end date?",
            "label.form.contractTermntLeadDays": "Contract Termination (Days)",
            "label.form.contractDuration": "Contract Duration (Months)",
            "label.form.contractTermntDate": "Contract Notice Date",
            "label.form.contractActDate": "Contract Activation Date",
            "label.form.contractEndDate": "Contract End Date",
            "label.form.freeTaxes": "VAT Exempt",
            "label.form.clearedFinances": "Finances Regularized",
            "label.form.leadDays": "Days",
            "label.form.internalSalesAgent": "Internal Sales Agent Name",
            "label.form.externalPartnerName": "Partner Company",
            "label.form.producer": "Producer",
            "label.form.activationDate": "Activation Date",
            "label.form.meter": "Meter",
            "label.form.marketAgent": "Market Agent",
            "label.form.marketOfferingUnit": "Offering Unit",
            "label.form.isAggregation": "Is Aggregation?",
            "label.form.daily": "Daily",
            "label.form.dateFrom": "From",
            "label.form.dateTo": "To",
            "label.form.weekly": "Weekly",
            "label.form.monthly": "Monthly",
            "label.form.yearly": "Yearly",
            "label.form.viewBy": "View By",
            "label.form.yes": "Yes",
            "label.form.no": "No",
            "label.form.all": "All",
            "label.form.county": "County",
            "label.form.parish": "Parish",
            "label.form.newPassword": "New Password",
            "label.form.repeatNewPassword": "Repeat Password",
            "label.form.forecastTypeInstance": "Forecast",
            "label.form.taxRegime": "Tax Regime",
            "label.form.fiscalSpace": "Fiscal Space",
            "label.form.communityType": "Community Type",
            "label.form.sharingType": "Sharing Mode",
            "label.form.uploadDocuments": "Upload Documents",
            "label.form.contactSameAsProducer": "Producer Contact Data?",
            "label.form.receiptSameAsProducer": "Producer Receipt Data?",
            "label.form.physicalUnitAddressSameAsProducer": "Installation Address Same as Producer?",
            "label.form.tariffModelType": "Tariff Model Type",
            "label.form.businessType": "Business Type",
            "label.form.autoRenew": "Automatic Renewal",
            "label.form.backofficeEmail": "Financial Email",
            "label.form.supportEmail": "Contact Email",
            "label.form.offerUnitType": "Offering Unit Type",
            "label.form.physicalUnitType": "Physical Unit Type",
            "label.form.offerUnit": "Offering Unit",
            "label.form.assignedDate": "Assigned Date",
            "label.form.networkArea": "Network Area",
            "label.form.offeringType": "Offering Type",
            "offering_type.venda": "Sale",
            "offering_type.compra": "Purchase",
            "label.form.systemServiceMarket": "System Services Market",
            "label.form.offerAreaType": "Offer Area Type",
            "label.form.offerArea": "Offer Area Code",
            "label.form.optimizeSolution": "Optimization Solution",
            "label.form.divisibleOffer": "Indivisible Offer",
            "label.form.ddIBAN": "IBAN",
            "label.form.ddMandateReference": "Direct Debit Authorization (DDA)",
            "label.form.ddMaxValue": "Maximum Value (€)",
            "label.form.sepaCreditorID": "SEPA Creditor ID",
            "label.title.generalInformation": "General Information",
            "label.title.physicalUnitConfiguration": "Physical Unit Configuration",
            "label.title.systemServicesMarkets": "System Services Markets",
            "label.title.optimizationAndForecasts": "Optimization and Forecasts",
            "label.title.deleteRecord": "Delete Record",
            "label.title.newBilateralContract": "New Bilateral Contract",
            "label.title.entityInformation": "Entity Information",
            "label.title.purchasingEntityInformation": "Purchasing Entity",
            "label.title.sellingEntityInformation": "Selling Entity",
            "label.title.marketInformation": "Market Information",
            "label.title.contractIdentity": "Contract Identity",
            "label.title.confirmationStep": "Confirmation",
            "label.bilateralContract.isActive": "Active",
            "label.bilateralContract.isInactive": "Inactive (no contract code)",
            "label.text.confirmDeleteRecord": "Are you sure you want to delete this record?",
            "label.table.down": "Down",
            "label.table.up": "Up",
            "label.table.price": "Price",
            // uom
            "label.uom.kw": "kW",
            "label.uom.mw": "MW",
            "label.uom.kwh": "kWh",
            "label.uom.mwh": "MWh",
            // Labels Side Menus
            "label.menu.inactivate": "Deactivate",
            "label.menu.delete": "Remove",
            "label.menu.copy": "Copy",
            "label.menu.tariffsPlans": "Tariff Plans",
            "label.menu.clients": "Clients",
            "label.menu.installationMembers": "Installation Members",
            "label.menu.powertrading": "Powertrading",
            "label.menu.communities": "Communities",
            "label.menu.energy": "Energy",
            "label.menu.tariffModels": "Models",
            "label.menu.entities": "Entities",
            "label.menu.fiscalAuthority": "Tax Authority",
            "label.menu.userSettings": "User Settings",
            "label.menu.energyAgent": "Agent",
            "label.menu.sendRegistrationEmail": "Send Registration Email",
            "label.menu.sendPasswordResetEmail": "Send Password Reset Email",
            "label.menu.energyAgents": "Agents",
            "label.menu.settlements": "Settlements",
            "label.menu.dataUpload": "Data Upload",
            "label.menu.userDetails": "User Profile",
            "label.menu.invoicingDetails": "Receipt Information",
            "label.menu.voidDocument": "Void Document",
            "label.menu.newDocument": "New Financial Document",
            "label.menu.marketAgent": "Market Agent",
            "label.menu.viewContract": "View Contract",
            "label.menu.clientArea": "Installations",
            "label.menu.energyMarkets": "Markets",
            "label.menu.dailyMarkets": "Day-ahead market",
            "label.menu.intraDayMarkets": "Intraday market",
            "label.menu.integrations": "Integrations",
            "label.menu.attributes": "Attributes",
            "label.menu.powertradingDocuments": "Invoicing",
            "label.menu.locations": "Locations",
            "label.menu.viewClient": "View Client",
            "label.menu.invoicingClients": "Clients",
            "label.menu.details": "Details",
            "label.menu.addressInfo": "Address Details",
            "label.menu.addCommunity": "New Community",
            "label.menu.aggregator": "Aggregator",
            "label.menu.techInformation": "Technical Information",
            "label.menu.productionUnitDetails": "Details",
            "label.menu.registrationInfo": "Registration Data",
            "label.menu.solarPanels": "Solar Panels",
            "label.menu.inverters": "Inverters",
            "label.menu.identity": "Identification",
            "label.menu.others": "Others",
            "label.menu.profile": "Profile",
            "label.menu.additional": "Others",
            "label.menu.consumptionInstallation": "Consumption Installation",
            "label.menu.viewCommunity": "View Community",
            "label.menu.productionUnit": "Production Unit",
            "label.menu.storageUnit": "Storage Unit",
            "label.menu.invoicing": "Invoicing",
            "label.menu.production": "Production",
            "label.menu.consumption": "Consumption",
            "label.menu.sales": "Invoicing",
            "label.menu.documents": "Documents",
            "label.menu.members": "Members",
            "label.menu.invoices": "Invoices",
            "label.menu.kpis": "KPIs",
            "label.menu.payments": "Payments",
            "label.menu.paymentsAndReceipts": "Payments and Receipts",
            "label.menu.networkAccess": "Network Access",
            "label.menu.surplus": "Surplus",
            "label.menu.dashboards": "KPIs",
            "label.menu.management": "Management",
            "label.menu.marketAgents": "Market Agents",
            "label.menu.marketUnits": "Physical Units",
            "label.menu.offerUnits": "Offering Units",
            "label.menu.offerAreas": "Offer Areas",
            "label.menu.powerManagement": "Energy Management",
            "label.menu.forecastTypes": "Forecast Types",
            "label.menu.markets": "Markets",
            "label.menu.home": "Home",
            "label.menu.purchasing": "Energy Purchase",
            "label.menu.memberArea": "Member Area",
            "label.menu.promotorArea": "Promoter Area",
            "label.menu.egacArea": "EGAC Area",
            "label.menu.myCommunities": "My Communities",
            "label.menu.myData": "Account",
            "label.menu.myAccount": "My Account",
            "label.menu.myInvoices": "My Invoices",
            "label.menu.myDocuments": "My Documents",
            "label.menu.energyPrices": "Energy Prices",
            "label.menu.energySales": "Energy Sales",
            "label.menu.energyPurchases": "Energy Purchase",
            "label.menu.salesInvoices": "Energy Sales",
            "label.menu.purchasesInvoices": "Energy Purchase",
            "label.menu.invoicingInformation": "Data for Receipts / Payments",
            "label.menu.egac": "Managing Entity (EGAC)",
            "label.menu.community": "Community",
            "label.menu.receiptsPayments": "Receipts and Payments",
            "label.menu.agentCosts": "Management Services",
            "label.menu.balance": "Current Account",
            "label.menu.aggregation": "Powertrading",
            "label.menu.communication": "Communication",
            "label.text.agentLogoNote": "This image will be used in emails sent to clients when using the agent domain.",
            "label.title.emailConfiguration": "Email Sending Configuration",
            "label.form.senderType": "Sender Type",
            "label.option.senderType.indie": "Indie Energy Service",
            "label.option.senderType.smtp": "SMTP Server",
            "label.text.agentEmailLogoNote": "Upload a logo to appear in emails (250x100 px).",
            "error.forms.invalidHexColor": "Invalid Hex Color Code (e.g. #FF0000)",
            "label.form.primaryColor": "Primary Branding Color",
            "label.title.smtpSettings": "SMTP Server Settings",
            "label.form.smtpHost": "Unencrypted SMTP Host",
            "label.form.smtpPort": "Unencrypted SMTP Port",
            "label.form.smtpUser": "SMTP User",
            "label.form.smtpPassword": "SMTP Password",
            "label.form.smtpSenderEmail": "Sender Email",
            "label.form.smtpSenderName": "Sender Name",
            "label.form.smtpUseTls": "Use TLS",
            "label.form.smtpUseSsl": "Use SSL",
            "label.menu.aggregators": "Aggregators",
            "label.menu.producers": "Producers",
            "label.menu.contracts": "Contracts",
            "label.menu.physicalUnits": "Installations",
            "label.menu.invoicingClient": "Clients",
            "label.menu.agents": "Sales Agents",
            "label.menu.contact": "Contact",
            "label.menu.products": "Products and Services",
            "label.menu.physicalunit": "Installation",
            "label.menu.receipts": "Receipts",
            "label.menu.agent": "Sales Agent",
            "label.menu.agentAdmin": "Agent Administration",
            "label.menu.saftFiles": "SAF-T Files",
            "label.menu.communications": "Communications",
            "label.menu.installationRegistration": "Installation Registration",
            "label.menu.viewTable": "View Table",
            "label.menu.viewChart": "View Chart",
            "label.menu.termsAndConditions": "Terms and Conditions",
            "label.menu.communitiesInvoicing": "Communities Invoicing",
            "label.menu.addCommunityInvoice": "Import Network Use Invoices",
            "label.menu.networkUse": "Network Use",
            "label.menu.networkUseInvoices": "Import Network Use Invoices",
            "label.menu.communitiesTariffPlans": "Community Tariff Plans",
            "label.menu.addCommunityTariffPlan": "New Tariff Plan",
            "label.menu.changeInstallationOwner": "Transfer Installation Ownership",
            "label.menu.systemServiceMarket": "System Services Market",
            "label.menu.afrrDailyBand": "AFRR Daily Band",
            "label.menu.security": "Security",
            "label.menu.faqs": "FAQs",
            "label.menu.personalData": "Personal Data",
            "label.menu.language": "Language",
            "label.menu.fiscalData": "Fiscal and Contact Data",
            "label.menu.receiptMethods": "Receipt Methods",
            "label.menu.billingAgreements": "Self-Billing Agreements",
            // Page Titles
            "label.page.producerContracts": "Producer Contracts",
            "label.page.newContract": "New Contract",
            "label.page.forecastTypes": "Forecast Types",
            "label.page.viewForecastType": "View Forecast Type",
            "label.page.addForecastTypeInstance": "New Forecast",
            // Labels Table Headers
            "lable.table.footer.rowsPerPage": "Rows per Page",
            "lable.table.footer.of": "of",
            "label.table.header.relatedDeliverypoint": "Related Installation",
            "label.table.header.relatedType": "Member Type",
            "label.table.header.consumptionDeliverypoint": "Consumption CPE",
            "label.table.header.connectionPower": "Connection Power (kW)",
            "label.table.header.productionDeliverypoint": "Production CPE",
            "label.table.header.zipCode": "Postal Code",
            "label.table.header.locality": "County",
            "label.table.header.agent": "Agent",
            "label.table.header.address": "Address",
            "label.table.header.atcud": "ATCUD",
            "label.table.header.reportedSerie": "Reported Series",
            "label.table.header.autoInvoicing": "Self-Billing",
            "label.table.header.fixPriceValue": "Management - Fixed Term",
            "label.table.header.powerFee": "Power Fee",
            "label.table.header.fiscalRegime": "Tax Regime",
            "label.table.header.community": "Community",
            "label.table.header.communityType": "Community Type",
            "label.table.header.communityNumber": "Community Code",
            "label.table.header.totalMembers": "Number of Members",
            "label.table.header.totalCertifiedPower": "Certified Power of IC (kW)",
            "label.table.header.totalProductionInstallations": "Number of UPAC(s)",
            "label.table.header.totalConnectionPower": "Connection Power (kW)",
            "label.table.header.totalStoragePower": "Storage Power (kW)",
            "label.table.header.totalStorageCapacity": "Storage Capacity (kWh)",
            "label.table.header.respName": "Responsible Name",
            "label.table.header.agentNIF": "Agent NIPC",
            "label.table.header.registered": "Registered?",
            "label.table.header.hasIndieAccount": "Has Indie Account?",
            "label.table.header.clientName": "Client Name",
            "label.table.header.clientFiscalNumber": "Client Tax Number",
            "label.table.header.phone": "Phone",
            "label.table.header.email": "Email",
            "label.table.header.period": "Period",
            "label.table.header.validation": "Validation",
            "label.table.header.periodNumber": "Period No.",
            "label.table.header.periodCode": "Period Code",
            "label.table.header.timestamp": "Timestamp",
            "label.table.header.totalPowerUp": "Total Up (MW)",
            "label.table.header.totalPowerDown": "Total Down (MW)",
            "label.table.header.powerUp": "Up (MW)",
            "label.table.header.powerDown": "Down (MW)",
            "label.table.header.quarter": "Quarter-Hour Period",
            "label.table.header.bandUpNeedMw": "aFRR Band Up Need (MW)",
            "label.table.header.bandDownNeedMw": "aFRR Band Down Need (MW)",
            "label.table.header.bandTotalNeedMw": "Total Band (MW)",
            "label.table.header.bandMinimumMw": "Min. Band (MW)",
            "label.table.header.offerUp": "Offer Up (MW)",
            "label.table.header.offerDown": "Offer Down (MW)",
            "label.table.header.priceUp": "Price Up (€/MW)",
            "label.table.header.priceDown": "Price Down (€/MW)",
            "label.table.header.assignedBandUp": "Band Up (MW)",
            "label.table.header.assignedBandDown": "Band Down (MW)",
            "label.table.header.bandPriceUp": "Price Up (€/MW)",
            "label.table.header.bandPriceDown": "Price Down (€/MW)",
            "label.filter.assignedOnly": "Assigned",
            "label.view.grid": "Grid",
            "label.view.chart": "Chart",
            "label.table.header.reference": "Reference",
            "label.table.header.drop": "DR/OP",
            "label.table.header.receivingDate": "Receipt Date",
            "label.table.header.startDate": "Weekly Horizon Start",
            "label.table.header.endDate": "Weekly Horizon End",
            "label.table.header.energyTransaction": "Energy Transaction",
            "label.table.header.totalDeviationEnergy": "Total Deviation",
            "label.table.header.totalDeviationAmount": "Total Deviation (€)",
            "label.table.header.pdbf": "PDBF",
            "label.table.header.dayaheadOffer": "Day-ahead Offer",
            "label.table.header.pdbc": "PDBC",
            "label.table.header.cb": "CB",
            "label.table.header.technicalConstraints": "Technical Constraints",
            "label.table.header.pdvp": "PDVP",
            "label.table.header.intraday1Offer": "Intraday 1 Offer",
            "label.table.header.pibci1": "PIBCI 1",
            "label.table.header.pibca1": "PIBCA 1",
            "label.table.header.intraday2Offer": "Intraday 2 Offer",
            "label.table.header.pibci2": "PIBCI 2",
            "label.table.header.pibca2": "PIBCA 2",
            "label.table.header.intraday3Offer": "Intraday 3 Offer",
            "label.table.header.pibci3": "PIBCI 3",
            "label.table.header.pibca3": "PIBCA 3",
            "label.table.header.pdvd": "PDVD",
            "label.table.header.planType": "Model Type",
            "label.table.header.product": "Product",
            "label.table.header.transaction": "Transaction",
            "label.table.header.energy": "Energy",
            "label.table.header.plan": "Plan",
            "label.table.header.energyTariff": "Variable Energy Term",
            "label.table.header.fixedTerm": "Management Fixed Term",
            "label.table.header.variableTerm": "Management Variable Term",
            "label.table.header.plannedEnergy": "Final Position",
            "label.table.header.actualEnergy": "Verified Quantity",
            "label.table.header.deviationType": "Deviation",
            "label.table.header.deviationEnergy": "Deviation Quantity",
            "label.table.header.receiptDate": "Receipt Date",
            "label.table.header.horizon": "Horizon",
            "label.table.header.offerDate": "Offer Date",
            "label.table.header.offerCode": "Offer Code",
            "label.table.header.offerUnit": "Offering Unit",
            "label.table.header.totalOffer": "Total Offer (MWh)",
            "label.table.header.programme": "Program",
            "label.table.header.time": "Time",
            "label.table.header.minAvailable": "Min Avail. (MW)",
            "label.table.header.maxAvailable": "Max Avail. (MW)",
            "label.table.header.afrrUp": "aFRR ↑",
            "label.table.header.afrrDown": "aFRR ↓",
            "label.table.header.code": "Code",
            "label.table.header.minPower": "Min. Power (MW)",
            "label.table.header.maxPower": "Max. Power (MW)",
            "label.table.header.partition": "Partition (MW)",
            "label.table.header.afrrBand": "aFRR",
            "label.table.header.minQty": "Min Qty (MW)",
            "label.table.header.maxQty": "Max Qty (MW)",
            "label.table.header.bidId": "Bid ID",
            "label.table.header.divisible": "Divisible",
            "label.table.header.regulation": "Regulation",
            "label.table.header.minQuantity": "Min Qty mFRR (MW)",
            "label.table.header.maxQuantity": "Max Qty mFRR (MW)",
            "label.table.header.offerPrice": "Offer Price (€/MWh)",
            "label.table.header.periodStartTime": "Period Start Time",
            "label.table.header.periodEndTime": "Period End Time",
            "label.table.header.dateTimeAccepted": "Accepted At",
            "label.table.header.activationStartTime": "Activation Start",
            "label.table.header.activationEndTime": "Activation End",
            "label.table.header.volumeAccepted": "Volume Accepted (MW)",
            "label.table.header.priceAccepted": "Price Accepted (€/MWh)",
            "label.table.header.mrid": "mRID",
            "label.table.header.session": "Session",
            "label.table.header.requestDate": "Request Date",
            "label.table.header.createdBy": "Created By",
            "label.table.header.actions": "Actions",
            "label.table.header.referenceStartDate": "Period Start",
            "label.table.header.referenceEndDate": "Period End",
            "label.table.header.price": "Energy Price (€/MW)",
            "label.table.header.physicalUnit": "Physical Unit",
            "label.table.header.forecastInstance": "Forecast",
            "label.table.header.regulatorRefID": "# DGEG",
            "label.table.header.companyName": "Company",
            "label.table.header.deliveryPoint": "CPE",
            "label.table.header.title": "Title",
            "label.table.header.billingPeriodStart": "Billing Period Start",
            "label.table.header.total": "Value excl. VAT (€)",
            "label.table.header.totalWTaxes": "Value incl. VAT (€)",
            "label.table.header.status": "Status",
            "label.table.header.situation": "Situation",
            "label.table.header.step": "Step",
            "label.table.header.description": "Description",
            "label.table.header.message": "Message",
            "label.table.header.fiscalNumber": "Tax Number",
            "label.table.header.issueDate": "Issue Date",
            "label.table.header.cpe": "CPE",
            "label.table.header.invoiceNumber": "Invoice No.",
            "label.table.header.dueDate": "Due Date",
            "label.table.header.name": "Name",
            "label.table.header.createdOn": "Created On",
            "label.table.header.contractActData": "Activation Date",
            "label.table.header.contractEndData": "Termination Date",
            "label.table.header.cycle": "Cycle",
            "label.table.header.documentNumber": "Document",
            "label.table.header.documentType": "Document Type",
            "label.table.header.details": "Details",
            "label.table.header.month": "Month",
            "label.table.header.surplus": "Surplus",
            "label.table.header.surplusEuro": "Surplus (€)",
            "label.table.header.corrections": "Corrections (€)",
            "label.table.header.pending": "Pending (€)",
            "label.table.header.paymentDate": "Payment Date",
            "label.table.header.settlementDocument": "Payment Note",
            "label.table.header.pendingSettlement": "Pending incl. VAT (€)",
            "label.table.header.omieReference": "OMIE Ref.",
            "label.table.header.orm": "REN Ref.",
            "label.table.header.processCode": "Process Code",
            "label.table.header.createDate": "Created On",
            "label.table.header.offeringUnit": "Offering Unit",
            "label.table.header.maxPowerMW": "Maximum Power (MW)",
            "label.table.header.maxSites": "Max. Number of Instances",
            "label.table.header.totalSites": "Total Instances",
            "label.table.header.installationType": "Installation Type",
            "label.table.header.installedPowerkWh": "Installed Power (kW)",
            "label.table.header.aggregation": "Is Aggregation?",
            "label.table.header.physicalUnitType": "Physical Unit Type",
            "label.table.header.systemServiceMarkets": "System Services Markets",
            "label.table.header.offeringArea": "Offer Area Code",
            "label.table.header.optimizationSolution": "Optimization Solution",
            "label.table.rowsPerPage": "Rows per Page",
            "label.table.header.dateTime": "Date / Time",
            "label.table.header.marketHour": "Market Hour",
            "label.table.header.marketSession": "Market Session",
            "label.table.header.dcop": "DC/OP",
            "label.table.header.totalValue": "Total (€)",
            "label.table.header.magnitude": "Energy (MWh)",
            "label.date": "Date",
            "label.table.header.date": "Date",
            "label.table.header.sessionName": "Program",
            "label.table.header.forecastValue": "Forecast (MWh)",
            "label.table.header.programmingValue": "Programming (MWh)",
            "label.table.header.productionValue": "Production (MWh)",
            "label.table.header.deviationsValue": "Deviations (MWh)",
            "label.table.market.session.MD": "Day-Ahead Market",
            "label.table.market.session.MI1": "Intraday Market: Session 1",
            "label.table.market.session.MI2": "Intraday Market: Session 2",
            "label.table.market.session.MI3": "Intraday Market: Session 3",
            "label.table.market.session.MI4": "Intraday Market: Session 4",
            "label.table.market.session.MI5": "Intraday Market: Session 5",
            "label.table.market.session.MI6": "Intraday Market: Session 6",
            "label.table.market.programme.pdbf": "PDBF",
            "label.table.market.programme.pdvd": "PDVD",
            "label.table.market.programme.pdbc": "PDBC",
            "label.table.market.programme.phf": "PHF",
            "label.table.market.programme.pibci": "PIBCI",
            "label.table.market.programme.pibca": "PIBCA",
            "label.table.market.programme.pibcac": "PIBCAC",
            "label.table.market.session.MC1": "Continuous Market: Session 1",
            "label.table.market.session.MC2": "Continuous Market: Session 2",
            "label.table.market.session.MC3": "Continuous Market: Session 3",
            "label.table.market.session.MC4": "Continuous Market: Session 4",
            "label.table.market.session.MC5": "Continuous Market: Session 5",
            "label.table.market.session.MC6": "Continuous Market: Session 6",
            "label.table.market.session.MC7": "Continuous Market: Session 7",
            "label.table.market.session.MC8": "Continuous Market: Session 8",
            "label.table.market.session.MC9": "Continuous Market: Session 9",
            "label.table.market.session.MC10": "Continuous Market: Session 10",
            "label.table.market.session.MC11": "Continuous Market: Session 11",
            "label.table.market.session.MC12": "Continuous Market: Session 12",
            "label.table.market.session.MC13": "Continuous Market: Session 13",
            "label.table.market.session.MC14": "Continuous Market: Session 14",
            "label.table.market.session.MC15": "Continuous Market: Session 15",
            "label.table.market.session.MC16": "Continuous Market: Session 16",
            "label.table.market.session.MC17": "Continuous Market: Session 17",
            "label.table.market.session.MC18": "Continuous Market: Session 18",
            "label.table.market.session.MC19": "Continuous Market: Session 19",
            "label.table.market.session.MC20": "Continuous Market: Session 20",
            "label.table.market.session.MC21": "Continuous Market: Session 21",
            "label.table.market.session.MC22": "Continuous Market: Session 22",
            "label.table.market.session.MC23": "Continuous Market: Session 23",
            "label.table.market.session.MC24": "Continuous Market: Session 24",
            "label.table.market.session.MC25": "Continuous Market: Session 25",
            "label.table.market.session.MC26": "Continuous Market: Session 26",
            "label.table.market.session.MC27": "Continuous Market: Session 27",
            "label.table.market.session.MC28": "Continuous Market: Session 28",
            "label.table.market.session.MC29": "Continuous Market: Session 29",
            "label.table.market.session.MC30": "Continuous Market: Session 30",
            "label.table.market.session.MC31": "Continuous Market: Session 31",
            "label.table.market.session.MC32": "Continuous Market: Session 32",
            "label.table.market.session.MC33": "Continuous Market: Session 33",
            "label.table.market.session.MC34": "Continuous Market: Session 34",
            "label.table.market.session.MC35": "Continuous Market: Session 35",
            "label.table.market.session.MC36": "Continuous Market: Session 36",
            "label.table.market.session.MC37": "Continuous Market: Session 37",
            "label.table.market.session.MC38": "Continuous Market: Session 38",
            "label.table.market.session.MC39": "Continuous Market: Session 39",
            "label.table.market.session.MC40": "Continuous Market: Session 40",
            "label.table.market.session.MC41": "Continuous Market: Session 41",
            "label.table.market.session.MC42": "Continuous Market: Session 42",
            "label.table.market.session.MC43": "Continuous Market: Session 43",
            "label.table.market.session.MC44": "Continuous Market: Session 44",
            "label.table.market.session.MC45": "Continuous Market: Session 45",
            "label.table.market.session.MC46": "Continuous Market: Session 46",
            "label.table.market.session.MC47": "Continuous Market: Session 47",
            "label.table.market.session.MC48": "Continuous Market: Session 48",
            "label.table.market.session.MC49": "Continuous Market: Session 49",
            "label.table.market.session.MC50": "Continuous Market: Session 50",
            "label.table.market.session.MC51": "Continuous Market: Session 51",
            "label.table.market.session.MC52": "Continuous Market: Session 52",
            "label.table.market.session.MC53": "Continuous Market: Session 53",
            "label.table.market.session.MC54": "Continuous Market: Session 54",
            "label.table.market.session.MC55": "Continuous Market: Session 55",
            "label.table.market.session.MC56": "Continuous Market: Session 56",
            "label.table.market.session.MC57": "Continuous Market: Session 57",
            "label.table.market.session.MC58": "Continuous Market: Session 58",
            "label.table.market.session.MC59": "Continuous Market: Session 59",
            "label.table.market.session.MC60": "Continuous Market: Session 60",
            "label.table.market.session.MC61": "Continuous Market: Session 61",
            "label.table.market.session.MC62": "Continuous Market: Session 62",
            "label.table.market.session.MC63": "Continuous Market: Session 63",
            "label.table.market.session.MC64": "Continuous Market: Session 64",
            "label.table.market.session.MC65": "Continuous Market: Session 65",
            "label.table.market.session.MC66": "Continuous Market: Session 66",
            "label.table.market.session.MC67": "Continuous Market: Session 67",
            "label.table.market.session.MC68": "Continuous Market: Session 68",
            "label.table.market.session.MC69": "Continuous Market: Session 69",
            "label.table.market.session.MC70": "Continuous Market: Session 70",
            "label.table.market.session.MC71": "Continuous Market: Session 71",
            "label.table.market.session.MC72": "Continuous Market: Session 72",
            "label.table.market.session.MC73": "Continuous Market: Session 73",
            "label.table.market.session.MC74": "Continuous Market: Session 74",
            "label.table.market.session.MC75": "Continuous Market: Session 75",
            "label.table.market.session.MC76": "Continuous Market: Session 76",
            "label.table.market.session.MC77": "Continuous Market: Session 77",
            "label.table.market.session.MC78": "Continuous Market: Session 78",
            "label.table.market.session.MC79": "Continuous Market: Session 79",
            "label.table.market.session.MC80": "Continuous Market: Session 80",
            "label.table.market.session.MC81": "Continuous Market: Session 81",
            "label.table.market.session.MC82": "Continuous Market: Session 82",
            "label.table.market.session.MC83": "Continuous Market: Session 83",
            "label.table.market.session.MC84": "Continuous Market: Session 84",
            "label.table.market.session.MC85": "Continuous Market: Session 85",
            "label.table.market.session.MC86": "Continuous Market: Session 86",
            "label.table.market.session.MC87": "Continuous Market: Session 87",
            "label.table.market.session.MC88": "Continuous Market: Session 88",
            "label.table.market.session.MC89": "Continuous Market: Session 89",
            "label.table.market.session.MC90": "Continuous Market: Session 90",
            "label.table.market.session.MC91": "Continuous Market: Session 91",
            "label.table.market.session.MC92": "Continuous Market: Session 92",
            "label.table.market.session.MC93": "Continuous Market: Session 93",
            "label.table.market.session.MC94": "Continuous Market: Session 94",
            "label.table.market.session.MC95": "Continuous Market: Session 95",
            "label.table.market.session.MC96": "Continuous Market: Session 96",
            "label.table.market.session.MC97": "Continuous Market: Session 97",
            "label.table.market.session.MC98": "Continuous Market: Session 98",
            "label.table.market.session.MC99": "Continuous Market: Session 99",
            "label.table.market.session.MC100": "Continuous Market: Session 100",
            "label.table.header.egacName": "EGAC",
            "label.table.header.communityName": "Community",
            "label.table.header.documentDate": "Document Date",
            "label.table.header.invoicingStartDate": "Start Date",
            "label.table.header.invoicingEndDate": "End Date",
            "label.table.header.valueExcludingIVA": "Value excl. VAT (€)",
            "label.table.header.valueWithIVA": "Value incl. VAT (€)",
            "label.table.header.averagePrice": "Average Price (€/kWh)",
            "label.table.header.selfConsumptionRESP": "Self-Consumption RESP (kWh)",
            "label.table.header.processId": "Invoice ID",
            "label.table.header.unit": "Unit",
            "label.table.header.quantity": "Quantity",
            "label.table.header.invoicePrice": "Price (€)",
            "label.table.header.iva": "VAT Rate (%)",
            // Labels KPIs
            "label.kpi.averagePrice": "Average Deviation Price",
            "label.kpi.totalQuantity": "Energy Deviations (MWh)",
            "label.kpi.totalSettlement": "Energy Deviations (€)",
            "label.kpi.group.excessDeviations": "Excess Deviations",
            "label.kpi.group.defectDeviations": "Defect Deviations",
            "label.kpi.group.balanceSummary": "Balance",
            "label.kpi.averageExcessPrice": "Average Excess Deviation Price",
            "label.kpi.averageDefectPrice": "Average Defect Deviation Price",
            "label.kpi.totalExcessQuantity": "Excess Energy Deviations (MWh)",
            "label.kpi.totalDefectQuantity": "Defect Energy Deviations (MWh)",
            "label.kpi.totalExcessSettlement": "Excess Energy Deviations (€)",
            "label.kpi.totalDefectSettlement": "Defect Energy Deviations (€)",
            "label.kpi.totalDeviationEnergy": "Balance (MWh)",
            "label.kpi.totalDeviationSettlement": "Balance (€)",
            "label.kpi.total": "Total",
            "label.kpi.salesTotal": "Total",
            "label.kpi.dueInvoices": "Overdue Invoices",
            "label.kpi.expiredInvoices": "Expired Invoices",
            "label.kpi.salesSurplus": "Surplus",
            "label.kpi.salesCommunity": "Community",
            "label.kpi.salesSelfConsumption": "Self-Consumption",
            "label.kpi.costsTotal": "Costs",
            "label.kpi.capacity": "Capacity",
            "label.kpi.internal": "Internal Network",
            "label.kpi.externalNetwork": "External Network",
            "label.kpi.prosumers": "Producers",
            "label.kpi.members": "Members",
            "label.kpi.storage": "Storage",
            "label.kpi.sharedEnergy": "Shared Energy",
            "label.kpi.surplus": "Surplus",
            "label.kpi.networkCosts": "Network Access",
            "label.kpi.managementCosts": "Management Costs",
            "label.kpi.selfConsumption": "Self-Consumption",
            "label.kpi.community": "Community",
            "label.kpi.supplier": "Supplier",
            "label.kpi.totalConsumption": "Total Consumption",
            "label.kpi.totalProduction": "Total Production",
            // I2 - Total Production in UPAC
            "label.kpi.i2": "Total Production",
            // I4 - Shared Energy by IC
            "label.kpi.i4": "Shared Energy",
            // I8 - Surplus Energy in IC
            "label.kpi.i8": "Surplus",
            // I9 - Consumption Supplied to IC by Supplier
            "label.kpi.i9": "Supplier",
            // I10 - Self-Consumption in IC
            "label.kpi.i10": "Self-Consumption",
            // I11 - Self-Consumption through RESP
            "label.kpi.i11": "Community",
            // I13 - Billing of Self-Consumption in IC
            "label.kpi.i13": "Self-Consumption (€)",
            // I14 - Billing of Self-Consumption through RESP in IC
            "label.kpi.i14": "Community (€)",
            // I17 - Billing of Self-Consumed Energy by EC
            "label.kpi.i17": "Community (€)",
            // I19 - Billing of Surplus Energy in EC
            "label.kpi.i19": "Surplus (€)",
            // I21 - Network Access Costs
            "label.kpi.i21": "Network Access Costs (€)",
            // I22 - Community Management Costs
            "label.kpi.i22": "Community Management Costs (€)",
            // I23 - Payment for Sold Energy
            "label.kpi.i23": "Energy Sale (€)",
            // I26 - Surplus Energy in EC shared by IC
            "label.kpi.i26": "Shared Energy via RESP (MWh) Surplus",

            // Chart Labels
            "label.chart.networkAccessConsumption": "Network Access Costs of Consumed Energy (€)",
            "label.chart.networkAccessShared": "Network Access Costs of Shared Energy (€)",
            "label.chart.surplus": "Surplus (€)",
            "label.chart.sales": "Energy Purchase (€)",
            "label.chart.payments": "Energy Sale (€)",
            "label.chart.receipts": "Receipts (€)",
            "label.chart.revenueCosts": "Shared Energy Billing and Costs (€)",
            "label.chart.title.programmingVsForecasts": "Forecast vs Programming Comparison (MWh)",
            "label.chart.title.receipts": "Receipts (€)",
            "label.chart.title.production": "Production (MWh)",
            "label.chart.series.forecasts": "Forecast (MWh)",
            "label.chart.series.programming": "Programming (MWh)",
            "label.chart.series.prices": "Price (€/MWh)",
            "label.chart.series.production": "Produced Energy (MWh)",
            "label.chart.series.deviations": "Deviations (MWh)",
            // Navigation Labels
            "label.nav.home": "Home",
            "label.nav.consumptionInstallations": "Consumption Installations",
            // Fixed Options
            "label.option.upac": "UPAC",
            "label.option.upacia": "UPAC+IA",
            "label.option.ia": "IA",
            "label.option.ip": "IP",
            "label.option.ic": "IC",
            // Deviation Types
            "label.deviation.defect": "Defect",
            "label.deviation.excess": "Excess",
            "label.drop.payment": "Payment",
            "label.drop.receipt": "Receipt",
            // Document Void Stepper
            "label.step.confirmDocument": "Confirm Document to Void",
            "label.step.warningConfirmation": "Confirm this is the document to void. After this action, it cannot be undone. A credit note will be created that fully voids this document.",
            // Document Create Stepper
            "label.step.confirmDocumentToCreate": "Confirm Document Data",
            "label.step.confirmDocumentDates": "Confirm Document Dates",
            // Registration Form
            "label.step.termsAndConditions": "Terms and Conditions",
            "label.step.userRegistration": "Registration Data",
            "label.step.userRegistrationComplete": "Registration Complete",
            "label.step.chooseReport": "Choose Report",
            "label.step.configureReport": "Configure Report",
            "label.step.confirmReport": "Confirm Report",
            // Create Autoinvoice Agreement
            "label.step.newAutoinvoiceAgreement.selectAgentEntity": "Select Entity",
            // New Community Form
            "label.step.newCommunity.communityDataStep": "Community Identification",
            "label.step.newCommunity.communityDataStep.subtitle": "Enter the community identification data at DGEG.",
            "label.step.newCommunity.communityTypeStep": "Community Type",
            "label.step.newCommunity.communityTypeStep.subtitle": "Let's start by defining the type of community to create. What type of community do you want to create?",
            "label.step.newAgentCommunity.communityTypeStep.subtitle": "What type of community do you want to create?",
            "label.step.newAgentCommunity.communityBusinessTypeStep.subtitle": "Let's start by defining the business type. What kind of business do you want to create?",
            "label.step.newCommunity.communitySharingTypeStep": "Sharing Mode",
            "label.step.newCommunity.communitySharingTypeStep.subtitle": "Communities can have different sharing modes. Which sharing mode do you want to select?",
            "label.step.newCommunity.communityStatusStep": "Community Status",
            "label.step.newCommunity.communityStatusStep.subtitle": "Please indicate the current status of the community registration process.",
            "label.step.newCommunity.communityEGACStep": "Managing Entity",
            "label.step.newCommunity.communityEGACStep.subtitle": "Who will be the managing entity of this community?",
            "label.step.newCommunity.confirmationStep": "Confirmation",
            "label.step.newCommunity.confirmationStep.subtitle": "Confirm the data of the community to be created.",
            "label.step.newCommunity.respParty": "Responsible",
            "label.step.newCommunity.bannerUploadStep": "Profile Image",
            "label.step.newCommunity.bannerUpload.subtitle": "Add a profile image for the community.",
            "label.step.newCommunity.businessModelStep": "Tariff Plan Model Type",
            "label.step.newCommunity.businessModelStep.subtitle": "Select the type of tariff plan model to be applied to the shared energy in the community.",
            "label.step.newCommunity.communityNetworkCostsStep": "Billing",
            "label.step.newCommunity.communityNetworkCostsStep.subtitle": "Indicate how network usage billing will be carried out in the community, the billing cycle, and the payment conditions for the documents.",
            // New Community Member Form
            "label.step.newCommunityMember.introduction": "Introduction",
            "label.step.newCommunityMember.introduction.subtitle": "Before starting, please confirm you have all the necessary data to complete the registration of a new community member.",
            "label.step.newCommunityMember.introduction.text": "<ul><li>Client Registration Data at DGEG</li><li>Installation Type / Production Type</li><li>Installation Address</li><li>Installation Licensing Data</li></ul>",
            "label.step.newCommunityMember.selectCommunityStep": "Community",
            "label.step.newCommunityMember.selectCommunityStep.subtitle": "Select the community to which you want to add a new member.",
            "label.step.newCommunityInstallation.selectCommunityStep.subtitle": "Select the community to which you want to add a new installation.",
            "label.step.newCommunityMember.memberDataStep": "Member Data",
            "label.step.newCommunityMember.memberDataStep.subtitle": "Please enter the basic information for the new community member.",
            "label.step.newCommunityMember.installationClassificationStep": "Installation Classification",
            "label.step.newCommunityMember.installationClassificationStep.subtitle": "Classify the installation of the new community member.",
            "label.step.newCommunityMember.installationAddressStep": "Installation Address",
            "label.step.newCommunityMember.installationAddressStep.subtitle": "Please enter the installation address of the new community member.",
            "label.step.newCommunityMember.installationDetailsStep": "Installation Details",
            "label.step.newCommunityMember.installationDetailsStep.subtitle": "Please enter the installation details of the new community member.",
            "label.step.newCommunityMember.installationDetailsStep.installationData": "Installation",
            "label.step.newCommunityMember.installationDetailsStep.productionInstallationData": "Production",
            "label.step.newCommunityMember.installationDetailsStep.storageInstallationData": "Storage",
            "label.step.newCommunityMember.physicalUnitOwnerStep": "Installation Owner",
            "label.step.newCommunityMember.physicalUnitOwnerStep.subtitle": "Please enter the installation owner's data for the new community member.",
            "label.step.newCommunityMember.installationDetailsStep.licensingDetails": "Installation Licensing",
            "label.step.newCommunityMember.elctricityMarketDataStep": "Electricity Market Data",
            "label.step.newCommunityMember.elctricityMarketDataStep.subtitle": "Please enter the electricity market data for the new community member.",
            "label.step.newCommunityMember.confirmationStep": "Confirmation",
            "label.step.newCommunityMember.confirmationStep.subtitle": "Confirm the data of the new community member.",
            "label.step.newCommunityMember.installationTypeStep": "Installation Type",
            "label.step.newCommunityMember.installationTypeStep.subtitle": "Select the installation type of the new community member.",
            // New Community Tariff Plan Form
            "label.step.newCommunityTariffPlan.communityCodeStep": "Community",
            "label.step.newCommunityTariffPlan.communityCodeStep.subtitle": "Select the Community where you will create the tariff plan.",
            "label.step.newCommunityTariffPlan.tariffModelStep": "Tariff Plan Model",
            "label.step.newCommunityTariffPlan.tariffModelStep.subtitle": "Select the desired tariff plan model.",
            "label.step.newCommunityTariffPlan.communityMembersStep": "Community Members",
            "label.step.newCommunityTariffPlan.communityMembersStep.subtitle": "For which community members do you want to associate this plan?",
            "label.step.newCommunityTariffPlan.activationDateStep": "Activation Date",
            "label.step.newCommunityTariffPlan.confirmationStep": "Confirmation",
            "label.step.newCommunityTariffPlan.confirmationStep.subtitle": "Confirm the data of the plan to be created.",

            "label.step.selectInstallation": "Installation",
            "label.step.selectConsumerMember": "Consumer Member",
            "label.step.selectProducerMember": "Producer Member",
            "label.step.confirm": "Confirmation",
            "label.step.confirm.subtitle": "Confirm the installation's client data.",

            "label.installationType.consumptionInstallation": "Consumption Installation (IC)",
            "label.installationType.consumptionInstallationDescription": "Electrical installation that can consume, store, or produce electricity for self-consumption.",
            "label.installationType.productionInstallation": "Production Installation (IPr)",
            "label.installationType.productionInstallationDescription": "Electrical installation licensed for electricity production.",
            "label.installationType.batteryInstallation": "Storage Installation (IA)",
            "label.installationType.batteryInstallationDescription": "Electrical installation licensed for renewable energy storage",

            "label.installationClassification.consumptionInstallationNoProductionWithStorage": "Consumption Installation with Storage",
            "label.installationClassification.consumptionInstallationNoProductionWithStorageDescription": "Consumes and stores electricity from the grid.",
            "label.installationClassification.consumptionInstallationNoProduction": "Consumption Installation",
            "label.installationClassification.consumptionInstallationNoProductionDescription": "Only consumes electricity from the grid",
            "label.installationClassification.consumptionInstallationWithProduction": "Consumption Installation with UPAC",
            "label.installationClassification.consumptionInstallationWithProductionDescription": "Consumes and produces electricity for self-consumption.",
            "label.installationClassification.consumptionInstallationWithProductionAndStorage": "Consumption Installation with UPAC and Storage",
            "label.installationClassification.consumptionInstallationWithProductionAndStorageDescription": "Consumes, stores, and produces electricity for self-consumption.",
            "label.installationClassification.productionInstallationNoConsumption": "Production Installation",
            "label.installationClassification.productionInstallationNoConsumptionDescription": "Installation that only produces energy.",
            "label.installationClassification.productionInstallation": "Production Installation",
            "label.installationClassification.productionInstallationDescription": "Produces electricity for full injection into the grid.",
            "label.installationClassification.productionInstallationWithStorage": "Production Installation with Storage",
            "label.installationClassification.productionInstallationWithStorageDescription": "Produces and stores electricity for full injection into the grid.",
            "label.installationClassification.storageInstallation": "Storage Installation",
            "label.installationClassification.storageInstallationDescription": "Installation that stores energy.",
            "label.form.selectInstallationTypeFirst": "Select Installation Type",
            "label.form.installationClassification": "Installation Classification",
            "label.form.totalMembers": "Number of Members",
            "label.form.client": "Client",
            // Viewable Secret 
            "label.step.secret.insertCode": "Enter Two-Factor Authentication Code",
            "label.step.secret.viewData": "View Information",
            // Success Messages
            "success.api.delete": "Record successfully removed!",
            "success.api.create": "Record successfully created!",
            "success.api.save": "Record successfully updated!",
            "api.success.save": "Record successfully updated!",
            "api.success.sentRegistrationEmail": "Registration email sent successfully!",
            "success.message.foundProgramme": "An existing program was found.",
            "success.message.programProcessed": "Program processed and information updated.",
            "success.message.passwordResetEmail": "An email with password reset instructions has been sent.",
            "success.message.registrationEmail": "An email with user registration instructions has been sent.",
            "success.message.offerCreated": "Offer successfully created.",
            "success.message.marketSessionInfoLoaded": "Market session information loaded.",
            "success.message.agentEntityCreated": "Entity successfully created.",
            "success.message.filesUploaded": "Files uploaded successfully.",
            "message.agent.emailSent": "Registration email sent successfully.",
            // Error Messages
            "error.api.marketSessionLoadingError": "Could not load market session information.",
            "error.pages.notFound": "The page you are looking for was not found!",
            "error.forms.latitudeFormat": "Latitude must have a maximum of 5 decimal places and be a value between 90 and -90",
            "error.forms.longitudeFormat": "Latitude must have a maximum of 5 decimal places and be a value between 180 and -180",
            "error.forms.errors": "There are errors in the form. Please correct them and try again!",
            "error.forms.mandatory": "This field is required!",
            "error.forms.email": "Invalid email address",
            "error.forms.numeric": "This field must be numeric!",
            "error.forms.positiveNumber": "This field must be a positive number!",
            "error.forms.negativeNumber": "This field must be a negative number!",
            "error.forms.nonZeroNumber": "This field cannot be 0!",
            "error.forms.commaNumber": "This field must be a positive number! If so, replace the comma with a dot.",
            "error.forms.emailFormat": "Invalid email format!",
            "error.forms.caeFormat": "Invalid CAE format!",
            "error.forms.zipCodeFormat": "Invalid postal code format!",
            "error.forms.maxDecimalPlaces": "The number of decimal places cannot exceed {{decimalPlaces}}.",
            "error.api.save": "An error occurred while saving this record!",
            "error.api.loadingList": "An error occurred while loading the list!",
            "error.api.generic": "An error occurred communicating with the server.",
            "error.forms.contracts.deliveryPointContractExists": "There is already an active contract for the selected CPE/Product and it is not possible to have two active contracts. Please correct the CPE or Product.",
            "error.forms.contracts.minActDate": "Activation date must be after the signing date.",
            "error.form.findocs.notProcessed": "Could not process the documents.",
            "error.form.positiveNumber": "Must be a number greater than 0",
            "error.forms.installationTypeRequired": "Installation Type is required.",
            "error.forms.aggregationTypeRequired": "Aggregation indication is required.",
            "error.forms.datesMandatory": "Start and end dates are required.",
            "error.forms.maxPeriodTwelveMonths": "The maximum search period is 12 months.",
            "error.forms.endDateSuperiorStartDate": "End Date must be after Start Date.",
            "error.forms.endDateAfterStartDate": "End Date must be after Start Date.",
            "error.forms.startDateInFuture": "Start date must be in the future.",
            "error.forms.fiscalNumber": "Invalid fiscal number (NIF).",
            "error.forms.maxPeriodOneMonth": "The maximum search period is 1 month.",
            "error.api.contract.productionDeliveryPointExists": "The Production CPE is already associated with another installation.",
            "error.api.contract.consumptionDeliveryPointExists": "The Consumption CPE is already associated with another installation.",
            "error.api.mandatoryClosingDate": "Closing Date is required.",
            "error.api.closingDateInFuture": "Closing Date must be less than or equal to the current date.",
            "error.forms.marketagent.passwordIdentical": "Passwords must be identical.",
            "error.api.contract.physicalUnitAlreadyAtUse": "Physical Unit is already associated with another Installation.",
            "error.forms.findocs.noContractInfo": "No contract data. Redirecting to contract page.",
            "error.forms.dateInFuture": "This date cannot be in the future",
            "error.forms.register.fiscalNumberNotFound": "Invalid Registration Data.",
            "error.forms.fiscalNumberDigits": "NIF must have 9 digits.",
            "error.forms.fiscalNumberInvalid": "NIF is invalid.",
            "error.forms.register.tokenFiscalNumberCombinationNotValid": "Registration authorization expired or invalid.",
            "errors.forms.minimumLengthTen": "Password must have a minimum of 10 characters.",
            "error.forms.invalidIBAN": "Invalid IBAN. Please check that you entered the IBAN correctly.",
            "error.forms.invalidCPE": "Invalid CPE.",
            "error.forms.missingContractID": "Contract ID is required to update the contract.",
            "errors.forms.passwordComplexity": "Password must contain at least: one lowercase/uppercase letter, one digit, and one special character (!@#\$%^&*_). ",
            "error.forms.newCommunity.noEGACEntities": "No managing entities available. Go to your Agent area and configure community managing entities.",
            "error.forms.newInstallation.noEntityClients": "No clients are available for the selected Agent.",
            "error.forms.newProducer.noAggregatorEntities": "No aggregator entities available. Go to your Agent area and configure aggregator entities.",
            "error.api.loadingContract": "Error loading contract data. Refresh the page and try again.",
            "error.forms.onlyOneItemcanBeDefault": "You can only choose one default entry!",
            "error.forms.mustHaveOneDefault": "You must choose a default entry!",
            "error.api.fetchEntity": "Error fetching entity:",
            "error.api.trading.physicalUnitNameExists": "A physical unit with the same name already exists.",
            "error.api.trading.offerAlreadyExists": "An offer already exists for the selected Offer Unit.",
            "error.api.trading.offerTotalValueZero": "To submit to the market, the total offer value cannot be 0.",
            "error.api.trading.offerSessionAlreadyClosed": "Market session already closed. Cannot submit the offer.",
            "error.api.trading.phfNotAvailable": "Program results are not yet available, cannot create the offer.",
            "error.api.fiscalNumberNotFound": "NIF not identified. Contact your Market Agent.",
            "error.api.registrationProcessNotStarted": "Registration process not completed for the NIF in question. Request a new Registration Key.",
            "error.api.userAlreadyRegistered": "Registration process already completed for this NIF. Proceed to Login or request a new password.",
            "error.api.tokenExpired": "Registration Key expired. Use the link to request a Registration Email.",
            "error.api.unexpectedError": "An unexpected error occurred. Contact Platform support.",
            "error.api.registrationNotComplete": "Registration process not completed for the NIF in question. Request a new Registration Key.",
            "error.api.loginNotAuthorized": "User not registered or invalid user/password combination.",
            "error.api.loginUnknown": "An unknown error occurred during login. Please contact our Support.",
            "error.api.fiscalNumbernoContracts": "No contract found associated with the NIF. Contact your market agent.",
            "error.api.contractHasNoReceiptEntity": "It is mandatory to define a receipt entity for the contract.",
            "error.api.receiptEntityNoTaxRegime": "It is mandatory to select a Tax Regime for the receipt entity.",
            "error.api.contractTermsAfterClosingDate": "Closing date must be after the start of the last contract terms.",
            "error.api.contractFinancialDocsAfterClosingDate": "Closing date must be after the last billed period.",
            "error.api.activationDateBeforeSignDate": "Activation date must be after the signing date.",
            "error.api.cannotUpdateActDateHasRenewal": "Cannot change activation date as the contract has already been renewed.",
            "error.api.contractTermsStartBeforeContractStart": "Start date cannot be before the contract activation date.",
            "error.api.moreThanOneActiveTermsInPeriod": "Cannot change terms and conditions that have already been renewed",
            "error.api.trading.noDeliveryPointsFoundPhysicalUnit": "No delivery points associated with the physical unit.",
            "error.api.financialDocumentsAfterClosingDate": "There are financial documents issued after the intended closing date.",
            "error.api.termsExistAfterStartDate": "Terms exist after the selected date.",
            "error.api.cannotHaveGapBetweenTerms": "There is a period without contract terms between the existing and new ones. Please correct this error.",
            "error.api.b021p.missingCae": "It is mandatory to fill in the CAE of the Producer or Physical Unit.",
            "error.api.b021p.missingConnectionPowerInformation": "It is mandatory to fill in the connection power information.",
            "error.api.b021p.missingInstalledPowerInformation": "It is mandatory to fill in the installed power information.",
            "error.api.b021p.missingProductionType": "It is mandatory to fill in the production type.",
            "error.api.b021p.missingTechnologyType": "It is mandatory to fill in the technology type.",
            "error.api.b021p.producerMissingCompleteAddressInformation": "It is mandatory to fill in the complete address information of the producer.",
            "error.api.b021p.missingContractActDate": "It is mandatory to fill in the desired activation date for the contract.",
            "error.api.b021p.missingAggregatorDsoId": "Aggregator reference code is missing.",
            "error.api.trading.communicationErrorWithOMIE": "An error occurred communicating with OMIE. Contact support or try again later.",
            "error.api.trading.noOffersFound": "No offers found for the selected Offer Unit or they are not in a state that allows program search.",
            "error.api.trading.offerNotLatestVersion": "The selected offer is not the latest version. Please refresh the page and try again.",
            "errors.api.paymentMethodAlreadyExists": "A payment method already exists for the selected entity.",
            "error.forms.newCommunityTariffPlan.noCommunities": "No communities available. Go to the Energy Communities area and configure a new community.",
            "error.forms.newCommunityTariffPlan.noTariffModels": "No tariff models available. Go to the Tariff Models area and configure a new model.",
            "error.forms.newCommunityTariffPlan.noConsumers": "No consumer members. Go to the Members area within Communities and create a new consumer member.",
            "error.forms.newCommunityTariffPlan.noProducers": "No producer members. Go to the Members area within Communities and create a new producer member.",
            "error.forms.newCommunityTariffPlan.atLeastOneMember": "At least 1 member must be selected.",
            "error.forms.newCommunityTariffPlan.membersRequired": "Members are required.",
            "error.forms.invalidLimit": "The number must have at most 2 decimal places and be positive!",
            "error.forms.invalidSepaCreditorID": "The SEPA Creditor ID is invalid!",
            // Agent Validation Messages
            "error.validation.agentType": "Before proceeding, select at least one Agent type.",
            // Contract Validation Messages
            "error.api.contract.activate.contractNotInPreStatus": "The contract is no longer in Pre-Registration or Activating status.",
            "error.api.contract.activate.activationDateNotReached": "Activation Date has not yet been reached.",
            "error.api.contract.activate.physicalUnitNotFound": "Physical Unit not found.",
            "error.api.contract.activate.connectionPowerNotFound": "Connection Power in the Physical Unit has not yet been filled in.",
            "error.api.contract.activate.connectionGreater1MWAndNoMeterId": "Connection Power equal to or greater than 1MW and without GGS identification.",
            "error.api.contract.activate.receiptEntityNotFound": "Billing Client not found.",
            "error.api.contract.activate.noContractTerms": "No contract terms for the contract.",
            // Member Installation Errors
            "error.api.communities.memberAlreadyInCommunity": "The installation you are registering is already associated with another community.",
            "error.api.communities.extMemberIdAlreadyInUse": "The DGEG ID you are trying to use is already in use.",
            // 2Fa Errors
            "error.api.verificationCodeFailed": "Invalid authentication code. Please try again.",
            // Axios Errors
            "Request failed with status code 500": "An error occurred communicating with the server. Contact support.",
            "message.forms.noFiles": "No file selected!",
            "message.forms.files": "Selected Files:",
            "message.form.contracts.lodadedDeliveryPoint": "Physical Unit information loaded automatically.",
            "message.form.contracts.loadedProducerData": "Information loaded from Producer.",
            "message.form.contracts.entityData": "Entity already exists, data loaded from entity.",
            "message.form.editModeActive": "Edit Mode active",
            "message.form.recordSaved": "Changes saved!",
            "message.form.recordCreated": "Changes saved!",
            "message.form.findocs.processed": "Documents processed and sent to ERP",
            "message.table.noData": "No query has been made yet or the query returned no results. Change the search parameters and try again.",
            "message.table.loadError": "Could not load the data.",
            "label.button.tryAgain": "Try again",
            "label.title.fileImport": "File Import",
            "label.fileImport.tab.ord": "ORD Data files",
            "label.fileImport.col.fileName": "File name",
            "label.fileImport.col.community": "Community",
            "label.fileImport.col.agentEntity": "Agent entity",
            "label.fileImport.col.type": "Type",
            "label.fileImport.col.status": "Status",
            "label.fileImport.col.records": "Records",
            "label.fileImport.col.received": "Received",
            "label.fileImport.col.loaded": "Loaded",
            "label.fileImport.type.DAILY": "Daily",
            "label.fileImport.type.MONTHLY": "Monthly",
            "label.fileImport.type.EXTRAORDINARY": "Extraordinary",
            "label.fileImport.status.PENDING": "Pending",
            "label.fileImport.status.LOADED": "Loaded",
            "label.fileImport.status.FAILED": "Failed",
            "label.fileImport.status.QUARANTINED": "Quarantined",
            "label.fileImport.clearFilters": "Clear filters",
            "label.fileImport.retry": "Retry",
            "label.fileImport.rowActions": "Actions for {{file}}",
            "label.fileImport.download": "Download CSV",
            "message.fileImport.empty": "No ORD files to show. Daily files are kept 31 days, monthly and extraordinary files 13 months. Failed and quarantined files are kept until resolved.",
            "message.fileImport.noMatch": "No files match the filters.",
            "message.fileImport.noAccess": "You do not have access to this page. Contact an administrator.",
            "message.fileImport.retryConfirm": "Retry loading {{file}} for {{community}}? All failed files of this community run are queued with it. Data already loaded is not duplicated.",
            "message.fileImport.retryRequested": "Retry requested. Status will update shortly.",
            "api.error.ord.notRetryable": "File is not in failed state. Nothing was queued.",
            "api.error.ord.copyNotAvailable": "The CSV copy of this file is no longer available.",
            "message.table.customNoData": "There are no tariff plan models created yet for the selected agent. Please go to the tariff plans menu and create a new model.",
            "message.info.noContracts": "You have no associated contracts.",
            "message.info.noProgrammeFound": "No program found for the selected period.",
            "message.info.dataLoaded": "Data loaded successfully.",
            "message.form.login.sucess": "Login Successful",
            "message.forms.fileSizeExceeded": "File size exceeds the allowed limit of 10MB.",
            "message.dialog.2FACode": "Please enter your two-factor authentication code. If you have not yet configured two-factor authentication, you must configure it in Account > User Settings.",
            "message.form.xmlfiles": "Only files with the .xml extension are allowed.",
            "message.form.250kbfilesize": "The file must be smaller than 250KB.",
            // Backend Options
            "Quarterly": "Quarterly",
            "Monthly": "Monthly",
            "Monthly (15th)": "Monthly / Mid-Month",
            "Monthly (2nd)": "Monthly / Beginning of Month",
            "No Billing Period": "No Cycle / Single Act",
            "Weekly": "Weekly",
            "Yearly": "Yearly",
            "Validation": "In Validation",
            "Approved": "Approved",
            "Prospecting": "Under Construction",
            "Operating": "Operating",
            "label.status.member.prerecord": "Pre-Registration",
            "label.status.member.active": "Active",
            "label.status.member.registered": "Registered",
            "label.status.member.suspended": "Suspended",
            "label.status.member.inactive": "Inactive",
            "label.status.member.certification": "Certification",
            "label.status.receipt.DUE": "Due",
            "label.status.report.PENDING": "Pending",
            "label.status.report.COMPLETED": "Completed",
            "label.status.report.ERROR": "With Error",
            "label.status.report.RUNNING": "In Progress",
            "label.status.offer.UNSENT": "Not Sent",
            "label.status.offer.SENT": "Sent",
            "label.status.offer.SUBMITTED": "Submitted",
            "label.status.offer.VOIDED": "Voided",
            "label.status.offer.REJECTED": "Rejected",
            "label.status.offer.REFUSED": "Rejected",
            "label.status.offer.UPDATED": "Pending",
            "label.status.offer.PENDING": "Pending",
            "label.status.offer.ARCHIVED": "Archived",
            "label.status.contract.ATI": "Active",
            "label.status.contract.PRE": "Pre-Registration",
            "label.status.contract.PEN": "Pending",
            "label.status.contract.REC": "Rejected",
            "label.status.contract.FEC": "Closed",
            "label.type.offer.C": "Purchase",
            "label.type.offer.V": "Sale",
            "label.status.agent.PREREG": "Pre-Registration",
            "label.status.agent.ACTIVE": "Active",
            // Community Status
            "label.community.status.dgegRegistrationgGroup": "DGEG Registration",
            "label.community.status.prerecord": "Pre-Registration",
            "label.community.status.active": "Active",
            "label.community.status.submitted": "Project submitted",
            "label.community.status.analyzing": "Under Analysis",
            "label.community.status.partialReview": "Partial ORD Opinion",
            "label.community.status.totalReview": "Total ORD Opinion",
            "label.community.status.waitingAcceptance": "Awaiting Acceptance for Registration",
            "label.community.status.cadastreAssignment": "Registration Assignment",
            "label.community.status.certificationDGEG": "DGEG Certification",
            "label.community.status.certificationORD": "ORD Certification",
            "label.community.status.suspended": "Sharing Suspended",
            "label.community.status.certification": "Certification",
            "label.community.status.registering": "Registering at DGEG",
            "label.community.type.acc": "Collective Self-Consumption",
            "label.community.type.cer": "Renewable Energy Community",
            // Invoices Status
            "Paid": "Paid",
            "Paid Off": "Paid",
            "Pending": "Pending",
            "Void": "Voided",
            "Processed": "Processed",
            "Issued": "Issued",
            "Unpaid": "Due",
            "Approval": "Approved",
            // Producer Status
            "Pre-Record": "Pre-Registration",
            "Active": "Active",
            "Inactive": "Inactive",
            "Refused": "Rejected",
            "Pending Contract": "Pending",
            "No Contracts": "No Contract",
            "Activating": "Activating",
            // Financial Document Types
            "Auto Invoice": "Self-Bill",
            "Purchase Document": "Purchase Document",
            "Sales Document": "Invoice",
            "Credit Note": "Credit Note",
            // Payment Terms
            "20 Days": "20 Days",
            "30 Days": "30 Days",
            "60 Days": "60 Days",
            // Long Text Messages
            "label.message.producerExists": "A producer with the entered Tax Number already exists and it is not possible to create two producer records for the same Tax Number. Do you want to enter another Tax Number or be redirected to the existing producer's page?",
            "label.message.goBackConfirmation": "Going back will lose all changes made, this record has not been saved!",
            "label.message.deleteConfirmation": "By removing, you will permanently delete and lose all records!",
            "label.message.recordsProcessedSuccess": "Records processed successfully.",
            "label.message.noActiveAutoInvoiceAgreements": "There are no active self-billing agreements for this client.",
            "label.message.noActivePaymentMethods": "There are no active Payment Methods for this client.",
            "label.contract.action.REOPEN": "Reopen",
            "label.contract.action.RENEW": "Renewal",
            "label.contract.action.CLOSE": "Termination",
            "label.contract.action.CREATE": "Creation",
            "label.contract.action.UPDATE": "Update",
            "label.contract.action.UPDATE_ACTDATE": "Change Signature / Contract Termination",
            "label.contract.action.ACTION_UPD_TERMS": "Update Terms",
            "label.contract.action.SCHED_CLOSE": "Scheduled Termination",

            "label.message.agent.referenceCodesUpdated": "Reference Codes updated successfully.",
            "label.message.agent.certificateUploaded": "Certificate uploaded successfully.",
            "label.message.agent.certificatePasswordUpdated": "Certificate Password updated successfully.",

            "label.message.dialog.closingIn": "This window will close in {{seconds}} seconds.",
            "message.dialog.valueCopied": "Value copied to clipboard.",
            "label.message.noData": "No data.",

            "label.dialog.changeOwner.title": "Transfer Ownership",
            "label.dialog.changeOwner.step1.title": "New Owner Data",
            "label.dialog.changeOwner.step1.subtitle": "Enter the Tax Number and the name of the new installation owner.",
            "label.dialog.changeOwner.step2.title": "Confirm New Owner",
            "label.dialog.changeOwner.step2.sectionTitle": "Owner Data",

            "label.dialog.confirmContinueToMemberConfiguration.message": "Congratulations! You have completed the installation configuration in the community. Do you want to continue to configure the client associated with the installation?",
            "label.dialog.confirmContinueToCommunityConfiguration.message": "Congratulations! You have completed the installation configuration. Do you want to associate it with a community?",
            "label.dialog.confirmContinueToTariffPlanConfigurationDialog.message": "You have completed the configuration of a client for the installation! Do you want to continue to configure the tariff plan?",
            "label.tariffPlanType.consumer": "Consumer",
            "label.tariffPlanType.producer": "Producer",
            "label.installationMemberType.consumer": "Consumers",
            "label.installationMemberType.producer": "Producers",
            "label.tariffPlanType.consumer.description": "Tariff plan applied to the sale of energy consumed by the Consumer, shared by the Community through the network or supplied by the UPAC.",
            "label.tariffPlanType.producer.description": "Tariff plan applied to the purchase of energy injected into the grid by the Producer, for sharing with the Community or trading in energy markets.",
            "label.tariffPlanType.producers_2_consumer": "All Producers to Consumer",
            "label.tariffPlanType.producers_2_consumer.description": "Tariff plan applied to energy shared between each Producer and each Consumer.",
            "label.tariffPlanType.pairs": "Consumer - Producer Pair",
            "label.tariffPlanType.pairs.description": "Tariff plan applied to the purchase and sale of energy shared between each Producer – Consumer pair in a Community.",
            "label.step.newTariffModel.tariffPlanType.subtitle": "Select the type of tariff plan model.",
            "label.step.newTariffModel.tariffs": "Tariffs",
            "label.step.newTariffModel.duration": "Duration",
            "label.step.newTariffModel.duration.subtitle": "Define the duration of the tariff plan and the number of days in advance with which contract termination must be communicated.",
            "label.step.newTariffModel.tariffType": "Energy Tariff",
            "label.step.newTariffModel.tariffType.subtitle": "Define the terms of the energy tariff.",
            "label.step.newTariffModel.fees": "Management Tariff",
            "label.step.newTariffModel.fees.subtitle": "Define the terms of the management tariff.",
            "label.step.newTariffModel.paymentsAndReceipts": "Payments and Receipts",
            "label.step.newTariffModel.payments": "Payments",
            "label.step.newTariffModel.payments.subtitle": "This section allows you to configure payment methods, payment conditions, and billing cycles that can be made available to the Client.",
            "label.step.newTariffModel.receipts": "Receipts",
            "label.step.newTariffModel.receipts.subtitle": "This section allows you to configure receipt methods, receipt conditions, and billing cycles that can be made available to the Client.",
            "label.step.newTariffModel.paymentsAndReceipts.subtitles": "Define the default values for payments and receipts.",
            "label.step.newTariffModel.confirmationStep": "Data Confirmation",
            "label.step.newTariffModel.confirmationStep.subtitle": "Confirm the tariff plan data.",

            "label.step.newProducer.agentEntityStep": "Agent",
            "label.step.newCommunity.newProducer.subtitle": "Let's start by defining which aggregation entity is responsible for managing the producer.",
            "label.step.newProducer.entityData": "Producer Data",
            "label.step.newCommunity.newProducer.entityData": "You can search for an existing entity by Tax Number or create a new entity.",
            "label.step.newProducer.confirmData": "Validate Data",
            "label.step.newTariffPlan.confirmationStep.subtitle": "Confirm the tariff plan data to be created.",
            "label.product.CVE": "Energy Purchase and Sale",
            "label.product.VE": "Energy Sale",
            "label.product.CE": "Energy Purchase",
            "label.product.CAR": "Network Access Costs",
            "label.product.CGE": "EGAC Management Costs",
            "label.product.CGA": "Aggregator Management Costs",
            "label.energyTransaction.shared": "Shared Energy",
            "label.energyTransaction.surplus": "Surplus Energy",
            "label.energyTransaction.production": "Produced Energy",
            "label.energyTransaction.selfconsumption": "Self-Consumption",
            "label.energyTransaction.consumption": "Self-Consumption via Network",
            "label.energyTransaction.trader": "Supplier",
            "label.energyTransaction.shared_consumed": "Shared Energy",
            "label.energyTransaction.shared_surplus": "Surplus Energy",
            "label.tariffPlans.ATI": "Active",
            "label.tariffPlans.PRE": "Pre-Registration",
            "label.tariffPlans.EAC": "Activating",
            "label.tariffPlans.PEN": "Pending",
            "label.tariffPlans.REC": "Rejected",
            "label.tariffPlans.FEC": "Closed",
            // New Powertrading Contract Stepper
            "label.newPowerTradingTariff.introductionStep": "Introduction",
            "label.newPowerTradingTariff.agentEntityStep": "Agent",
            "label.newPowerTradingTariff.physicalUnitDataStep": "Installation Data",
            "label.newPowerTradingTariff.physicalUnitAddressStep": "Installation Address",
            "label.newPowerTradingTariff.contactDataStep": "Contact Data",
            "label.newPowerTradingTariff.receiptsStep": "Receipts and Billing",
            "label.newPowerTradingTariff.documentsStep": "Documents",
            "label.newPowerTradingTariff.confirmationStep": "Validate Data",
            "label.form.renRegistration": "REN Registration Data",
            "label.form.geoCoding": "Geo Location",

            "label.dialog.confirmContinueToInstallationConfigurationDialog.message": "Congratulations! You have completed the community configuration. Do you want to continue to configure an installation for this community?",

            "label.communities.tariffModel.title.independent": "Independent Tariffs",
            "label.communities.tariffModel.description.independent": "This model allows you to apply independent tariff plans to the energy shared with each consumer and to the energy shared by each producer.",

            "label.communities.tariffModel.title.pairs": "Consumer - Producer Pairs",
            "label.communities.tariffModel.description.pairs": "This model allows you to apply a tariff plan to the energy shared between each producer and each consumer.",

            "label.communities.tariffModel.title.producers_2_consumer": "All Producers to One Consumer",
            "label.communities.tariffModel.description.producers_2_consumer": "In this model, all producers apply the same tariff plan to the energy shared with a given consumer.",

            "label.businessType.aggregation": "Powertrading",
            "label.businessType.communities": "Communities",

            "label.step.newPaymentMethod.selectAgentEntity": "Select Agent",
            "label.step.newPaymentMethod.selectPaymentMethod": "Select Payment Method",

            "label.title.configureInstallation": "Configure Installation",
            "api.error.alreadyHasTariffPlan": "There is already an active tariff plan for this installation and the selected energy transaction.",
            "api.error.datesGreaterThanToday": "Please select a date equal to or earlier than today.",
            "api.error.physicalUnitNotFound": "Could not find the selected installation.",

            "label.title.clientData": "Client Data",
            "label.title.documentData": "Document Data",
            "label.title.energyProduction": "Energy Production",
            "label.title.energyConsumption": "Energy Consumption",
            "label.title.energySurplus": "Energy Surplus",
            "label.title.sharedEnergy": "Shared Energy",
            "label.title.sharedEnergyConsumed": "Shared Energy Consumed",
            "label.title.sharedEnergySurplus": "Shared Surplus Energy",
            "label.title.selfConsumptionResp": "Self-Consumption via RESP",
            "label.title.selfConsumptionRi": "Self-Consumption via RI",
            "label.title.consumptionByCommercializer": "Consumption supplied by Supplier",
            "label.title.totalConsumption": "Network Consumption",
            "label.title.networkConsumption": "Self-Consumption via Network",
            "label.title.totalProduction": "Total Production",
            "label.title.totalNetworkInjection": "Total Injected into Network",
            "label.title.surplusEnergy": "Surplus Energy",
            "label.title.UPACConsumptionEnergy": "Integrated UPAC Self-Consumption",

            "label.relatedType.P": "Producer",
            "label.relatedType.C": "Consumer",

            "api.error.activeEnergyPurchasePlan": "There is already an active energy purchase tariff plan for this installation.",
            "api.error.activeEnergySalePlan": "There is already an active energy sale tariff plan for this installation.",
            "api.error.noConsumptionData": "No data for the indicated period or you do not have access.",
            "api.info.noProductionData": "No production data for the indicated period or you do not have access.",
            "api.info.noEnergySurplusData": "No energy surplus data for the indicated period or you do not have access.",
            "label.title.renSFTPConfiguration": "REN SFTP Connection Configuration",
            "label.title.eredesSFTPConfiguration": "E-Redes SFTP Connection Configuration",
            "label.title.energyDataSftpConfiguration": "Energy Data SFTP Configuration",
            "label.title.systemServicesMarketConfiguration": "System Services Market Configuration",
            "label.form.host": "Host",
            "label.form.port": "Port",
            "label.form.sourcePath": "Source Folder",
            "label.form.submissionPath": "Submission Folder",
            "label.form.destinationPath": "Destination Folder",

            "label.message.agent.renSftpConfigurationUpdated": "REN SFTP configuration updated successfully.",
            "label.message.agent.eredesSftpConfigurationUpdated": "E-Redes SFTP configuration updated successfully.",
            "label.newPowerTradingTariff.productsServicesStep": "Products and Services",

            "label.form.autoinvoicingAgreements": "Prior Self-Billing Agreement",
            "label.table.header.useAutoInvoicing": "Self-Billing Regime?",
            "label.table.header.hasValidationCode": "Reported Series?",

            "label.tab.approval": "Approval",
            "label.tab.pending": "Pending",
            "label.tab.processed": "Processed",
            "label.tab.issued": "Issued",
            "label.tab.void": "Voided",
            "label.tab.settled": "Paid",
            "label.title.selectAggregator": "Select Aggregator",
            "label.title.editAutoInvoiceAgreement": "Edit Self-Billing Agreement",
            "label.title.marketSessionConfiguration": "Market Session Configuration",

            "api.error.agentEntityDoesNotHaveCertificate": "The selected entity does not have an OMIE digital certificate associated. Please upload a digital certificate for this entity in your account.",
            "error.api.trading.cantSendRejectedOffer": "It is not possible to send a rejected offer. Edit the offer to correct the errors before sending.",
            "api.error.errorFetchingOpenMarketSession": "Could not confirm if there is an open market session. Please try again later.",
            "error.api.trading.voidOfferNotSuccessful": "Could not void the offer. Please try again later.",
            "error.api.trading.offerAlreadySent": "The offer has already been submitted to the market. To send again, create a new version by changing the offer data.",
            "api.error.noOmieReferenceId": "The selected market agent does not have the OMIE reference ID filled in. Action cannot be completed.",

            //Physical Unit Update
            "api.error.physicalUnitsUpdate.consumptionDeliverypointAlreadyUsed": "The Consumption CPE is already associated with another installation.",
            "api.error.physicalUnitsUpdate.productionDeliverypointAlreadyUsed": "The Production CPE is already associated with another installation.",
            "api.error.physicalUnitsUpdate.ownerNotFound": "The Installation Owner was not found on the platform.",

            //Physical Unit Change Owner
            "api.error.physicalUnitsChangeOwner.ownerNotFound": "The Installation Owner was not found on the platform.",

            // Financial Document Manual Creation
            "api.error.finDoc.manualCreationDisabled": "Manual document creation feature is disabled.",
            "api.error.finDoc.invalidClassificationForSurplusCommunity": "For billing a surplus community, the document must be Energy Purchase.",
            "api.error.finDoc.onlyEPForAggregation": "The document must be Energy Purchase.",
            "api.error.finDoc.invalidClassificationForRole": "Invalid document classification.",
            "api.error.finDocPrepare.contractNotFound": "Tariff Plan not found.",

            // Physical Unit Classifications
            "label.physicalUnitClassification.ip": "IP",
            "label.physicalUnitClassification.ic": "IC",
            "label.physicalUnitClassification.ic_prod": "IC / Production",
            "label.physicalUnitClassification.ic_prod_strg": "IC / Production / Storage",
            "label.physicalUnitClassification.ic_strg": "IC / Storage",
            "label.physicalUnitClassification.ip_strg": "IP / Storage",
            "label.physicalUnitClassification.ia": "Storage Installation",

            "error.api.trading.notLatestVersionOffer": "The selected offer is not the latest version. Please refresh the page and try again.",
            "label.title.forecastProgramme": "Programming",
            "error.api.trading.finalOfferAlreadySubmitted": "The final offer has already been submitted to the market. It cannot be voided.",

            "label.title.selectEGAC": "Select Managing Entity",
            "label.menu.financialDocuments": "Financial Documents",
            "label.title.selectedAgentEntity": "Selected Entity",
            "api.error.invalidPlanTypeForCommunity": "The selected tariff plan type is not valid for the selected community.",
            "label.agentEntity.egacCode": "EGAC Code",
            "label.table.header.productionDeliveryPoint": "Production CPE",
            "label.table.header.consumptionDeliveryPoint": "Consumption CPE",
            "label.button.runInvoiceCycle": "Run Billing Cycle",

            "label.dialog.runInvoiceCycle.title": "Run Billing Cycle",
            "label.dialog.runInvoiceCycle.selectCycle": "Select Billing Cycle",
            "label.dialog.runInvoiceCycle.confirmData": "Confirm Billing Cycle Processing Request",

            "api.error.invoiceProcessRequestExists": "There is already a billing cycle processing request for the selected Agent and Cycle.",
            "label.menu.invoicingCycleRequests": "Billing Cycle Processing Requests",
            "label.table.header.createdDate": "Creation Date",
            "label.table.header.updatedDate": "Update Date",
            "label.status.invoiceCyleRequest.PN": "Pending",
            "label.status.invoiceCyleRequest.PR": "Processing",
            "label.status.invoiceCyleRequest.CP": "Complete",
            "label.status.invoiceCyleRequest.FL": "Error",

            "error.api.communityWithDsoIDAlreadyExists": "A community is already registered with the DSO ID. Please change the value and try again.",
            "label.table.header.businessType": "Business Type",

            // Financial Documents Status
            "label.financialDocuments.status.AP": "In Approval",
            "label.financialDocuments.status.PN": "Pending",
            "label.financialDocuments.status.PR": "Processed",
            "label.financialDocuments.status.IS": "Issued",
            "label.financialDocuments.status.VD": "Voided",
            "label.financialDocuments.status.RJ": "Rejected",
            "label.financialDocuments.status.PD": "Paid",

            // Financial Documents Menu Actions
            "label.financialDocument.menu.downloadSettlementNote": "Download Settlement Note",
            "label.financialDocument.menu.downloadSettlementDocument": "Download Payment Document",
            "label.financialDocument.menu.uploadDocument": "Upload Document",
            "label.financialDocument.menu.voidDocument": "Void Document",
            "label.financialDocument.menu.publishDocument": "Publish Document",
            "label.financialDocument.menu.uploadDocuments": "Upload Documents",
            "label.financialDocument.menu.fileSelected": "File Selected:",
            "label.financialDocument.menu.noFileSelected": "No file selected",
            "label.financialDocument.menu.sendEmail": "Reenviar Email de Emissão",
            "label.table.header.documents": "Documents",
            "api.error.validation": "A validation error occurred. Please check the entered data.",
            "api.error.afrrBlock1Required": "Block 1 must be created before adding higher-numbered blocks to a period.",
            "api.error.afrrMaxPower": "The total offered power for this period exceeds the physical unit's maximum power.",
            "errors.api.financialDocument.documentExistsForPeriod": "A financial document already exists for the selected period. First void the existing document.",
            "errors.api.financialDocumentAlreadyVoided": "Could not void the document as it is already voided.",
            "error.api.existingTariffPlan": "There is already an active tariff plan for this installation and the selected energy transaction.",

            "label.title.tariffPlans": "Tariff Plans",
            "label.title.viewTariffPlan": "View Tariff Plan",
            "label.table.header.energyTariffEuro": "Energy Tariff (€/MWh)",
            "label.table.header.tariffPlan": "Tariff Plan",
            "label.table.header.periodStart": "Start Date",
            "label.table.header.periodEnd": "End Date",
            "label.table.header.mgmtEnergyTariffEuro": "Management Tariff (€/MWh)",
            "label.table.header.mgmtEnergyTariffPerc": "Management Tariff (%)",
            "label.table.header.powerTariffEuro": "Management Tariff (€/kW/day)",
            "label.table.header.acceptNegPrices": "Accept?",
            "label.menu.generalInfo": "General Data",
            "label.menu.tariffs": "Tariffs",
            "label.title.planDates": "Dates and Duration",
            "label.title.changeTariffPeriod": "Change Tariff Terms",
            "label.title.newTariffPeriod": "New Tariff Terms",
            "api.error.contract.updatePlanDates.moreThanOneTariffPeriodFound": "More than one tariff period was found associated with the plan. It is not possible to change the activation date when there is more than one tariff period.",
            "api.error.contract.updatePlanDates.startDateMustBeAfterSignatureDate": "The activation date must be after the signature date.",
            "label.dialog.deleteTariffPeriod.title": "Remove Tariff Period",
            "label.dialog.deleteTariffPeriod.confirmQuestion": "Please confirm you still want to proceed with removing the tariff period.",
            "label.dialog.deleteTariffPeriod.affectedDocumentsIntro": "The following documents issued and associated with the period being removed were identified.",
            "label.dialog.deleteTariffPeriod.content": "Do you confirm you want to remove the period from {{start}} to {{end}}?",
            "label.dialog.confirmAffectedDocuments.title": "Existing Financial Documents",
            "label.dialog.confirmAffectedDocuments.intro": "The financial documents listed below were found associated with this date range.",
            "label.dialog.confirmAffectedDocuments.confirmQuestion": "Are you sure you want to confirm?",
            "label.dialog.confirmAffectedDocuments.footnote": "The documents will always remain available on the platform to be voided manually later, if you wish.",
            "label.table.header.erpId": "ERP ID",
            "label.table.header.referenceStartDate": "Start",
            "label.table.header.referenceEndDate": "End",
            "api.error.contract.deleteTariffPeriod.cannotDeleteLastTariffPeriod": "It is not possible to remove this tariff period. The tariff plan must have at least one tariff period.",
            "label.common.loading": "Loading...",
            "error.api.tariffPeriod.deleteFailed": "Could not remove the record. Please try again.",
            "error.api.existingTariffPeriodForContract": "Could not save changes: Another tariff period already exists for the selected dates.",
            "error.api.contract.createTariffPeriod.newPeriodMustStartAfterTheLastOneEnds": "Could not save changes: tariff period dates must be continuous.",
            "error.api.createTariffModel.agentNotFound": "Failed to create tariff plan model: could not determine the agent associated with your account.",

            // Void Financial Documents
            "label.button.voidFinDocNoSubstitution": "Void Document without Replacement Document",
            "label.button.voidFinDocWithSubstitution": "Void Document and Create Replacement Document",
            "label.voidFinDoc.stepSubsDocument": "Create Substitution Document",
            "label.button.goBack": "Go Back to Previous Step",
            "label.button.submitVoidAndSubsDoc": "Submit Void and Substitution Document",

            "Limit": "Limit",
            "label.title.editPaymentMethod": "Edit Payment Method",

            // Financial Documents Classifications
            "label.table.header.classification": "Classification",
            "label.financialDocumentClassification.EP": "Energy Purchase",
            "label.financialDocumentClassification.ES": "Energy Sale",
            "label.financialDocumentClassification.AC": "Management Services",
            "label.financialDocumentClassification.client.EP": "Energy Sale",
            "label.financialDocumentClassification.client.ES": "Energy Purchase",
            "label.financialDocumentClassification.client.AC": "Management Services",

            "error.api.managingEntityNotFoundOrNotAuthorized": "The selected Managing Entity was not found or does not have permission to manage this entity.",

            // Client Area
            "placeholder.search.physicalUnit": "Search CPE, Address or Name",
            "placeholder.search.community": "Search Name or Code",
            "placeholder.search.communityAlt": "Search Nome or DGEG ID",
            "info.search.failed": "Search returned no results or you have no active contract available.",
            "search.physicalUnit.btn.text": "View All",
            "card.physicalUnit.name": "Installation Name",
            "card.physicalUnit.address": "Installation Address",
            "card.physicalUnit.locality": "Installation Locality",
            "card.physicalUnit.noName": "Installation Name not defined",
            "card.physicalUnit.noLocality": "Installation Locality not defined",
            "btn.physicalUnit.details": "Installation Details",
            "btn.community.details": "Community Details",
            "btn.physicalUnit.energy": "Energy",
            "btn.physicalUnit.billing": "Billing",
            "btn.physicalUnit.tariffPlans": "Tariff Plans",
            "btn.physicalUnit.saft": "SAF-T",
            "cardsSection.clientDashboard.community": "Community Energy",
            "cardsSection.clientDashboard.egac": "Managing Entity (EGAC)",
            "cardsSection.clientDashboard.client": "Client",
            "cardsSection.clientDashboard.billingAddress": "Billing Address",
            "cardsSection.clientDashboard.buyEnergy": "Energy Purchase",
            "cardsSection.clientDashboard.paymentMethod": "Payment Method",
            "cardsSection.clientDashboard.consumption": "Community Consumption (kWh) in recent months",
            "cardsSection.clientDashboard.recentBilling": "Most recent billing",
            "btnText.contacts": "View Contacts",
            "btnText.modifyContacts": "Edit Contacts",
            "btnText.modifyAddress": "Edit Address",
            "btnText.modifyBillingAddress": "Edit Billing Address",
            "btnText.modifyLimit": "Edit Limit",
            "btnText.modifyIBAN": "Edit IBAN",
            "btnText.invoice": "Invoice",
            "cardsSection.clientDashboard.debit": "Direct Debit",
            "cardsSection.clientDashboard.limit": "Limit",
            "cardsSection.clientDashboard.valueToPay": "Amount to Pay",
            "cardsSection.clientDashboard.valueToReceive": "Amount to Receive",
            "cardsSection.clientDashboard.valueToCredit": "Amount to Refund",
            "chartConsumption.autoConsumptionNet": "Self-Consumption via Network",
            "chartConsumption.autoConsumption": "Self-Consumption",

            "physicalUnits.everyPhysicalUnit": "All Installations",

            "physicalUnit.editName": "Edit Installation Name",

            "dashboardDialogs.egacContacts": "EGAC Contacts",
            "dashboardDialogs.addressData": "Address Data",
            "dashboardDialogs.paymentInfo": "Payment Data",
            "dashboardDialogs.modifyPayment": "Edit Payment Data",
            "dashboardDialogs.doorNumber": "Door Number",
            "dashboardDialogs.apartmentNumber": "Apartment Number",

            "physicalUnitDetails.idMember": "Member ID",
            "physicalUnitDetails.noData": "No installation data",
            "physicalUnitDetails.invoices.paymentMethod.SEPA": "SEPA Direct Debit",
            "physicalUnitDetails.invoices.paymentMethod.bankTransfer": "Bank Transfer",

            "invoicesTab.method.sdd": "SEPA Direct Debit",
            "invoicesTab.method.rmb": "Multibanco Reference",
            "invoicesTab.method.TRF": "Bank Transfer",

            "dashboard.updatePayments": "Update Payment and Receipt Data",
            "Update": "Update",
            "dashboard.updateProfile": "Update Profile",

            "dashboard.info.noDataAvailable": "No information is yet available regarding your tariff plan.",

            "physicalUnits.details.noImage": "No image available",
            "physicalUnits.details.imageTitle": "Installation Image",

            // Edit Tariff Period
            "error.api.contract.updateTariffPeriod.canOnlyUpdateEndDateOfLastTariffPeriod": "Only the end date of the last tariff period can be updated.",
            "error.api.contract.updateTariffPeriod.startDateAndEndDateMustBeWithinContract": "The start and end dates of the tariff period must be within the contract dates. To extend the contract, you must create a new Tariff Period.",
            // Close Tariff Plan
            "label.tariffPlan.close.title": "Close Tariff Plan",
            "label.tariffPlan.close.confirmQuestion": "Please confirm you still want to proceed with closing the tariff plan.",
            "label.tariffPlan.close.affectedDocumentsIntro": "The following documents issued after the tariff plan closing date were identified.",
            "label.tariffPlan.close.closeDate": "Close Tariff Plan",
            "label.tariffPlan.close.confirmation": "Confirm Data",
            "api.error.contract.close.contractAlreadyClosed": "It is not possible to close the contract. The contract is already closed.",
            "api.error.contract.close.invoicesExistAfterCloseDate": "It is not possible to close the contract. There are invoices after the contract closing date.",
            "api.error.contract.close.termsExistAfterCloseDate": "It is not possible to close the contract. There are tariff periods after the contract closing date. Remove the future tariff periods before closing the plan.",
            // Remove Tariff Plan
            "error.api.tariffPlan.deleteFailed": "Could not remove the tariff plan due to an error. Please contact platform support.",
            "label.dialog.deleteTariffPlan.title": "Remove Tariff Plan",
            "label.dialog.deleteTariffPlan.content": "Do you confirm you want to remove the tariff plan for installation {{deliverypoint}} from {{start}} to {{end}}?",
            "error.api.contract.deleteContract.cannotDeleteContractWhenDocumentsHaveBeenCreated": "It is not possible to remove the Tariff Plan. There are already financial documents associated with the Plan.",

            "dashboard.detailsSection.noBillingData": "Your tariff plan has no recent billing",
            "dashboard.detailsSection.noEnergyData": "Your tariff plan has no recent energy data",

            "communities.memberDetails.deliverypoint": "Production / Consumption CPE",

            // Client Document Statuses
            "label.financialDocuments.status.client.notPaid": "Due",
            "label.financialDocuments.status.client.paid": "Paid",
            "label.financialDocuments.status.client.notReceived": "Not Received",
            "label.financialDocuments.status.client.received": "Received",
            "label.financialDocuments.status.client.void": "Voided",

            //Market Session / Offers
            "label.button.createEmptyOffers": "Create Empty Offers",
            "label.button.createTotalOffer": "Create Total Offer",
            "label.button.createIncrementalOffer": "Create Incremental Offer",
            "success.message.previousSessionStatusLoaded": "The results of the programs related to the previous session have been synchronized.",
            "title.incrementalProgramme.confirmation": "Confirm creation of incremental program",
            "title.incrementalProgramme.noAvailableProgramme": "There is no program available to create the incremental offer. Confirm if you want to create an offer for the entire programming or an empty offer.",
            "title.incrementalProgramme.referenceProgrammeAvailable": "The reference program <b>{{programme_name}}</b> is available to create the incremental offer. Confirm the creation of the incremental offer.",
            "title.incrementalProgramme.referenceProgrammeNotAvailable": "The reference program <b>{{programme_name}}</b> is not available to create the incremental offer. Confirm if you want to use the program <b>{{replacement_programme_name}}</b> to create the incremental offer.",

            "clientDetails.fiscalData": "Fiscal Data",
            "clientDetails.noData": "Could not load user information. Please logout and login again.",
            "clientDetails.invalidImageFormat": "Invalid format. Only JPEG or PNG images are allowed.",
            "clientDetails.invalidImageSize": "The image cannot be larger than 5MB.",

            "Admin": "Admin",

            "languages.portuguese": "Portuguese",
            "languages.english": "English",

            "label.role.admin": "Admin",
            "label.role.agent": "Agent",
            "label.role.client": "Client",

            "communityMember.status.description.prerecord": "Member not registered on the DGEG Portal",
            "communityMember.status.description.registered": "Member registered on the DGEG Portal",
            "communityMember.status.description.active": "After certification by DGEG and signing the network usage contract, energy sharing begins",
            "communityMember.status.description.suspended": "Sharing suspended due to situations provided for in the RAC regulations",

            "markets.copyValues.block": "Block",
            "markets.copyValues.hours": "Periods",
            "markets.offers.missingData": "No offer information to display.",
            "markets.offers.copiedData": "Data copied to clipboard.",

            "label.userRegistration.viewTermsAndConditions": "See our Terms and Conditions here",
            "label.userRegistration.registrationComplete": "You have completed your registration! You can proceed to the login page here",
            "label.registration.loginLink": "here",
            "label.userRegistration.loginWithFiscalNumber": "and log in with your Tax Number.",
            "label.step.userProfile": "User Profile",
            "label.step.userProfilePicture": "Profile Picture",
            "label.step.userAddress": "Address",
            "label.step.userSecurityConfiguration": "Security Configuration",

            "label.table.paymentMethods.bankName": "Bank Name",
            "label.table.paymentMethods.swift": "Swift",

            "communities.communityImage": "Community Image",

            "agentDetails.renSettlement.title": "REN Settlement",
            "label.message.agent.renSettlementUpdated": "REN Settlement data updated successfully.",

            "btnLabel.addCClient": "New Client",
            "addClient.clientType": "Client Type",
            "addClient.clientType.subtitle": "The client can be of several types. Which client types do you want to select?",
            "addClient.clientType.producerOrEgac": "Producer/EGAC Client",
            "addClient.clientType.consumer": "Consumer Client",
            "addClient.clientType.noProducerOrEgac": "The client is neither a Producer nor an EGAC. This information does not need to be filled in.",
            "addClient.clientType.noConsumer": "The client is not a Consumer. This information does not need to be filled in.",
            "addClient.clientType.confirmationStep.subtitle": "Confirm the data of the client to be created.",
            "addClient.clientType.confirmationStep.consumerData": "Consumer Client Data",
            "addClient.clientType.confirmationStep.producerData": "Producer/EGAC Client Data",
            "addClient.clientType.confirmationStep.autoInvoiceRegime": "Self-Billing Regime",

            "taxRegimes.ISN": "VAT Exemption Regime",
            "taxRegimes.NRM": "Normal VAT Regime",
            "taxRegimes.ATL": "VAT Self-Assessment Regime",

            "clientsFilter.selectEntity": "Select an entity",
            "clientsFilter.selectAgent": "Select an agent",
            "clientList.hasValidationCode": "Reported Series",

            "consumer": "Consumer",
            "producer": "Producer",
            "egac": "Managing Entity (EGAC)",
            "clientDetails.clientTypes": "Client Types",
            "agentEntity.contactData": "Agent Entity Contact Data",

            "btnLabel.addPhysicalUnit": "New Installation",

            "installationClassification.ic": "Consumption Installation",
            "installationClassification.ic_prod": "Consumption Installation with UPAC",
            "installationClassification.ic_prod_strg": "Consumption Installation with UPAC and Storage",
            "installationClassification.ic_strg": "Consumption Installation with Storage",
            "installationClassification.ip": "Production Installation (IPr)",
            "installationClassification.ip_strg": "Production Installation with Storage",
            "installationClassification.ia": "Storage Installation",

            "newAgentCommunity.ownerAgentNotRequired": "This field is not required for the selected business type.",
            "newAgentCommunity.projectSummary": "Project Summary",
            "newAgentCommunity.registrationData": "Registration Data",
            "newAgentCommunity.projectSummary.subtitle": "Enter the project values.",
            "newAgentCommunity.clientEGAC": "EGAC Client",
            "newAgentCommunity.egacRegisteredDGEG": "EGAC Registered on DGEG",
            "newAgentCommunity.egacRegisteredDGEG.subtitle": "Enter the data of the Managing Entity registered with DGEG",
            "newAgentCommunity.confirmStep.businessType.aggregation": "Aggregation",
            "newAgentCommunity.confirmStep.businessType.communities": "Communities",
            "newAgentCommunity.isEGACInDGEG": "The selected agent is the EGAC registered at DGEG",

            "noConsumptionDeliverypoint": "No Consumption Deliverypoint",

            "communityDetail.searchEGACClient": "Search for EGAC Client...",

            "communityDetail.onlyUpdateClientEGAC": "The client you are trying to edit is not registered for this agent",

            "api.error.createPhysicalUnit.alreadyExists": "The CPE already exists for this agent",
            "api.error.updatePhysicalUnit.alreadyExists": "The CPE already exists for this agent",
            "api.error.createPhysicalUnit.sameDeliverypoints": "The Consumption and Production Deliverypoint can't be the same",

            "api.error.createCommunity.alreadyExists": "A community with this code already exists",

            "newTarriffPlan.contractInfo": "Contract Information",
            "newTarriffPlan.tariffPlanType": "Installations / Communities",
            "newTarriffPlan.seeInstallations": "See Installations",
            "newTarriffPlan.seeCommunities": "See Communities",
            "newTarriffPlan.initialAgentData": "The associated agent is:",
            "newTarriffPlan.initialClientData": "The associated client is:",
            "newTarriffPlan.initialMemberData": "The associated member is:",
            "newTarriffPlan.initialInstallationData": "The associated installation is:",
            "newTarriffPlan.initialCommunityData": "The associated community is:",

            "communityDetails.activateCommunityManagement": "Activate Community Management",
            "communityDetails.activateCommunityManagement.confirmText": "This action will set the agent {{agentName}} as the Managing Entity of the Community and allow the management of members and billing of the community on the Indie Energy platform. Do you wish to continue?",
            "communityDetails.activateCommunityManagement.activation": "The community {{communityName}} is available for management on the Indie Energy platform. You must fill in the Activation Date, Sharing Mode, and Tariff and Billing Model in the community details in order to start billing the members.",

            "error.forms.newCommunityTariffPlan.noAgentOrCommunity": "Could not determine the agent.",

            "egacClient.communities.dgegName": "DGEG's EGAC Name",
            "egacClient.communities.dgegNIF": "DGEG's EGAC NIF",

            "tariffs.acceptNegPrices": "Accept Negative Prices",

            "asset": "Asset",

            "aggregatorDeliverypoint": "Aggregator Deliverypoint",
            "api.error.createCommunity.aggregatorDeliveryPointAlreadyExists": "The aggregator deliverypoint already exists.",

            "dailyMarket.programmingHorizon": "Programming Horizon",
            "dailyMarket.openSession": "Open Session",
            "dailyMarket.programmingPeriod": "Programming Period",
            "dailyMarket.programmingPUnit": "Programming Unit",
            "dailyMarket.programmingPUnits": "Programming Units",
            "market.aFRRBand": "aFRR Band",
            "market.afrr.fullName": "Automatic Frequency Restoration Reserve",
            "market.aFRRBand.necessities": "Band Necessities",
            "market.aFRRBand.change": "Band Change",
            "market.aFRRBand.energy": "Energy",
            "market.aFRRBand.band": "Band",
            "market.afrr.energy.selectAgentAndUnit": "Please select an Agent and Physical Unit first.",
            "market.afrr.energy.selectPeriod": "Select a period to view bids.",
            "market.afrr.energy.bid.create": "Create new aFRR Bid",
            "market.afrr.energy.bid.edit": "Edit aFRR Energy Bid",
            "market.afrr.energy.bid.periodImmutable": "The period cannot be changed after the bid is created.",
            "market.afrr.energy.bid.warning.exceedsTechnicalLimit": "Quantity exceeds the aFRR platform technical limit (9999 MW).",
            "market.afrr.energy.bid.warning.exceedsAvailableUp": "Quantity exceeds the available headroom (Available Power minus Partition) for an Up offer.",
            "market.afrr.energy.bid.warning.exceedsAvailableDown": "Quantity exceeds the current Partition for a Down offer.",
            "market.afrr.energy.bid.warning.belowContractedBand": "Quantity is below the contracted aFRR band for this period.",
            "market.afrr.energy.bid.warning.belowMandatoryCapacity": "This Physical Unit is subject to mandatory aFRR service — quantity is below the technically feasible power.",
            "market.afrr.energy.bid.confirmWarningsTitle": "Review before submitting",
            "market.afrr.energy.bid.confirmAndSave": "Confirm and Save",
            "market.afrr.energy.bid.clickAgainToConfirm": "Warnings found — click the button again to confirm and proceed.",
            "market.afrr.energy.bid.error.negativeQty": "Quantity cannot be negative.",
            "market.afrr.energy.band.assigned": "Assigned",
            "market.afrr.energy.band.pending": "Pending",
            "market.mfrr": "Reserva de Restabelecimento de Frequência Manual",
            "market.mfrr.energy": "Energy",
            "market.mfrr.bid.create": "Create new mFRR Bid",
            "market.mfrr.bid.edit": "Edit mFRR Energy Bid",
            "market.mfrr.bid.save": "Save",
            "market.mfrr.bid.saveAndSubmit": "Save & Submit",
            "market.mfrr.bid.submit": "Submit",
            "market.mfrr.bid.submitted": "Bid submitted successfully",
            "market.mfrr.bid.submitError": "Submission failed",
            "market.mfrr.bid.error.periodsNotOpen": "One or more selected periods are no longer open for bidding.",
            "market.mfrr.bid.rejectionReason": "Bid rejected by SIME",
            "market.mfrr.activationType.programada": "Scheduled",
            "market.mfrr.activationType.direta": "Direct",
            "market.mfrr.divisible": "Divisible",
            "market.mfrr.nonDivisible": "Non-divisible",
            "market.mfrr.direction.up": "Up",
            "market.mfrr.direction.down": "Down",
            "market.mfrr.physicalUnits": "Physical Units",
            "market.mfrr.minQtyNote": "Min/Max Qty are the quantities offered per unit",
            "market.mfrr.viewLevel.offeringArea": "Offering Area",
            "market.mfrr.viewLevel.physicalUnit": "Physical Unit",
            "market.mfrr.selectPeriod": "Select a period to view bids",
            "market.mfrr.bid.newVersion": "New Version",
            "market.mfrr.bid.selectAllOpen": "Select All Open",
            "market.mfrr.bid.hideClosedPeriods": "Hide Closed",
            "market.mfrr.selectAgentAndArea": "Please select an Agent and Offering Area first.",
            "market.mfrr.period.status.open": "Open",
            "market.mfrr.period.status.pending": "Pending",
            "market.mfrr.period.status.closed": "Closed",
            "market.mfrr.bid.error.priceRange": "Price must be between -15000 and 15000 €/MWh.",
            "market.mfrr.bid.error.qtyRange": "Power values must be between 0 and 9999 MW.",
            "market.mfrr.bid.error.minGreaterMax": "Min quantity cannot be greater than max quantity.",
            "market.mfrr.dispatchOrders": "Dispatch Orders",
            "market.mfrr.dispatchOrders.code": "Dispatch Order Code",
            "market.mfrr.dispatchOrders.column.offerArea": "Offer Area",
            "market.mfrr.dispatchOrders.column.activationType": "Activation Type",
            "market.mfrr.dispatchOrders.column.regulationDirection": "Regulation Direction",
            "market.mfrr.dispatchOrders.column.volume": "Volume (MW)",
            "market.mfrr.dispatchOrders.column.createDate": "DI Creation Date",
            "market.mfrr.dispatchOrders.column.startDate": "DI Start Date",
            "market.mfrr.dispatchOrders.column.ramp1Start": "Ramp 1 Start",
            "market.mfrr.dispatchOrders.column.ramp1End": "Ramp 1 End",
            "market.mfrr.dispatchOrders.column.ramp2Start": "Ramp 2 Start",
            "market.mfrr.dispatchOrders.column.ramp2End": "Ramp 2 End",
            "label.status.bid.PENDING": "Pending",
            "label.status.bid.RECEIVED": "Received",
            "label.status.bid.SUBMITTED": "Submitted",
            "label.status.bid.VALID": "Valid",
            "label.status.bid.ACCEPTED": "Accepted",
            "label.status.bid.REJECTED": "Rejected",
            "label.status.bid.EXPIRED": "Expired",
            "label.status.bid.INVALID": "Invalid",
            "label.status.bid.ARCHIVED": "Archived",
            "label.status.bid.AVAILABLE": "Available",
            "label.status.bid.UNAVAILABLE": "Unavailable",
            "label.status.bid.WITHDRAWN": "Withdrawn",
            "label.status.bid.CONDITIONALLY_AVAILABLE": "Conditionally Available",
            "label.status.bid.CONDITIONALLY_UNAVAILABLE": "Conditionally Unavailable",
            "market.bilateralContracts": "Bilateral Contracts",
            "market.bilateralContracts.generate": "Generate Communication",
            "market.bilateralContracts.submit": "Submit Communication",
            "market.bilateralContracts.noData": "No communication found for this date and BSP.",
            "market.bilateralContracts.pending": "Pending",
            "market.bilateralContracts.submitted": "Submitted",
            "market.bilateralContracts.archived": "Archived",
            "market.bilateralContracts.active": "Active Bilateral Contract",
            "market.bilateralContracts.downloadSubmission": "Submission",
            "market.bilateralContracts.downloadResponse": "Response",
            "market.bilateralContracts.version": "Version",
            "label.bilateralComms": "Communications",
            "label.bilateralContract.purchaseOfferingUnit": "Purchase Offering Unit",
            "label.bilateralContract.saleOfferingUnit": "Sale Offering Unit",
            "market.unavailabilities": "Unavailabilities",
            "market.unavailabilities.physicalUnit": "Physical Unit",
            "market.unavailabilities.agentEntity": "Agent Entity",
            "market.unavailabilities.startTimestamp": "Start",
            "market.unavailabilities.endTimestamp": "End",
            "market.unavailabilities.type": "Type",
            "market.unavailabilities.networkRisk": "Network Risk",
            "market.unavailabilities.deleted": "Status",
            "market.unavailabilities.tab.records": "Records",
            "market.unavailabilities.tab.communications": "Communications",
            "market.unavailabilities.comm.code": "Code",
            "market.unavailabilities.comm.version": "Version",
            "market.unavailabilities.comm.action": "Action",
            "market.unavailabilities.comm.actionInsert": "Insert/Update",
            "market.unavailabilities.comm.actionDelete": "Delete",
            "market.unavailabilities.comm.status": "Status",
            "market.unavailabilities.comm.date": "Date",
            "market.limitations": "Limitations",
            "market.limitations.physicalUnit": "Physical Unit",
            "market.limitations.agentEntity": "Agent Entity",
            "market.limitations.startTimestamp": "Start",
            "market.limitations.endTimestamp": "End",
            "market.limitations.classification": "Classification",
            "market.limitations.limitationType": "Type",
            "market.limitations.maxValue": "Max (MW)",
            "market.limitations.minValue": "Min (MW)",
            "market.limitations.networkRisk": "Network Risk",
            "market.limitations.deleted": "Status",
            "market.limitations.tab.records": "Records",
            "market.limitations.tab.communications": "TSO Batches",
            "market.limitations.comm.code": "Code",
            "market.limitations.comm.date": "Date",
            "market.limitations.comm.version": "Version",
            "market.limitations.comm.action": "Action",
            "market.limitations.comm.actionInsert": "Insert/Update",
            "market.limitations.comm.actionDelete": "Delete",
            "market.limitations.comm.status": "Status",
            "market.unavailabilities.create": "New Unavailability",
            "market.unavailabilities.edit": "Edit Unavailability",
            "market.unavailabilities.history": "Communication History",
            "market.unavailabilities.cancelTitle": "Cancel Unavailability",
            "market.unavailabilities.cancelConfirm": "Mark this unavailability as inactive? This cannot be undone.",
            "market.unavailabilities.submitTitle": "Submit to TSO",
            "market.unavailabilities.submitConfirm": "Submit this unavailability to the TSO? A new communication will be created.",
            "market.unavailabilities.submitSuccess": "Submitted to TSO.",
            "market.unavailabilities.type.PL": "Maintenance Plan (PL)",
            "market.unavailabilities.type.PG": "Scheduled (PG)",
            "market.unavailabilities.type.FT": "Fortuitous (FT)",
            "market.unavailabilities.status.pending": "Pending",
            "market.unavailabilities.status.ongoing": "Ongoing",
            "market.unavailabilities.status.ended": "Ended",
            "market.unavailabilities.status.cancelled": "Cancelled",
            "market.unavailabilities.step.basic": "Basic Information",
            "market.unavailabilities.step.descriptions": "Descriptions",
            "market.unavailabilities.publicDescPt": "Public Description (PT)",
            "market.unavailabilities.publicDescEn": "Public Description (EN)",
            "market.unavailabilities.sensitiveDescPt": "Sensitive Description (PT, optional)",
            "market.unavailabilities.isDefinitive": "Definitive",
            "market.unavailabilities.flagGb": "Flag GB",
            "market.unavailabilities.valueGb": "Value GB",
            "market.unavailabilities.flagTlr": "Flag TLR",
            "market.unavailabilities.statusTlr": "Status TLR",
            "market.unavailabilities.flagCompSinc": "Flag COMP SINC",
            "market.unavailabilities.statusCompSinc": "Status COMP SINC",
            "market.unavailabilities.technicalFlags": "Technical flags",
            "market.unavailabilities.startTimestamp": "Start",
            "market.unavailabilities.endTimestamp": "End",
            "market.unavailabilities.timezoneNote": "Times are reported in the selected physical unit's local timezone",
            "market.unavailabilities.dstAmbiguous": "Ambiguous time (DST change) — select occurrence:",
            "market.unavailabilities.dstSummer": "Before clock falls back (UTC+1)",
            "market.unavailabilities.dstWinter": "After clock falls back (UTC+0)",
            "market.limitations.create": "New Limitation",
            "market.limitations.edit": "Edit Limitation",
            "market.limitations.history": "Communication History",
            "market.limitations.cancelTitle": "Cancel Limitation",
            "market.limitations.cancelConfirm": "Mark this limitation as inactive? This cannot be undone.",
            "market.limitations.comment": "Comment",
            "market.tradingOutlook": "Trading Outlook",
            "market.tradingOutlook.comingSoon": "Trading Outlook",
            "market.tradingOutlook.description": "Timeline visualization of unavailabilities and limitations across programming intervals. Coming soon.",
            "market.tradingOutlook.selectBspAndDate": "Select a BSP and date to load the trading outlook.",
            "market.tradingOutlook.capacidade": "Capacidade",
            "market.tradingOutlook.totalPower": "Total Power",
            "market.tradingOutlook.availablePower": "Available Power",
            "market.tradingOutlook.unavailablePower": "Unavailable Power",
            "market.tradingOutlook.physicalUnit": "Physical Unit",
            "market.tradingOutlook.maxPower": "Max Power (MW)",
            "market.tradingOutlook.availablePowerCol": "Available (MW)",
            "market.tradingOutlook.offeringArea": "Offering Area",
            "market.tradingOutlook.noUnits": "No physical units found for the selected filters.",
            "market.tradingOutlook.period": "Period",
            "market.tradingOutlook.kpi.nominalCapacity": "Nominal Capacity",
            "market.tradingOutlook.kpi.maxDeviation": "Max Power Deviation",
            "market.tradingOutlook.kpi.actualCapacity": "Actual Capacity",
            "market.tradingOutlook.kpi.maxAvailablePower": "Max Available Power",
            "market.tradingOutlook.kpi.minAvailablePower": "Min Available Power",
            "market.tradingOutlook.kpi.minPowerTotal": "Min Power Total",
            "market.tradingOutlook.kpi.maxOfferTotal": "Max Power Total",
            "market.tradingOutlook.kpi.minPowerAvailable": "Min Power Available",
            "market.tradingOutlook.kpi.maxPowerAvailable": "Max Power Available",
            "market.tradingOutlook.kpi.totalCapacity": "Total Capacity",
            "market.tradingOutlook.kpi.availablePower": "Available Power",
            "market.tradingOutlook.kpi.minPower": "Min Power",
            "market.tradingOutlook.kpi.maxPower": "Max Power",
            "market.tradingOutlook.col.periodNumber": "Period #",
            "market.tradingOutlook.col.periodName": "Period",
            "market.tradingOutlook.col.minPowerTotal": "Min Power Total (MW)",
            "market.tradingOutlook.col.maxOfferTotal": "Max Offer Total (MW)",
            "market.tradingOutlook.col.minPowerAvailable": "Min Power Available (MW)",
            "market.tradingOutlook.col.maxPowerAvailable": "Max Power Available (MW)",
            "market.tradingOutlook.allOfferingAreas": "All Offering Areas",
            "market.tradingOutlook.selectAgentAndDate": "You must select the agent and date.",
            "market.tradingOutlook.onlyWithUnavailabilities": "Show only units with unavailabilities",
            "market.comm.code": "Code",
            "market.comm.version": "Version",
            "market.comm.action": "Action",
            "market.comm.actionInsert": "Insert/Update",
            "market.comm.actionDelete": "Delete",
            "market.comm.status": "Status",
            "market.comm.date": "Date",
            "market.comm.document": "Document",
            "label.button.history": "History",
            "label.noRecords": "No records found.",
            "market.offersSubmitted": "Offers Submitted",
            "market.offersNotSubmitted": "Offers Not Submitted",
            "market.offersRejected": "Offer Rejected",
            "market.noOfferInfo": "No offer information.",
            "market.partition.selectFilters": "Select a date, BSP and programming unit to view the partition details.",
            "market.afrr.selectFilters": "Select a date and BSP to view the band offer details.",
            "market.afrr.selectPhysicalUnit": "Select a physical unit to view the periods.",
            "market.afrr.validation.row": "Row {{row}}: {{message}}",
            "market.afrr.validation.physicalUnit": "physical unit is required",
            "market.afrr.validation.period": "period must be between 1 and 96",
            "market.afrr.validation.block": "block must be ≥ 1",
            "market.afrr.validation.avgPower": "average power must be between 0 and 9999.9 MW",
            "market.afrr.validation.avgPowerMax": "average power exceeds unit maximum",
            "market.afrr.validation.bandPrice": "band price must be between 0 and 999.99 €/MW",
            "market.afrr.validation.energyPrice": "energy price must be between -9999.99 and 9999.99 €/MWh",
            "market.afrr.periodsWithErrors": "Some periods have errors",
            "market.noSwitchingRequestInfo": "No switching request.",
            "market.switchingRequestPending": "Switching Request Pending Submission",
            "market.switchingRequestSubmitted": "Switching Request Submitted",
            "market.switchingRequestAccepted": "Switching Request Accepted",
            "market.switchingRequestRejected": "Switching Request Rejected",
            "market.submissionDate": "Submission time",
            "market.blockOffer": "Block offer",
            "market.direction": "Direction",
            "market.averagePowerMW": "Average power (MW)",
            "market.energyPrice": "Energy price (€/MWh)",
            "market.up": "Up",
            "market.down": "Down",
            "market.offerOrigin.automatic": "Automatic",
            "market.offerOrigin.manual": "Manual",

            "send": "Send",
            "currentTime": "Current time",
            "actions": "Actions",
            "delete": "Eliminate",
            "edit": "Edit",

            "physicalUnit.addCommunity": "Add Community",
            "error.api.updateInvoicingCycle.invoicingCycleRequested": "An error occurred while updating the invoicing cycle.",
            "error.api.updateInvoicingCycle.invoicingCycleNotFound": "The selected invoicing cycle was not found.",
            "error.api.updateInvoicingCycleFailed": "An error occurred while updating the invoicing cycle.",

            "label.message.confirmNewAutoInvoiceAgreement": "Are you sure you want to register a new auto-invoicing agreement with the agent {{agentEntity}}?",
            "errors.api.client.deleteBlocked": "Unable to remove the client. Please check if there are Installations, Tariff Plans, Documents, or other records associated with this client.",
            "errors.api.client.deleteIntegrityError": "Unable to remove the client due to a data integrity constraint. Please contact support.",
            "errors.api.client.deleteFailed": "An unexpected error occurred while removing the client.",
            "api.error.userEmailAlreadyExists": "A user with the indicated email address already exists. Please choose another email address.",
            "api.error.usernameAlreadyExists": "A user with the indicated username already exists. Please choose another username.",

            "bsp": "BSP",

            "market.bandPrice": "Band Price (€/MW)",

            "indivisible": "Indivisible",
            "market.insertPhysicalUnit": "Insert Physical Unit",

            "afrr.columnTitle.bandMW": "Band (MW)",
            "label.button.addOffers": "Add Offers",

            "label.button.contractedBand": "Contracted Band",
            "label.button.bandUp": "Band Up",
            "label.button.bandDown": "Band Down",

            // Manual Document Creation
            "label.title.newDocument": "New Document",
            "label.title.installation": "Installations",
            "label.title.surplusCommunity": "Communities",
            "label.title.targetType": "Target Type",
            "label.step.selectTarget": "Select Installation or Community",
            "label.step.selectClassifications": "Select Documents Classifications",
            "label.step.selectPeriod": "Select Period",
            "label.step.previewAndApprove": "Preview and Create",
            "label.info.selected": "Selected",
            "label.info.autoClassification": "Automatic classification",
            "label.info.preparingDocuments": "Preparing documents...",
            "label.info.noDocumentsForPeriod": "No documents were generated for the selected period. Please verify that the dates are correct and that there is an active tariff plan covering this period.",
            "label.info.allDocumentsProcessed": "All documents have been created.",
            "label.dialog.title.confirmCompletion": "Confirm Completion",
            "label.info.documentsApproved": "Created successfully:",
            "label.info.documentsWithErrors": "Documents with creation errors:",
            "label.info.documentsNotProcessed": "Not yet processed:",
            "label.info.confirmCloseAnyway": "There are unprocessed or failed documents. Are you sure you want to close?",
            "label.info.consultListBelow": "Please consult the list of documents below.",
            "label.button.closeAnyway": "Close Anyway",
            "label.button.previewDocuments": "Preview Documents",
            "label.button.newDocument": "New Document",
            "label.button.approveDocument": "Create Document",
            "label.button.finish": "Finish",
            "label.status.approved": "Created",
            "label.status.processing": "Processing",
            "label.status.error": "Error",
            // Financial document detail page
            "label.financialDocument.back": "Back to {{label}}",
            "label.financialDocument.toolbar.attachments": "Attachments",
            "label.financialDocument.toolbar.relatedDocuments": "Related documents",
            "label.financialDocument.toolbar.more": "More",
            "label.financialDocument.action.createSettlementNote": "Create settlement note",
            "label.financialDocument.action.void": "Void",
            "label.financialDocument.action.voidHint": "Keeps the record with status Voided",
            "label.financialDocument.action.attach": "Attach",
            "label.financialDocument.banner.voided": "Voided on {{date}} by {{user}}",
            "label.financialDocument.banner.voidedNoUser": "Voided on {{date}}",
            "label.financialDocument.banner.voidedNoHistory": "This document is voided.",
            "label.financialDocument.banner.processing": "Waiting for the ERP to issue the document. This page refreshes by itself.",
            "label.financialDocument.field.erpDocumentId": "ERP document ID",
            "label.financialDocument.field.netTotal": "Net total",
            "label.financialDocument.field.totalWithTaxes": "Total with taxes",
            "label.financialDocument.field.agentType": "Agent type",
            "label.financialDocument.field.iban": "IBAN",
            "label.financialDocument.placeholder.erpId": "Assigned by the ERP on issue",
            "label.financialDocument.placeholder.totalWithTaxes": "Returned by the ERP on issue",
            "label.financialDocument.lines.empty": "This document has no lines.",
            "label.financialDocument.help.totalWithTaxes": "This value is shown once the document is issued in the ERP.",
            "label.financialDocument.lines.startDate": "Start Date",
            "label.financialDocument.lines.endDate": "End Date",
            "label.financialDocument.lines.returnedOnIssue": "Returned on issue",
            "label.financialDocument.history.created": "Created as {{to}}",
            "label.financialDocument.history.statusChanged": "{{from}} → {{to}}",
            "label.financialDocument.history.statusChangedA11y": "{{from}} to {{to}}",
            "label.financialDocument.history.reprocessed": "Reprocessed",
            "label.financialDocument.history.settlementNoteCreated": "Settlement note created",
            "label.financialDocument.history.unknownUser": "—",
            "label.financialDocument.history.empty": "No history recorded",
            "label.financialDocument.history.error": "History could not be loaded.",
            "label.financialDocument.notAvailable.title": "Document not available",
            "label.financialDocument.notAvailable.agent": "Agents do not see documents awaiting approval. The document becomes visible once an Indie Energy administrator approves it.",
            "label.financialDocument.notAvailable.generic": "The document does not exist or you do not have access to it.",
            "label.financialDocument.loadError": "The document could not be loaded.",
            "label.button.retry": "Retry",
            "label.button.create": "Create",
            "label.financialDocument.dialog.approve.title": "Approve document?",
            "label.financialDocument.dialog.approve.body": "The document moves to Pending. It can then be processed.",
            "label.financialDocument.dialog.process.title": "Process document?",
            "label.financialDocument.dialog.process.body": "The document is sent to the ERP and moves to Processed until the ERP issues it. Once issued, the ERP returns the document ID and the total with taxes, the invoice PDF is generated and the document becomes visible to the client. Once issued, a document can be reprocessed or voided.",
            "label.financialDocument.dialog.reprocess.title": "Reprocess {{id}}?",
            "label.financialDocument.dialog.reprocess.titleNoId": "Reprocess document?",
            "label.financialDocument.dialog.reprocess.body": "The document is sent to the ERP again and the PDF it returns replaces the current file. The ERP document ID and the total with taxes stay the same.",
            "label.financialDocument.dialog.createSettlementNote.title": "Create settlement note?",
            "label.financialDocument.dialog.createSettlementNote.body": "The settlement note (Excel) is generated from the document lines and added to the attachments.",
            "label.financialDocument.dialog.attach.title": "Attach document",
            "label.financialDocument.dropzone.invoiceHint": "Drag the PDF here or click to browse · PDF only · up to 10 MB",
            "label.financialDocument.dropzone.hint": "Drag a file here or click to browse · PDF, XLSX, JPG, PNG or XML · up to 10 MB",
            "label.financialDocument.attach.tooManyFiles": "Attach one file at a time.",
            "label.financialDocument.attachments.subtitle": "Settlement note, invoice, payment note and uploaded files",
            "label.financialDocument.attachments.empty.title": "No attachments yet",
            "label.financialDocument.attachments.empty.awaitingApproval": "Documents awaiting approval have no files.",
            "label.financialDocument.attachments.empty.createHint": "The settlement note is created with Create settlement note.",
            "label.financialDocument.attachments.error": "Attachments could not be loaded.",
            "label.financialDocument.attachments.download": "Download {{name}}",
            "label.financialDocument.attachments.replace": "Replace",
            "label.financialDocument.dialog.replaceInvoice.title": "Replace document PDF?",
            "label.financialDocument.dialog.replaceInvoice.warning": "The current document PDF is removed and replaced by this file. This cannot be undone. The client is not emailed. If the document is reprocessed later, the PDF returned by the ERP replaces this file.",
            "label.financialDocument.dialog.replaceInvoice.confirm": "Replace PDF",
            "success.financialDocument.invoiceReplaced": "Document PDF replaced",
            "label.financialDocument.history.invoiceReplaced": "Invoice / Purchase document replaced",
            "errors.api.financialDocument.cannotReplaceInvoice": "The PDF can only be replaced on issued or paid documents that have an ERP PDF.",
            "errors.api.financialDocument.invoiceMustBePdf": "The file must be a PDF.",
            "errors.api.financialDocument.invoiceSingleFile": "Select a single PDF file.",
            "label.financialDocument.attachment.kind.STL": "Settlement note",
            "label.financialDocument.attachment.kind.INV": "Invoice",
            "label.financialDocument.attachment.kind.PRD": "Purchase document",
            "label.financialDocument.attachment.kind.CRN": "Credit note",
            "label.financialDocument.attachment.kind.YIN": "Supplier invoice",
            "label.financialDocument.attachment.kind.MDR": "Missing data report",
            "label.financialDocument.attachment.kind.UPL": "Uploaded",
            "label.financialDocument.attachment.kind.PAY": "Payment note",
            "label.financialDocument.attachment.kind.unknown": "Document",
            "label.financialDocument.placeholder.settlementNoteHint": "Created with Create settlement note",
            "label.financialDocument.placeholder.issuedHint": "Generated when the ERP issues the document",
            "label.financialDocument.placeholder.paymentNoteHint": "Added when the document is paid",
            "label.financialDocument.related.subtitle": "Credit notes and re-issued documents linked to this document",
            "label.financialDocument.related.column.document": "Document",
            "label.financialDocument.related.column.relation": "Relation",
            "label.financialDocument.related.column.date": "Date",
            "label.financialDocument.related.column.total": "Total",
            "label.financialDocument.related.column.status": "Status",
            "label.financialDocument.related.notIssuedYet": "Not issued yet",
            "label.financialDocument.related.relation.VOIDS.incoming": "Credits this document",
            "label.financialDocument.related.relation.VOIDS.outgoing": "Credited by this document",
            "label.financialDocument.related.relation.REISSUES.incoming": "Re-issue that replaces this document",
            "label.financialDocument.related.relation.REISSUES.outgoing": "Voided document replaced by this one",
            "label.financialDocument.related.empty.title": "No related documents",
            "label.financialDocument.related.empty.body": "Credit notes issued for this document and documents that replace it after a void are linked here.",
            "label.financialDocument.related.error": "Related documents could not be loaded.",
            "label.financialDocument.related.documentCrumb": "Document #{{id}}",
            "success.financialDocument.approved": "Document approved",
            "success.financialDocument.processing": "Processing document",
            "success.financialDocument.reprocessRequested": "Reprocess requested",
            "label.financialDocument.action.resendEmail": "Resend email",
            "label.financialDocument.action.resendEmailHint": "Emails the document to the client again",
            "label.financialDocument.action.regenerateSettlementNote": "Regenerate settlement note",
            "label.financialDocument.action.regenerateSettlementNoteHint": "Replaces the current settlement note file",
            "label.financialDocument.history.clientInvoiceUploaded": "Supplier invoice uploaded",
            "label.financialDocument.menu.uploadReplacesPrevious": "The file replaces the invoice uploaded before for this document.",
            "errors.api.financialDocument.cannotUploadInvoice": "An invoice can only be uploaded to a purchase document that is not voided.",
            "label.financialDocument.history.emailSent": "Email sent",
            "label.financialDocument.dialog.regenerateSettlementNote.title": "Regenerate settlement note?",
            "label.financialDocument.dialog.regenerateSettlementNote.body": "A new settlement note is generated from the current data and replaces the current settlement note file. The current file is not kept.",
            "label.financialDocument.dialog.regenerateSettlementNote.issuedBody": "The client is not emailed and the issued ERP document does not change. To send the new file to the client, use Resend email.",
            "label.financialDocument.dialog.regenerateSettlementNote.confirm": "Regenerate",
            "label.financialDocument.dialog.resendEmail.title": "Resend the document email?",
            "label.financialDocument.dialog.resendEmail.body": "The client receives the document email again at {{email}}, with the document PDF and the other files, except uploaded documents.",
            "label.financialDocument.dialog.resendEmail.noAddress": "The client has no email address, so the email cannot be sent.",
            "label.financialDocument.dialog.resendEmail.confirm": "Resend email",
            "success.financialDocument.settlementNoteRegenerated": "Settlement note regenerated",
            "success.financialDocument.emailSent": "Email sent to {{email}}",
            "errors.api.financialDocument.cannotResendEmail": "The email can only be resent for issued or paid documents that have a document PDF.",
            "errors.api.financialDocument.resendEmailBlocked": "Client emails are blocked for this agent, so the email was not sent.",
            "errors.api.financialDocument.resendEmailNoClient": "The document has no client to email.",
            "errors.api.financialDocument.resendEmailNoAddress": "The client has no email address.",
            "errors.api.financialDocument.resendEmailNotIssued": "The document has no issue date, so the email cannot be sent.",
            "errors.api.financialDocument.resendEmailNoTemplate": "There is no email template for this type of document.",
            "errors.api.financialDocument.resendEmailFailed": "The email could not be sent. Try again later.",
            "success.financialDocument.settlementNoteCreated": "Settlement note created",
            "success.financialDocument.attached": "Document attached",
            "success.financialDocument.issued": "Document issued by the ERP",
            "error.financialDocument.download": "The file could not be downloaded.",
            "errors.api.financialDocumentAlreadyApproved": "The document is already approved.",
            "errors.api.financialDocument.cannotPublish": "The document can only be processed when it is Pending or Processed.",
            "errors.api.financialDocument.cannotReprocess": "Only issued or paid documents can be reprocessed.",
            "errors.api.financialDocument.settlementNoteNeedsContract": "A settlement note can only be created for documents with a contract.",
            "errors.api.financialDocument.settlementNoteOnCreditNote": "A settlement note cannot be created for a credit note that voids another document.",
            "errors.api.financialDocument.attachmentMissing": "Select a file to attach.",
            "errors.api.financialDocument.attachmentTypeNotAllowed": "This file type is not allowed. Use PDF, XLSX, JPG, PNG or XML.",
            "errors.api.financialDocument.attachmentTooLarge": "The file is larger than 10 MB.",
            "errors.api.financialDocument.attachmentNameTooLong": "The file name is longer than 100 characters. Rename the file and try again.",
            "errors.api.financialDocument.documentVoided": "The document is voided. Files can no longer be attached.",
            "label.title.noEntity": "No client",
            "api.error.internalServerError": "An unexpected server error occurred. Please try again later.",
        }
    },
    es: {
        translation: {
            CRM: "CRM",
            Chat: "Chat",
            Shop: "Tienda",
            Sales: "Ventas",
            Payment: "Pago",
            Account: "Cuenta",
            Profile: "Perfil",
            Pricing: "Precios",
            Invoice: "Factura",
            Sessions: "Sesiones",
            Results: "Resultados",
            Checkout: "Verificar",
            Dashboards: "Cuadros de mando",
            Ecommerce: "Comercio electrónico",
            "Upcoming Task": "Próxima tarea",
            "Your Downloads": "Tus descargas",
            "Course Status": "Estado del curso",
            "Course in Progress": "Curso en curso",
            "Enrolled Courses": "Cursos inscritos",
            "Course Completed": "Curso completado",
            "Job Management": "Gestión de trabajos",
            "User & Contact": "Usuario y contacto",
            "User List": "Lista de usuarios",
            "User Grid": "Cuadrícula de usuario",
            "Contact List": "Lista de contactos",
            "Contact Grid": "Cuadrícula de contacto",
            "Invoice List": "Lista de facturas",
            "Create Invoice": "Crear factura",
            "Billing Address": "Dirección de Envio",
            "Payment Complete": "Pago completo",
            "Product List": "Lista de productos",
            "Create Product": "Crear producto",
            "Product Details": "Detalles de producto",
            "Product Grid": "Cuadrícula de productos",
            "Invoice Details": "Detalles de la factura",
            "Learning Management": "Gestión del aprendizaje",
            "Welcome Back! Watson": "¡Bienvenido de nuevo! Watson",
            "Admin Ecommerce": "Administrador de comercio electrónico",
            "Study Time Last Week": "Tiempo de estudio la semana pasada",
            "label.form.divisibleOffer": "Oferta Indivisible",
            "label.title.afrrBandNeeds": "Necesidades de Banda",
        },
    },
    pt: {
        translation: {
            // Menu
            "Energy Communities": "Comunidades de Energia",
            "Administration": "Administração",
            "Manage Entities": "Gestão de Entidades",
            "Manage Members": "Gestão de Membros",
            "Manage Delivery Points": "Gestão de Pontos de Entrega",
            "Member": "Membro",
            "Community of": "Comunidade de",
            "Energy": "Energia",
            "Surplus": "Excedente",
            "Potência": "Power",
            "Storage": "Armazenamento",
            "Active Members": "Membros Ativos",
            "All": "Tudo",
            "Building": "Em Construção",
            "Prospecting-Communities": "Construção",
            "Add Community": "Nova Comunidade",
            "Communities": "Comunidades",
            "Reports": "Relatórios",
            "Forming": "Projeto",
            "Statistics": "Estatisticas",
            "Members": "Membros",
            "Account": "Conta",
            "All Members": "Todos",
            "Consumers": "Consumidores",
            "Add New Member": "Novo Membro",
            "Logout": "Sair",
            "Delivery Points": "Pontos de Entrega",
            "Production Units": "Produção",
            "Installations": "Instalações",
            "Invoices": "Faturação",
            "Hi": "Olá",
            "Add": "Novo",
            "Consumption Instalations": "Consumo",
            "Storage Installations": "Armazenamento",
            // Membros

            "Name": "Nome",
            "Community": "Comunidade",
            "Zip Code": "Código Postal",
            "Status": "Estado",
            "Selling Price": "Preço de Venda",
            "Start Date": "Data de Início",
            "End Date": "Data de Fecho",
            "Network Buying Price": "Preço de Compra Rede",
            "Community Buying Price": "Preço de Compra Comunidade",
            "New Price": "Novo Preço",
            "Installation": "Instalação",
            "Invoicing Entities": "Entidades de Faturação",
            "Member Installation": "Dados da Instalação",
            "Consumtion Delivery Point": "CPE de Consumo",
            "Production Delivery Point": "CPE de Produção",
            "Storage Delivery Point": "CPE de Armazenamento",
            "Billing Period": "Ciclo de faturação",
            "City": "Cidade",
            "Fiscal Number": "Número de Contribuinte",
            "Company?": "Empresa?",
            // Comunidades
            "Overview": "Sumário",
            "View Community": "Ver Comunidade",
            "Community Details": "Detalhes",
            "Sales": "Vendas",
            "Documents": "Documentos",

            "Document List": "Documentos Carregados",
            "Production": "Produção",
            // Delivery Points
            "Consumption Installations": "Instalações de Consumo",
            "Address": "Morada",
            "Country": "País",
            "View Consumption Installation": "Ver Instalação de Consumo",
            "Add Consumption Installation": "Nova Instalação de Consumo",
            "Meter Type": "Tipo de Contador",
            "Capacity": "Capacidade",
            "Unit of Measure": "Unidade de Medida",
            //Layout
            "label.layout.greeting": "Olá",
            // Labels Page Titles
            "label.title.testIntegration": "Testar Integração",
            "label.title.invoicing": "Modelo Tarifário e Faturação",
            "label.title.viewTariffModel": "Ver Modelo de Plano Tarifário",
            "label.title.type": "Tipo",
            "label.title.communityDetails": "Detalhes da Comunidade",
            "label.title.communityManagement": "Gestão da Comunidade",
            "label.title.consumption": "Consumo",
            "label.title.configureTariffPlan": "Configurar Plano Tarifário",
            "label.title.personalCompanyInformation": "Informação Pessoal / Empresa",
            "label.title.personalInformation": "Informação Pessoal",
            "label.title.addressInformation": "Morada",
            "label.title.fiscalFinancialInformation": "Informação Fiscal / Financeira",
            "label.title.receiptInvoicingData": "Informação de Faturação",
            "label.title.receiptHistory": "Histórico de Recebimentos",
            "label.title.newPowertradingContract": "Novo Plano Tarifário",
            "label.title.updateOMIECertificate": "Atualizar Certificado OMIE",
            "label.title.agents": "Agentes",
            "label.title.users": "Utilizadores",
            "label.title.userIdentity": "Identificação do Utilizador",
            "label.title.accountStatus": "Estado da Conta",
            "label.title.agentAuthorizations": "Autorizações de Agente",
            "label.title.groupMemberships": "Grupos",
            "label.title.userClients": "Acesso a Clientes",
            "label.menu.permissions": "Permissões",
            "label.form.agent": "Agente",
            "label.form.allAgents": "Todos os Agentes",
            "label.form.isActive": "Ativo",
            "label.table.header.group": "Grupo",
            "label.table.header.groups": "Grupos",
            "label.table.header.lastLogin": "Último Acesso",
            "label.button.addAgentAuthorization": "Adicionar Autorização",
            "label.button.addGroup": "Adicionar Grupo",
            "label.button.addClient": "Adicionar Cliente",
            "label.title.preRegisterAgent": "Pré-Registo de Agente",
            "label.agent.newEntity.step1": "Tipo de Entidade",
            "label.agent.newEntity.step1Subtitle": "Por favor selecione o tipo de entidade que deseja criar.",
            "label.agent.newEntity.step2": "Dados da Entidade",
            "label.agent.newEntity.step2Subtitle": "Por favor preencha os campos abaixo com os dados da entidade que deseja criar.",
            "label.agent.newEntity.step3": "Dados do Responsável pela Entidade",
            "label.agent.newEntity.step3Subtitle": "Por favor preencha os campos abaixo com os dados do responsável pela entidade que deseja criar.",
            "label.agent.newEntity.step4": "Confirmação",
            "label.agent.newEntity.step4Subtitle": "Por favor confirme os dados inseridos.",
            "label.agent.preRegister.step1": "Tipo de Agente",
            "label.agent.preRegister.step1Subtitle": "Antes de começar, por favor selecione um ou mais tipos de agente para o qual deseja efetuar o registo.",
            "label.agent.preRegister.step2": "Dados do Agente",
            "label.agent.preRegister.step2Subtitle": "Por favor preencha os campos abaixo com os dados do agente que deseja registar.",
            "label.agent.preRegister.step3": "Confirmação",
            "label.agent.type.aggregator": "Agregador",
            "label.agent.type.aggregatorDescription": "Entidade responsável pela agregação da eletricidade produzida, consumida e armazenada de múltiplos clientes para compra e venda no mercado grossista ou prestação de serviços de sistema.",
            "label.agent.type.egac": "EGAC",
            "label.agent.type.egacDescription": "Entidade Gestora do Autoconsumo Coletivo (EGAC) é a entidade responsável pela prática de atos de gestão operacional da atividade corrente do Autoconsumo Coletivo (ACC).",
            "label.agent.type.marketer": "Comercializadora",
            "label.agent.type.marketerDescription": "Entidade responsável pela compra de eletricidade no mercado grossista e a venda direta aos consumidores finais.",
            "label.agent.type.ese": "ESE",
            "label.agent.type.eseDescription": "Empresa de Serviços Energéticos (ESE), é a entidade responsável pelo desenvolvimento de projetos de eficiência energética.",
            "label.title.tariffModels": "Modelos de Planos Tarifários",
            "label.title.newTariffModel": "Novo Modelo de Plano Tarifário",
            "label.step.newTariffModel.businessType": "Tipo de Negócio",
            "label.step.newTariffModel.name": "Nome do Modelo",
            "label.step.newTariffModel.planType": "Tipo de Modelo de Plano Tarifário",
            "label.step.newTariffModel.energy": "Energia",
            "label.title.markets": "Mercado Diário / Intradiário",
            "label.title.paymentsAndReceiptsDetails": "Detalhes de Pagamentos e Recebimentos",
            "label.title.results": "Resultados",
            "label.title.wholesaleResults": "Resultados Mercado Grossista",
            "label.title.receivable": "Pagamentos e Recebimentos",
            "label.title.energy": "Energia",
            "label.title.programmeResults": "Resultados dos Programas",
            "label.title.programmeDate": "Data do Programa",
            "label.title.intradayMarkets": "Mercados Intra-Diários",
            "label.title.integrationsConfiguration": "Configuração de Integrações",
            "label.title.reports": "Relatórios",
            "label.title.preRegistration": "Pré-Registo",
            "label.title.activation": "Em Ativação",
            "label.title.activeContracts": "Ativos",
            "label.title.refused": "Recusados",
            "label.title.closed": "Fechados",
            "label.title.dgegData": "Dados de acesso à área reservada na DGEG",
            "label.title.egacEredesData": "Dados de acesso à área reservada da EGAC na E-Redes",
            "label.text.sensitiveDataAccessibleIndie": "Os dados inseridos nesta área são sensíveis e poderão ser visualizados por um administrador da plataforma Indie Energy para fins relacionados com obtenção de dados relacionados com a sua atividade.",
            "label.title.issueDate": "Data de Emissão",
            "label.title.dataUpload": "Carregamento de Dados de Energia",
            "label.title.uploadDocuments": "Carregar Documentos",
            "label.title.dialog.actionLog": "Histórico de Ações",
            "label.title.dialog.secretValue": "Visualizar Dados Sensíveis",
            "label.title.dialog.documentUpload": "Carregar Documentos",
            "label.title.dialog.validationLog": "Validação de Contrato",
            "label.title.editFinancialDocument": "Editar Documento",
            "label.title.editOffer": "Editar Oferta",
            "label.title.viewFinancialDocument": "Visualizar Documento",
            "label.title.notAddress": "Sem Morada",
            "label.title.noPlanSelected": "Sem Plano",
            "label.title.noProductSelected": "Sem Produto",
            "label.title.noExternalMeterId": "Código Meter Não Disponível",
            "label.title.noInstalledPower": "N/A",
            "label.title.termsAndConditions": "Termos e Condições de Utilização da Aplicação da Indie Energy",
            "label.title.privacyPolicy": "Política de Privacidade",
            "label.title.dataTreatment": "Âmbito da nossa Política de Privacidade e responsável pelo tratamento dos dados",
            "label.title.dataHandling": "Para que fins são recolhidos os dados pessoais do Utilizador?",
            "label.title.dataAccess": "Quem tem acesso aos dados pessoais do Utilizador?",
            "label.title.dataRights": "Quais são os direitos dos titulares de dados pessoais?",
            "label.title.dataSave": "Onde são guardados os dados do Utilizador?",
            "label.title.webCookies": "A equipa da Indie Energy utiliza cookies no seu Website?",
            "label.title.authorizedUse": "Utilização da APlicação Indie Energy",
            "label.title.lawsAndLitigations": "Lei Aplicável e Resolução de Litígios",
            "label.title.conditionModifications": "Alteração das Condições",
            "label.title.personalDataProtection": "Proteção de Dados Pessoais",
            "label.title.clientObligations": "Obrigações do Cliente",
            "label.title.responsabilities": "Responsabilidade",
            "label.title.definitions": "Definições",
            "label.title.overview": "Visão Geral",
            "label.title.ownership": "Propriedade",
            "label.title.loginForm": "Início de Sessão",
            "label.title.registrationForm": "Formulário de Registo",
            "label.title.search": "Pesquisa",
            "label.title.offers": "Ofertas",
            "label.title.offerDetails": "Detalhes da Oferta",
            "label.title.offerSubmission": "Submissão de Ofertas",
            "label.title.offerView": "Consulta de Ofertas",
            "label.title.physicalUnitSchedule": "Repartição por Unidade Física",
            "label.title.phf": "Programa Horário Final",
            "label.title.submitTechnicalConstraint": "Submição de Restrições",
            "label.title.searchTechnicalConstraint": "Consulta de Restrições",
            "label.title.TechnicalConstraintResolution": "Resolução de Restrições Técnicas",
            "label.technicalConstraintsOffers.strategies.maxpower": "Potência Máxima",
            "label.technicalConstraintsOffers.strategies.fixedprice": "Preço Fixo",
            "label.validationResults.title": "Resultados de Validação",
            "label.validationResults.summary.latestRun": "Última execução",
            "label.validationResults.summary.source": "Origem",
            "label.validationResults.summary.totalIssues": "Total de erros",
            "label.validationResults.subtitle.issues": "Erros",
            "label.validationResults.triggerSource.init": "Criação Automática de Oferta",
            "label.validationResults.triggerSource.updateOrCreate": "Criação/Atualização Manual de Oferta",
            "label.validationResults.triggerSource.submit": "Submissão de Oferta",
            "label.validationResults.table.severity": "Severidade",
            "label.validationResults.table.rule": "Regra",
            "label.validationResults.table.period": "Período",
            "label.validationResults.table.offerUnit": "Unidade de Oferta",
            "label.validationResults.table.message": "Mensagem",
            "label.validationResults.table.validationDate": "Data de Validação",
            "label.validationResults.severity.warning": "Aviso",
            "label.validationResults.severity.error": "Erro",
            "label.validationResults.severity.info": "Informação",
            "label.validationResults.rule.TC_REQUIRED_DIRECTIONS": "Direções Obrigatórias",
            "label.validationResults.rule.TC_NON_ZERO_DECLARED_POWER": "Potência Declarada Não Nula",
            "label.validationResults.rule.TC_DOWNWARD_FEASIBILITY": "Viabilidade de Descida",
            "label.validationResults.rule.TC_UPWARD_FEASIBILITY": "Viabilidade de Subida",
            "label.validationResults.message.TC_REQUIRED_DIRECTIONS": "As direções de subida e descida devem estar ambas representadas no período.",
            "label.validationResults.message.TC_NON_ZERO_DECLARED_POWER": "A potência declarada deve ser diferente de zero.",
            "label.validationResults.message.TC_DOWNWARD_FEASIBILITY": "A potência declarada em descida excede a potência viável em descida.",
            "label.validationResults.message.TC_UPWARD_FEASIBILITY": "A potência declarada em subida excede a potência viável em subida.",
            "label.validationResults.rule.BAND_NEED_EXCEEDED": "Necessidade de Banda Excedida",
            "label.validationResults.rule.MIN_OFFER_VALUE": "Valor Mínimo de Oferta",
            "label.validationResults.rule.BAND_PRICE_RANGE": "Intervalo de Preço de Banda",
            "label.validationResults.rule.ENERGY_PRICE_RANGE": "Intervalo de Preço de Energia",
            "label.validationResults.rule.BAND_POWER_RANGE": "Intervalo de Potência de Banda",
            "label.validationResults.rule.UNAVAILABILITY_CONFLICT": "Conflito de Indisponibilidade",
            "label.validationResults.rule.BLOCK_1_REQUIRED": "Bloco 1 Obrigatório",
            "label.validationResults.message.BAND_NEED_EXCEEDED": "A soma da potência total de todas as unidades excede a necessidade de banda para este período.",
            "label.validationResults.message.MIN_OFFER_VALUE": "A potência média está abaixo do valor mínimo exigido de 1 MW.",
            "label.validationResults.message.BAND_PRICE_RANGE": "O preço de banda está fora do intervalo permitido [0, 999,99] EUR/MW.",
            "label.validationResults.message.ENERGY_PRICE_RANGE": "O preço de energia está fora do intervalo permitido [-9999,99, 9999,99] EUR/MWh.",
            "label.validationResults.message.BAND_POWER_RANGE": "A potência total up ou down está fora do intervalo permitido [0, max_power].",
            "label.validationResults.message.UNAVAILABILITY_CONFLICT": "A unidade física tem uma indisponibilidade ativa que se sobrepõe a este período.",
            "label.validationResults.message.BLOCK_1_REQUIRED": "O bloco 1 é obrigatório mas está ausente para este período.",
            "label.validationResults.state.noOffer": "Selecione Horizonte de Programação, BSP e Unidade de Programação para carregar as respetivas validações.",
            "label.validationResults.state.contextReady": "A informação de validação está a ser apresentada para o contexto selecionado.",
            "label.validationResults.state.noValidationRun": "A oferta selecionada ainda não possui execução de validação.",
            "label.validationResults.state.noIssues": "Não existem erros de validação para o contexto atual.",
            "label.title.PDBF": "PDBF",
            "label.title.PDVP": "Programa Diário Viável Provisional",
            "label.title.submitPhysicalUnitSchedule": "Submissão de Repartições",
            "label.title.submitConsult": "Consulta de Submissões",
            "label.title.marketAgent": "Agente de Mercado",
            "label.title.marketProgramme": "Programa de Mercado",
            "label.title.contractTerms": "Termos do Contrato",
            "label.title.contractSigningandEndDates": "Assinatura / Cessação do Contrato",
            "label.title.newReportRequest": "Novo Pedido de Relatório",
            "label.title.newForecastTypeInstance": "Nova Previsão",
            "label.title.editForecastTypeInstance": "Modificar Previsão",
            "label.title.exportSurplusData": "Descarregar Documento Excedente",
            "label.title.description": "Descrição",
            "label.title.ggsDeviations": " Gestão Global de Sistema (GGS) - Desvios",
            "label.title.deviations": "Desvios",
            "label.title.referenceStartDate": "Data de Referência Inicio",
            "label.title.referenceEndDate": "Data de Referência Fim",
            "label.title.documentsUpload": "Carregar Documentos",
            "label.title.documentType": "Tipo de Documento",
            "label.title.documentHeader": "Cabeçalho do Documento",
            "label.title.documentDetails": "Detalhes do Documento",
            "label.title.productionUnits": "Unidades de Produção",
            "label.title.producerExists": "Produtor Existente",
            "label.title.viewProductionUnit": "Ver Unidade de Produção",
            "label.title.viewProcessDetails": "Ver Detalhes do Processo",
            "label.title.energyKWh": "Energia (kWh)",
            "label.title.quantity": "Quantidade",
            "label.title.entities": "Entidades",
            "label.title.newEntity": "Nova Entidade",
            "label.title.newFinancialDocument": "Novo Documento",
            "label.title.viewEntity": "Ver Entidade",
            "label.title.members": "Membros",
            "label.title.newMember": "Novo Membro",
            "label.title.viewMember": "Ver Membro",
            "label.title.contactInformation": "Dados de Contacto",
            "label.title.agentInformation": "Dados do Agente",
            "label.title.consumptionInstallation": "Instalação de Consumo",
            "label.title.technicalDetails": "Informação Técnica",
            "label.title.solarPanels": "Painéis Solares",
            "label.title.inverters": "Inversores",
            "label.title.installationLicencing": "Licenciamento da Instalação",
            "label.title.identity": "Identificação",
            "label.title.productionUnit": "Unidade de Produção (UPAC)",
            "label.title.registrationInformation": "Informação de Registo",
            "label.title.receivingConditions": "Dados e Condições de Recebimentos",
            "label.title.others": "Outras Informações",
            "label.title.invoicingInformation": "Dados de Faturação",
            "label.title.paymentInformation": "Dados para Recebimentos",
            "label.title.memberCommunity": "Dados da Comunidade",
            "label.title.viewInvoice": "Consultar Fatura",
            "label.title.invoiceInfo": "Dados de Fatura",
            "label.title.invoices": "Faturas",
            "label.title.due": "Vencidas",
            "label.title.unpaid": "Por Pagar",
            "label.title.unitValue": "Valor Unit.",
            "label.title.netTotal": "Valor Líquido",
            "label.title.taxes": "Impostos",
            "label.title.programming": "Programação",
            "label.title.discountPercentage": "Desconto",
            "label.title.discountValue": "Total com Desconto",
            "label.title.totalEnergy": "Total Energia Contratada",
            "label.title.totalAmmount": "Valor a Receber/Pagar",
            "label.title.averagePrice": "Preço Médio",
            "label.title.total": "Total",
            "label.title.all": "Todas",
            "label.title.upacOwner": "Proprietário da UPAC",
            "label.title.communities": "Comunidades",
            "label.title.communityOf": "Comunidade de",
            "label.title.newPrice": "Atualizar Preços",
            "label.title.producers": "Produtores",
            "label.title.address": "Morada",
            "label.title.meter": "Meter",
            "label.title.contactInfo": "Dados de Contacto",
            "label.title.lastReceipt": "Último Recebimento",
            "label.title.goBackConfirmation": "Deseja mesmo voltar atrás?",
            "label.title.deleteConfirmation": "Tem a certeza que deseja remover?",
            "label.title.physicalUnitDetails": "Caracterização da Instalação",
            "label.title.commercialAgentData": "Dados do Agente Comercial",
            "label.title.fileName": "Nome do Ficheiro",
            "label.title.fileTitle": "Título",
            "label.title.fileType": "Tipo de Ficheiro",
            "label.title.forecastTypes": "Tipos de Previsão",
            "label.title.uploadFiles": "Carregar Documentos",
            "label.title.contractDocuments": "Lista de Documentos",
            "label.title.noPhysicalUnit": "Sem Instalação",
            "label.title.paid": "Pagas",
            "label.title.pending": "Pendentes",
            "label.title.processed": "Processadas",
            "label.title.viewAggregator": "Ver Agregador",
            "label.title.viewAgent": "Ver Agente de Mercado",
            "label.title.processingResult": "Resultado do Processamento de Documentos",
            "label.title.approvalResult": "Resultado do Processamento de Documentos",
            "label.title.agentCodes": "Códigos REN / OMIE",
            "label.title.omieCertificate": "Certificado OMIE",
            "label.title.certificatePassword": "Password Certificado OMIE",
            "label.title.marketPhysicalUnits": "Unidades Físicas",
            "label.title.offerUnits": "Unidades de Oferta",
            "label.title.offerAreas": "Áreas de Oferta",
            "label.title.newPhysicalUnit": "Nova Unidade Física",
            "label.title.newOfferingUnit": "Nova Unidade de Oferta",
            "label.title.newOfferingArea": "Nova Área de Oferta",
            "label.text.offeringArea": "Área de Oferta",
            "label.title.viewMarketUnit": "Ver Unidade Física",
            "label.title.viewOfferUnit": "Ver Unidade de Oferta",
            "label.title.viewOfferArea": "Ver Área de Oferta",
            "label.title.installations": "Instalações",
            "label.title.details": "Dados",
            "label.title.wholesale": "Grossista",
            "label.title.technicalConstraints": "Restrições Técnicas",
            "label.title.priceSettings": "Configurações de Ofertas",
            "message.priceSettings.phase4Placeholder": "A página base de Configurações de Mercado está pronta para integrar a funcionalidade.",
            "message.priceSettings.defaultMarketFamily": "Família de mercado por omissão",
            "message.priceSettings.phase5TablePending": "A tabela de configurações será ligada na próxima fase.",
            "message.priceSettings.sessionsLoaded": "Sessões carregadas",
            "message.priceSettings.verifyIdle": "Selecione um ficheiro e execute a verificação do template.",
            "message.priceSettings.verifyRunning": "A verificar template...",
            "message.priceSettings.verifySuccess": "Template verificado com sucesso.",
            "message.priceSettings.verifyFailedWithIssues": "O template tem erros de validação e não pode ser carregado. Consulte os problemas abaixo.",
            "message.priceSettings.uploadWarning": "Após confirmar o novo template, os novos preços irão substituir os preços atuais para a sessão selecionada.",
            "label.priceSettings.uploadDialogTitle": "Carregar Novo Template",
            "label.priceSettings.session": "Sessão",
            "label.priceSettings.selectTemplateFile": "Selecionar Ficheiro Template",
            "label.priceSettings.verifyTemplate": "Verificar Template",
            "label.priceSettings.detectedRows": "Linhas detetadas",
            "label.priceSettings.blocksDetected": "Blocos detetados",
            "label.priceSettings.periodsDetected": "Períodos detetados",
            "label.priceSettings.validationIssuesByBlock": "Problemas de validação por bloco e período:",
            "message.priceSettings.validationIssueLineBlockPeriod": "Bloco {{block}}, Período {{period}}: {{error}}",
            "message.priceSettings.validationIssueLineBlock": "Bloco {{block}}: {{error}}",
            "message.priceSettings.validationIssueLinePeriod": "Período {{period}}: {{error}}",
            "message.priceSettings.validationIssueLineGeneric": "{{error}}",
            "api.error.strategy.configuration.invalidTemplateFile": "O template carregado é inválido ou não pode ser lido.",
            "api.error.strategy.configuration.emptyTemplate": "O template está vazio. Preencha pelo menos um bloco válido.",
            "api.error.strategy.configuration.uploadFileRequired": "Por favor selecione um ficheiro template.",
            "api.error.strategy.configuration.offeringUnitNotFound": "Unidade de oferta não encontrada ou sem acesso.",
            "api.error.strategy.configuration.marketSessionNotFound": "Sessão de mercado não encontrada.",
            "api.error.strategy.configuration.strategyNotFound": "Estratégia não encontrada.",
            "api.error.strategy.configuration.strategyDisabled": "A estratégia selecionada está desativada.",
            "api.error.strategy.configuration.missingFields": "Faltam campos obrigatórios para esta operação.",
            "api.error.strategy.configuration.fileMustBeVerified": "Tem de verificar o ficheiro selecionado antes de confirmar o carregamento.",
            "api.error.strategy.wh_default_prices.invalid_price": "Preço inválido. Os preços devem ser valores numéricos (Ex: 10.5).",
            "api.error.strategy.wh_default_prices.invalid_block": "Bloco inválido. O bloco deve estar entre B1 e B10.",
            "api.error.strategy.wh_default_prices.invalid_period": "Período inválido. O período deve estar entre H1Q1 e H25Q4.",
            "api.error.strategy.wh_default_prices.price_out_of_range": "Preço fora do intervalo permitido. Os valores devem estar entre 0 e 9999.9.",
            "api.error.strategy.wh_default_prices.duplicate_period_block": "Foi detetada uma combinação de bloco/período duplicada.",
            "api.error.strategy.wh_default_prices.partial_block": "Bloco parcial detetado. Cada bloco preenchido deve conter os 100 períodos.",
            "api.error.strategy.wh_default_prices.non_sequential_blocks": "Os blocos têm de ser preenchidos de forma sequencial, sem intervalos.",
            "api.error.strategy.tc_default_prices.direction_not_allowed": "A coluna direction não é permitida para preços por defeito de restrições técnicas.",
            "api.error.strategy.tc_default_prices.invalid_price": "Preço inválido. Os preços devem ser valores numéricos (Ex: 10.5).",
            "api.error.strategy.tc_default_prices.invalid_block": "Bloco inválido. O bloco deve estar entre B1 e B10.",
            "api.error.strategy.tc_default_prices.invalid_period": "Período inválido. O período deve estar entre H1Q1 e H25Q4.",
            "api.error.strategy.tc_default_prices.price_out_of_range": "Preço fora do intervalo permitido. Os valores devem estar entre 0 e 9999.9.",
            "api.error.strategy.tc_default_prices.duplicate_period_block": "Foi detetada uma combinação de bloco/período duplicada.",
            "api.error.strategy.tc_default_prices.partial_block": "Bloco parcial detetado. Cada bloco preenchido deve conter os 100 períodos.",
            "api.error.strategy.tc_default_prices.non_sequential_blocks": "Os blocos têm de ser preenchidos de forma sequencial, sem intervalos.",
            "api.error.technicalConstraintOfferManager.createVersion.noProgrammeResults": "Não existe programa PDBF para a data selecionada.",
            "api.error.techRestrictionsOffer.strategy.configurationNotFound": "Configuração de preços de oferta não definida. Por favor configure-a na página da Unidade de Oferta.",
            "api.error.techRestrictionsOffer.offerChanged": "Esta oferta foi alterada desde que começou a editar. Reveja a versão mais recente antes de continuar.",
            "api.error.techRestrictionsOffer.incompleteOfferingUnits": "Algumas Unidades de Oferta ainda não foram geradas. Gere-as antes de submeter.",
            "api.error.techRestrictionsOffer.missingPDBF": "Não existe PDBF para pelo menos uma das unidades de oferta selecionadas. Se continuar, será gerado um programa considerando a potência máxima da unidade.",
            "api.error.techRestrictionsOffer.notPending": "Esta oferta já não pode ser editada diretamente. Crie uma nova versão para continuar a editar.",
            "label.title.offerChanged": "Oferta Alterada",
            "label.title.incompleteOfferingUnits": "Unidades de Oferta em Falta",
            "label.title.missingPDBF": "PDBF em Falta",
            "label.button.quit": "Sair",
            "label.button.generateMissing": "Gerar em Falta",
            "label.button.generateWithMaxPower": "Gerar com Potência Máxima",
            "label.text.missingUnitsGenerated": "As Unidades de Oferta em falta foram geradas. Reveja a oferta e submeta novamente.",
            "error.api.createTariffPlan.installation.activeContractExist": "Existem planos tarifários ativos para esta instalação. Por favor feche-os antes de criar um novo.",
            "error.api.createTariffPlan.surplusCommunity.activeContractExist": "Existem planos tarifários ativos para esta comunidade. Por favor feche-os antes de criar um novo.",
            "label.title.viewInstallation": "Ver Instalação",
            "label.title.production": "Produção",
            "label.title.offersConfig": "Configuração de Ofertas",
            "label.title.mfrr": "mFRR",
            "label.title.surplus": "Excedente",
            "label.title.viewForecastType": "Ver Tipo de Previsão",
            "label.title.name": "Nome",
            "label.title.required": "Obrigatório?",
            "label.title.value": "Valor",
            "label.title.userProfile": "Dados de Acesso",
            "label.title.fiscalNumber": "NIF",
            "label.title.erpId": "Referência ERP",
            "label.title.default": "Usar por Omissão",
            "label.title.active": "Ativo",
            "label.title.fiscalEntities": "Entidades Fiscais",
            "label.title.notZipCode": "Sem Código Postal",
            "label.section.agentDetails": "Detalhes do Agente",
            "label.section.agentType": "Tipo de Agente",
            "label.section.respPartyDetails": "Detalhes do Responsável",
            "label.section.automaticOffers": "Ofertas Automáticas",
            "label.title.2FAAuthConfig.step1": "Autenticação de 2 Fatores",
            "label.text.2FAAuthConfig.intro": "Para garantir a segurança da sua conta, a Indie Energy disponibiliza a autenticação de 2 fatores.",
            "label.text.2FAAuthConfig.intro2": "Por favor siga os passos abaixo para configurar a autenticação de 2 fatores. Esta autenticação será usada, nesta fase, apenas na realização de algumas ações na plataforma.",
            "label.text.2FAAuthConfig.intro3": "Antes de prosseguir, confirme que tem instalado no seu telemóvel um aplicativo como Google Authenticator ou MIcrosoft Authenticator, para geração de códigos de autenticação.",
            "label.title.2FAAuthConfig.step2": "Confirmação de Password",
            "label.text.2FAAuthConfig.enterPassword": "Por favor insira a sua password atual para continuar.",
            "label.title.2FAAuthConfig.step3": "Configuração de Aplicativo de Autenticação",
            "label.title.twoFactorAuth": "Configuração de Autenticação de 2 Fatores",
            "label.text.twoFactorAuth.usage": "Na Indie Energy, a segurança dos seus dados é uma prioridade. Para garantir a segurança da sua conta, a Indie Energy disponibiliza a autenticação de 2 fatores para a realização de ações seguras.",
            "label.title.fiscalAuthorityData": "Dados de Acesso à AT",
            "label.text.fiscalAuthDataNotAccessibleIndie": "Os dados de acesso à Autoridade Tributária não são acessíveis na plataforma Indie Energy por nenhum utilizador. Serão apenas utilizados para efeitos de integração de ficheiros SAF-T com a AT, quando a funcionalidade estiver disponível.",
            "label.title.registrationData": "Dados de Registo",
            "label.title.agentData": "Dados do Agente",
            "label.title.respPartyData": "Dados do Responsável",
            "label.title.communityInvoiceDetail": "Detalhes da Fatura",
            "label.title.documentDate": "Data do Documento",
            "label.title.memberProfile": "Perfil do Membro",
            "label.title.paymentMethods": "Métodos de Pagamento",
            "label.title.paymentReceivingMethods": "Métodos de Pagamento e Recebimento",
            "label.title.contactData": "Dados de Contacto",
            "label.title.afrrOfferSubmission": "Submissão de Ofertas",
            "label.title.afrrBandNeeds": "Necessidades de Banda",
            "label.title.afrrBandSwap": "Troca de Banda",
            "label.title.afrrBandPrice": "Consulta Preço Banda Reservada",
            "label.title.afrrBandResults": "Resultados de Banda",
            "label.title.afrrBandSwitching": "Troca de Banda",
            "label.title.switchingRequest": "Pedido de Troca",
            "label.title.selectAgentAndDate": "Selecione um agente e data para visualizar os pedidos de troca",
            "label.title.selectPeriod": "Selecione um período para ver os detalhes",
            "label.title.responseAt": "Resposta em",
            "label.title.requestHour": "Hora",
            "label.title.afrrOfferSubmissionFilter": "Configuração de Ofertas",
            // Labels Buttons
            "label.button.viewDocumentHistory": "Ver Histórico",
            "label.button.viewDocument": "Visualizar Documento",
            "label.button.editDocument": "Editar Documento",
            "label.button.downloadDocument": "Descarregar Documento",
            "label.button.edit": "Modificar",
            "label.button.autoInvoicing": "Autofaturação",
            "label.button.salesDocuments": "Faturas de Venda",
            "label.button.newAutoInvoiceAgreement": "Registar Acordo Autofaturação",
            "label.button.newPaymentMethod": "Adicionar Método de Pagamento",
            "label.button.inactivate": "Inativar",
            "label.button.updateManagingEntity": "Alterar Entidade Gestora",
            "label.button.updateStatus": "Alterar Situação",
            "label.button.updateCertificate": "Atualizar Certificado",
            "label.button.configure2FA": "Configurar Dupla Autenticação",
            "label.button.registrationEmail": "Reenviar Email de Registo",
            "label.button.preRegisterAgent": "Pré-Registo de Agente",
            "label.button.downloadExcel": "Download Excel",
            "label.button.cancelOffer": "Anular Oferta",
            "label.button.submit": "Submeter",
            "label.button.submitOffer": "Submeter Oferta",
            "label.button.submitSwitchingRequest": "Submeter Pedido",
            "label.button.newRequest": "Novo Pedido",
            "label.button.newVersion": "Nova Versão",
            "label.button.addLines": "Adicionar Linhas",
            "label.button.addPartition": "Adicionar Repartição",
            "label.button.addLine": "Adicionar Linha",
            "label.title.addSwitchingLines": "Adicionar Linhas de Troca",
            "label.periodDetail": "Detalhe do período {{period}}",
            "label.original": "Original",
            "label.current": "Atual",
            "label.manualMode": "Modo Manual",
            "label.assistedMode": "Modo Assistido",
            "label.totalsMatch": "Totais coincidem",
            "label.totalsMismatch": "Totais não coincidem",
            "label.title.editLine": "Editar Linha",
            "label.button.createOffer": "Criar Oferta",
            "label.button.createOffers": "Criar Ofertas",
            "label.button.createPartition": "Criar Repartição",
            "label.button.assistedOffer": "Oferta Assistida",
            "label.button.assistedPartition": "Repartição Assistida",
            "label.text.confirmAssistedPartition": "Será criada uma repartição assistida para cada período se {{programmeCode}} estiver disponível. Caso contrário, a repartição ficará vazia.",
            "label.button.copyOffer": "Copiar Oferta",
            "label.text.confirmCopyOffer": "Será criada uma cópia editável da versão atual.",
            "label.button.manualOffer": "Oferta Manual",
            "label.button.confirm": "Confirmar",
            "label.button.configureMember": "Configurar Membro(s) de Instalação",
            "label.title.configureClient": "Configurar Cliente",
            "label.button.createClient": "Criar Cliente",
            "label.button.createInstallation": "Criar Instalação",
            "label.button.createMember": "Configurar Novo Cliente",
            "label.button.configureNewInstallation": "Configurar Nova Instalação",
            "label.step.selectClient": "Selecionar ou Criar Cliente",
            "label.step.selectClient.subtitle": "Pesquise o cliente na tabela abaixo e prima Enter, ou crie um novo.",
            "label.step.newCommunityMember.selectOrCreatePhysicalUnitStep": "Selecionar ou Criar Instalação",
            "label.step.newCommunityMember.selectOrCreatePhysicalUnitStep.subtitle": "Pesquise a instalação na tabela abaixo e prima Enter, ou crie uma nova.",
            "label.button.continue": "Continuar",
            "label.button.delete": "Remover",
            "label.button.newReportRequest": "Novo Pedido de Relatório",
            "label.button.actionLog": "Histórico de Ações",
            "label.button.actions": "Outras Ações",
            "label.button.changeSignEndContract": "Alterar Assinatura / Cessação",
            "label.button.closeContract": "Fechar",
            "label.button.reopenContract": "Reabrir",
            "label.button.updateContractTerms": "Alterar Termos",
            "label.button.newPurchaseDocument": "Novo Documento de Compra / Autofatura",
            "label.button.newAutoInvoice": "Nova Autofatura",
            "label.button.saveNewPassword": "Guardar a nova Password",
            "label.success.completeRegistration.completed": "A sua palavra-passe foi definida com sucesso. Já pode fazer login.",
            "label.error.completeRegistration.tokenExpired": "Este link de registo expirou. Por favor contacte um administrador para obter um novo.",
            "label.error.completeRegistration.tokenInvalid": "Este link de registo é inválido ou já foi utilizado.",
            "label.error.completeRegistration.failed": "Não foi possível concluir o seu registo. Por favor tente novamente mais tarde ou contacte o suporte.",
            "label.title.completeRegistration": "Complete o seu Registo",
            "label.subtitle.completeRegistration": "Bem-vindo(a), {{username}}! Escolha uma password abaixo para concluir a configuração da sua conta e começar a utilizar a plataforma Indie Energy.",
            "label.title.completeRegistrationError": "Link de Registo Inválido",
            "label.completeRegistration.alreadyRegistered": "Já concluiu o seu registo? Inicie sessão",
            "label.completeRegistration.needHelp": "Precisa de ajuda? Contacte a nossa equipa de suporte.",
            "label.message.validatingInvitation": "A validar o seu convite…",
            "label.button.recoverPassword": "Enviar Email de Recuperação de Password",
            "label.button.recoverRegistration": "Enviar Email de Recuperação de Registo",
            "label.button.agreeTermsAndConditions": "Confirmo que Li e Aceito os Termos e Condições",
            "label.button.processForecasts": "Processar Previsões",
            "label.button.newLocation": "Nova Localização",
            "label.button.process": "Processar",
            "label.button.back": "Voltar",
            "label.button.save": "Guardar",
            "label.button.assign": "Associar",
            "label.button.savePassword": "Guardar Password",
            "label.button.yes": "Sim",
            "label.button.no": "Não",
            "label.button.stay": "Ficar",
            "label.button.doNotStay": "Prosseguir",
            "label.button.update": "Atualizar",
            "label.button.upload": "Carregar Documento",
            "label.button.remove": "Remover",
            "label.button.search": "Procurar",
            "label.button.previous": "Antes",
            "label.button.procuration": "Procuração",
            "label.button.next": "Seguinte",
            "label.button.newProductionUnit": "Nova Unidade de Produção",
            "label.button.newLine": "Nova Linha",
            "label.button.newEntity": "Nova Entidade",
            "label.button.newMember": "Novo Membro",
            "label.button.newProducer": "Novo Produtor",
            "label.button.newContract": "Novo Contrato",
            "label.button.newBilateralContract": "Novo Contrato",
            "label.button.approve": "Aprovar",
            "label.button.reprocess": "Reprocessar",
            "label.button.cancel": "Cancelar",
            "label.button.export": "Exportar",
            "label.button.newInvoice": "Novo Documento",
            "label.button.new": "Novo",
            "label.button.newUser": "Novo Utilizador",
            "label.button.signin": "Iniciar Sessão",
            "label.button.register": "Registar",
            "label.button.viewProducer": "Ver Produtor",
            "label.button.expCertificate": "Lic. Exploração",
            "label.button.viewDetails": "Ver Detalhes",
            "label.button.validateActivation": "Validar Ativação de Contrato",
            "label.button.contract": "Ver Contrato",
            "label.button.contracts": "Contratos",
            "label.button.download": "Descarregar",
            "label.button.downloadBlankTemplate": "Descarregar Template",
            "label.button.uploadNewTemplate": "Carregar Novo Template",
            "label.button.uploadConfiguration": "Carregar Configuração",
            "label.button.newAggregator": "Novo Agregador",
            "label.button.close": "Fechar",
            "label.button.createNewB021PProcess": "Novo Processo de Registo na REN",
            "label.button.saveInvoicingData": "Atualizar Dados de Faturação",
            "label.button.createPhysicalUnit": "Criar Unidade Física",
            "label.button.createOfferingUnit": "Criar Unidade de Oferta",
            "label.button.createOfferingArea": "Criar Área de Oferta",
            "label.button.copy": "Copiar",
            "label.button.submitPhysicalUnitSchedule": "Submeter Repartição",
            "label.button.submitTechnicalConstraint": "Submeter Resolução",
            "label.text.createTechRestOffersDialod.subtitle": "Selecione as Unidades de Programação pretendidas para criar nova oferta automática.",
            "label.table.down": "Baixar",
            "label.table.up": "Subir",
            "label.table.price": "Preço",
            // Labels Forms
            "label.text.twoFactorAuth.enabled": "A autenticação de 2 fatores está ativa na sua conta.",
            "label.text.twoFactorAuth.notEnabled": "A autenticação de 2 fatores não está ativa na sua conta.",
            "label.text.noProductionDeliveryPointNotRequired": "A instalação selecionada não tem CPE de Produção. Não é necessário preeencher esta informação.",
            "label.text.productTaxesNotRequired": "O produto selecionado não permite a aplicação de taxas.",
            "label.text.2FAAuthConfig.scanQR": "Por favor leio o código QR abaixo com o aplicativo de autenticação no seu telemóvel.",
            "label.form.userName": "Utilizador",
            "label.form.request": "Pedido",
            "label.form.response": "Resposta",
            "label.form.fixedPriceTariff": "Tarifa Fixa (€/MWh)",
            "label.form.contract": "Contrato",
            "label.form.energyFee": "Termo variável de energia",
            "label.form.erpId": "ID ERP",
            "label.form.powerFee": "Termo fixo",
            "label.form.value": "Valor",
            "label.form.fee": "Tarifa",
            "label.table.header.configurationStatus": "Estado da Configuração",
            "label.table.header.configuredAt": "Configurado Em",
            "label.table.header.populatedTemplate": "Template Preenchido",
            "label.table.header.uploadNewTemplate": "Carregar Novo Template",
            "label.table.value.configured": "Configurado",
            "label.table.value.notConfigured": "Não Configurado",
            "message.priceSettings.noConfigurations": "Não foram encontradas configurações para a família de mercado selecionada.",
            "label.mfrr.defaultConfig.uploadDialogTitle": "Carregar Configuração mFRR por Defeito",
            "label.mfrr.defaultConfig.selectTemplateFile": "Selecionar ficheiro (.xlsx)",
            "label.mfrr.defaultConfig.verifyTemplate": "Verificar Template",
            "label.mfrr.defaultConfig.version": "Versão",
            "label.mfrr.flowDirection.U": "A subir",
            "label.mfrr.flowDirection.D": "A baixar",
            "label.mfrr.activationType.P": "Programada",
            "label.mfrr.activationType.D": "Direta",
            "label.mfrr.offerType.SD": "Simples divisível",
            "label.mfrr.offerType.SI": "Simples indivisível",
            "label.table.header.flowDirection": "Sentido",
            "label.table.header.activationType": "Tipo de Ativação",
            "label.table.header.offerType": "Tipo de Oferta",
            "message.mfrr.defaultConfig.verifyIdle": "Selecione um ficheiro e execute a verificação do template.",
            "message.mfrr.defaultConfig.verifyRunning": "A verificar template...",
            "message.mfrr.defaultConfig.verifySuccess": "Template verificado com sucesso.",
            "message.mfrr.defaultConfig.verifyFailedWithIssues": "O template tem problemas de validação e não pode ser carregado. Reveja os problemas abaixo.",
            "message.mfrr.defaultConfig.uploadWarning": "Após confirmar, a nova configuração substituirá a configuração ativa atual.",
            "message.mfrr.defaultConfig.uploadDescription": "Carregue um ficheiro Excel com os parâmetros de oferta por defeito para esta unidade física.",
            "message.mfrr.defaultConfig.noActiveConfig": "Não foi encontrada uma configuração ativa. Carregue um template para configurar as ofertas por defeito.",
            "message.mfrr.defaultConfig.noRows": "Não foram encontradas linhas de configuração.",
            "api.error.mfrr.bid.notEditable": "Esta oferta já não pode ser editada.",
            "api.error.mfrr.defaultConfig.invalidTemplateFile": "Ficheiro de template inválido. Por favor carregue um ficheiro .xlsx válido.",
            "api.error.mfrr.defaultConfig.emptyTemplate": "O ficheiro de template está vazio.",
            "api.error.mfrr.defaultConfig.missingPeriods": "Todos os 100 períodos devem estar presentes para cada sentido de regulação.",
            "api.error.mfrr.defaultConfig.duplicatePeriodDirection": "Combinação duplicada de (período, sentido) detetada.",
            "api.error.mfrr.defaultConfig.invalidPeriod": "Valor de período inválido. Deve ser um inteiro entre 1 e 100.",
            "api.error.mfrr.defaultConfig.invalidFlowDirection": "Sentido de regulação inválido. Use 'A subir' (U) ou 'A baixar' (D).",
            "api.error.mfrr.defaultConfig.invalidActivationType": "Tipo de ativação inválido. Use 'Programada' (P) ou 'Direta' (D).",
            "api.error.mfrr.defaultConfig.invalidOfferType": "Tipo de oferta inválido. Use 'Simples divisível' (SD) ou 'Simples indivisível' (SI).",
            "api.error.mfrr.defaultConfig.priceOutOfRange": "Preço fora do intervalo permitido. Deve estar entre -9999,99 e 9999,99 €/MWh.",
            "api.error.mfrr.defaultConfig.invalidPrice": "Valor de preço inválido.",
            "api.error.mfrr.defaultConfig.missingFields": "Campos obrigatórios em falta.",
            "api.error.mfrr.defaultConfig.physicalUnitNotFound": "Unidade física não encontrada.",
            "api.error.mfrr.defaultConfig.noDocumentAttached": "Nenhum documento associado a esta configuração.",
            "api.error.unavailability.missingGeneratorGroupCode": "Esta unidade física não tem o código de grupo gerador GGS configurado. Por favor configure o código antes de submeter.",
            "label.form.fee.power": "Termo fixo",
            "label.form.fee.energy": "Termo variável",
            "label.form.energy": "Energia",
            "label.form.energyTransaction": "Energia Transacionada",
            "label.form.duration": "Duração (Meses)",
            "label.form.manualInput": "Preencher Manualmente",
            "label.form.noProducer": "Não tem Membro Produtor",
            "label.form.managingEntity": "Entidade Gestora",
            "label.form.installationOwner": "Titular da Instalação?",
            "label.form.sameAsConsumer": "Utilizar dados do Membro Consumidor?",
            "label.form.uploadPhoto": "Carregar Foto",
            "label.form.delete": "Apagar",
            "label.form.type": "Tipo",
            "label.form.billingPeriod": "Ciclo de Faturação",
            "label.form.classification": "Classificação",
            "label.form.ownerName": "Nome do Titular",
            "label.form.ownerNIF": "NIF do Titular",
            "label.form.storagePowerKWh": "Potência de Armazenamento (kWh)",
            "label.form.storageCapacityKWh": "Capacidade de Armazenamento (kWh)",
            "label.form.storageCapacityKWhTotal": "Capacidade de Armazenamento Total (kWh)",
            "label.form.hasEvcp": "Tem Ponto de Carregamento de VE?",
            "label.form.dgegid": "ID DGEG",
            "label.table.header.dgegID": "ID DGEG",
            "label.table.header.puClassification": "Classificação",
            "label.form.permanentCertificate": "Código Certidão Permanente",
            "label.form.omieReferenceId": "Código OMIE",
            "label.form.omieReferenceId.helper": "Este código é o código atribuido pelo OMIE ao agregador para participação em Mercados. Será utilizado pela plataforma da Indie Energy no processamento de dados relacionados com a participação em mercados.",
            "label.form.ordReferenceId": "Código ORT",
            "label.form.ordReferenceId.helper": "Este código é o código atribuido pela REN ao agregador. Será utilizado pela plataforma da Indie Energy em integraçãoes com o ORD.",
            "label.form.2FACode": "Código de Autenticação",
            "label.form.marketAgentCompanies": "Empresa",
            "label.form.contractPowerFee": "Fee de Potência (€/kW/Dia)",
            "label.form.contracts": "Contratos",
            "label.form.id": "ID",
            "label.form.uploadedBy": "Carregado por",
            "label.form.uploadedDate": "Data de Carregamento",
            "label.form.renewContract": "Renovar Contrato",
            "label.form.code": "Código",
            "label.form.fiscalEntity": "Entidade Fiscal de Faturação",
            "label.form.marketSession": "Programa",
            "label.form.programmeDate": "Data do Programa",
            "label.form.siteid": "Site ID",
            "label.form.maxInstances": "Número Máximo de Instâncias",
            "label.form.processingResult": "Resultado",
            "label.form.singleService": "Ato Único",
            "label.form.autoinvoicing": "Autofaturação",
            "label.form.hasAutoInvoicingAgreement": "Tem Acordo de Autofaturação?",
            "label.form.isAutoInvoicingAgreement": "Regime de Autofaturação?",
            "label.title.receivingInformation": "Informação de Recebimentos",
            "label.title.paymentsInformation": "Informação de Pagamentos",
            "label.form.atcud": "ATCUD",
            "label.form.hasOpenActivity": "Atividade Aberta",
            "label.form.hasNegativePrices": "Tem Preços Negativos?",
            "label.form.contractPriceDiscount": "Desconto Comercial (%)",
            "label.form.quarterHour": "Quarto-Horário",
            "label.form.hourly": "Horário",
            "label.form.energy": "Energia",
            "label.form.endDate": "Data Fim",
            "label.form.search": "Pesquisar",
            "label.form.selectValue": "Selecionar um valor da lista.",
            "label.form.sessionNumber": "Número da Sessão",
            "label.form.programmeStartDate": "Data Início Horizonte",
            "label.form.programmeEndDate": "Data Fim Horizonte",
            "label.form.hourlyOption": "Opção Horária",
            "label.form.certifiedPower": "Potência Certificada (kW)",
            "label.form.estAnnualConsumption": "Consumo Anual Estimado",
            "label.form.title": "Título",
            "label.form.tensionLevel": "Nível Tensão",
            "label.tensionLevel.BT": "Baixa Tensão",
            "label.tensionLevel.MT": "Média Tensão",
            "label.tensionLevel.AT": "Alta Tensão",
            "label.tensionLevel.MAT": "Muito Alta Tensão",
            "label.form.deliveryPoint": "CPE",
            "label.reportParameter.allDeliveryPoints": "Todos os Pontos de Entrega",
            "label.reportParameter.deliveryPoints": "CPE de Produção",
            "label.form.zipCode": "Código Postal",
            "label.form.country": "País",
            "label.form.regulatorReferenceNumber": "Número de registo na DGEG",
            "label.form.registrationNumber": "Nº de Registo",
            "label.form.recordNumber": "Nº de Cadastro",
            "label.form.recordReferenceNumber": "Número de cadastro",
            "label.form.referenceDate": "Data de Referência",
            "label.form.referenceStartDate": "Data Início Período Faturação",
            "label.form.referenceEndDate": "Data Fim Período Faturação",
            "label.form.productionCompanyName": "Denominação do Produtor",
            "label.form.productionDeliveryPoint": "CPE de Produção",
            "label.form.productionType": "Tipo de Produção",
            "label.form.processCode": "Código de Processo",
            "label.form.oldSignDate": "Data de Assinatura Atual",
            "label.form.oldActDate": "Data de Ativação Atual",
            "label.form.newSignDate": "Nova Data de Assinatura",
            "label.form.newActDate": "Nova Data de Ativação",
            "label.form.newEndDate": "Nova Data de Cessação",
            "label.form.newTermDate": "Nova Data de Denúncia",
            "label.form.omieSolicitude": "Código Solicitude OMIE",
            "label.form.consumptionDeliveryPoint": "CPE de Consumo",
            "label.form.injectsEnergy": "Injeta Energia na Rede?",
            "label.form.installationType": "Tipo de Instalação",
            "label.form.installedPowerKWp": "Potência Instalada (kWp)",
            "label.form.installedPowerKWh": "Potência Instalada (kW)",
            "label.form.installedPowerKva": "Potência Instalada (kVA)",
            "label.form.primaryRenewableSource": "Fonte Primária Renovável",
            "label.form.technologyType": "Tipo de tecnologia utilizada",
            "label.form.systemNominalPower": "Potência nominal do sistema FV(kWp)",
            "label.form.numberOfPanels": "Número de Painéis",
            "label.form.panelPower": "Potência dos Painéis (Wp)",
            "label.form.panelManufacturer": "Fabricante dos Painéis",
            "label.form.panelModel": "Modelo dos Painéis",
            "label.form.connectedPowerKWh": "Potência de ligação (kW)",
            "label.form.injectionPower": "Potência de injeção na RESP (kW)",
            "label.form.connectedPowerKva": "Potência de ligação (kVA)",
            "label.form.generatorPowerKWh": "Potência do Gerador (kW)",
            "label.form.generatorGroupCode": "Código de Grupo Gerador GGS",
            "label.form.numberOfInverters": "Número de Inversores",
            "label.form.invertersPower": "Potência dos inversores (kW)",
            "label.form.inverterManufacturer": "Fabricante do(s) inversor(es)",
            "label.form.inverterModel": "Modelo do inversor",
            "label.form.connectedToNetwork": "Instalação ligada à RESP ?",
            "label.form.expStartDate": "Data de entrada em exploração",
            "label.form.surfaceAreaAvailable": "Área da superfície disponível",
            "label.form.surfaceAreaCovered": "Área da superfície coberta pela UPAC",
            "label.form.surfaceType": "Tipo de superfície",
            "label.form.phone": "Número de Telefone",
            "label.form.short.phone": "Telefone",
            "label.form.physicalUnitClassification": "Classificação da Instalação",
            "label.form.email": "Email",
            "label.form.name": "Nome",
            "label.form.firstName": "Primeiro Nome",
            "label.form.lastName": "Apelido",
            "label.form.agentName": "Nome do Agente",
            "label.form.contractStatus": "Estado",
            "label.form.agentEntityName": "Nome da Entidade do Agente",
            "label.form.address": "Morada",
            "label.form.respPartyName": "Nome do Responsável",
            "label.form.respPartyEmail": "Email do Responsável",
            "label.form.respPartyPhone": "Telefone do Responsável",
            "label.form.aggregator": "Agregador",
            "label.form.city": "Cidade",
            "label.form.fiscalNumber": "Número Fiscal",
            "label.form.NIF": "NIF",
            "label.form.isClient": "É Cliente?",
            "label.form.isAgent": "É Agente?",
            "label.form.isManagingEntity": "É EGAC?",
            "label.form.isSupplier": "É Fornecedor?",
            "label.form.erpSupplierID": "ID Fornecedor ERP",
            "label.form.erpCompanyID": "ID Empresa ERP",
            "label.form.erpClientID": "ID Cliente ERP",
            "label.form.community": "Comunidade",
            "label.form.companyName": "Nome / Denominação Social",
            "label.form.status": "Situação",
            "label.form.version": "Versão",
            "label.form.add": "Criar",
            "label.form.active": "Ativo",
            "label.form.startDate": "Data de Início",
            "label.form.purchasingEntityFiscalNumber": "NIF da Entidade Compradora",
            "label.form.purchasingEntityName": "Nome da Entidade Compradora",
            "label.form.sellingEntityFiscalNumber": "NIF da Entidade Vendedora",
            "label.form.sellingEntityName": "Nome da Entidade Vendedora",
            "label.form.maxContractEnergy": "Energia Máxima do Contrato (MW)",
            "label.form.initialCommunityBuyingPrice": "Preço Inicial de Compra à Comunidade",
            "label.form.initialNetworkBuyingPrice": "Preço Inicial de Compra à Rede",
            "label.form.initialSellingPrice": "Preço Inicial de Venda",
            "label.form.billingPeriod": "Ciclo de Faturação",
            "label.form.invoiceNumber": "# Fatura",
            "label.form.orderDate": "Data da Fatura",
            "label.form.billTo": "Fatura para",
            "label.form.billFrom": "Fatura de",
            "label.form.itemName": "Artigo",
            "label.form.itemQuantity": "Quantidade",
            "label.form.unitPrice": "Preço Unitário",
            "label.form.useProducerData": "Usar Dados de Produtor",
            "label.form.price": "Preço",
            "label.form.period": "Período",
            "label.form.activationType": "Tipo de Ativação",
            "label.form.divisible": "Divisibilidade",
            "label.form.flowDirection": "Sentido",
            "label.form.powerStrategy": "Estratégia de Potência",
            "label.form.priceStrategy": "Estratégia de Preço",
            "label.form.fixedPrice": "Preço Fixo",
            "label.form.activeEnergy": "Energia Ativa",
            "label.form.amount": "Valor",
            "label.form.total": "Total",
            "label.form.nextInvoiceDate": "Data da Próxima Fatura",
            "label.form.currencyCode": "Moeda",
            "label.form.power": "Potência Instalada",
            "label.form.storage": "Armazenamento",
            "label.form.prosumers": "Produtores",
            "label.form.consumers": "Consumidores",
            "label.form.members": "Membros",
            "label.form.findCommunity": "Procurar Comunidade",
            "label.form.invoiceIBAN": "IBAN Faturação",
            "label.form.paymentIBAN": "IBAN Recebimentos",
            "label.form.paymentMethod": "Método de Pagamento",
            "label.form.paymentTerms": "Condições de Pagamento",
            "label.form.receiptMethod": "Método de Recebimento",
            "label.form.receiptTerms": "Condições de Recebimento",
            "label.form.cae": "CAE",
            "label.form.username": "Utilizador",
            "label.form.password": "Palavra-Passe",
            "label.form.rememberMe": "Guardar Acesso",
            "label.form.forgotPassword": "Não sabe a Palavra-Passe? Peça uma nova aqui",
            "label.form.eInvoiceEmail": "Email Fatura Eletrónica",
            "label.form.upload": "Carregar Documentos",
            "label.form.networkPrice": "Energia na RESP",
            "label.form.invoiceNetworkCosts": "Faturar Custos de Acesso às Redes",
            "label.form.selfConsPrice": "Autoconsumo",
            "label.form.sellingPrice": "Venda Excedente",
            "label.form.locality": "Localidade",
            "label.form.district": "Distrito",
            "label.form.longitude": "Longitude (°)",
            "label.form.latitude": "Latitude (°)",
            "label.form.description": "Descrição",
            "label.form.documentType": "Tipo de Documento",
            "label.form.documentNumber": "Código Documento",
            "label.form.doorNumber": "Porta",
            "label.form.apartmentNumber": "Apartamento",
            "label.form.stay": "Ficar",
            "label.form.goToProducer": "Ir Para Produtor",
            "label.form.gcsCode": "Código da Unidade Física",
            "label.form.product": "Produto",
            "label.form.planType": "Tipo de Plano",
            "label.form.plan": "Plano",
            "label.form.energyVariableTerm": "Termo variável de energia",
            "label.form.planCommission": "Tarifa de Gestão (€/MWh)",
            "label.form.fixPlanPrice": "Preço (€/MWh)",
            "label.form.indexPlanPrcntg": "Gestão - Termo Variável",
            "label.form.signatureDate": "Data de Assinatura",
            "label.form.isAutoTermination": "Cessação de contrato na data de fim de contrato?",
            "label.form.contractTermntLeadDays": "Rescisão Contratual (Dias)",
            "label.form.contractDuration": "Duração do Contrato (Meses)",
            "label.form.contractTermntDate": "Data de Denúncia do Contrato",
            "label.form.contractActDate": "Data de Ativação do Contrato",
            "label.form.contractEndDate": "Data de Fim do Contrato",
            "label.form.freeTaxes": "Isento de IVA",
            "label.form.clearedFinances": "Finanças Regularizadas",
            "label.form.leadDays": "Dias",
            "label.form.internalSalesAgent": "Nome do Agente Comercial Interno",
            "label.form.externalPartnerName": "Empresa Parceira",
            "label.form.producer": "Produtor",
            "label.form.activationDate": "Data de Ativação",
            "label.form.deactivationDate": "Data de Desativação",
            "label.form.minPowerMwh": "Potência Minima (MW)",
            "label.form.maxPowerMwh": "Potência Máxima (MW)",
            "label.form.meter": "Meter",
            "label.form.marketAgent": "Agente de Mercado",
            "label.form.marketOfferingUnit": "Unidade de Oferta",
            "label.form.isAggregation": "É Agregação?",
            "label.form.daily": "Diário",
            "label.form.dateFrom": "De",
            "label.form.dateTo": "A",
            "label.form.weekly": "Semanal",
            "label.form.monthly": "Mensal",
            "label.form.yearly": "Anual",
            "label.form.viewBy": "Ver Por",
            "label.form.yes": "Sim",
            "label.form.no": "Não",
            "label.form.all": "Todos",
            "label.form.county": "Concelho",
            "label.form.parish": "Freguesia",
            "label.form.newPassword": "Nova Palavra Passe",
            "label.form.repeatNewPassword": "Repetir Palavra Passe",
            "label.form.forecastTypeInstance": "Previsão",
            "label.form.taxRegime": "Regime Fiscal",
            "label.form.fiscalSpace": "Espaço Fiscal",
            "label.form.communityType": "Tipo de Comunidade",
            "label.form.sharingType": "Modo de Partilha",
            "label.form.uploadDocuments": "Carregar Documentos",
            "label.form.contactSameAsProducer": "Dados de Contacto do Produtor?",
            "label.form.receiptSameAsProducer": "Dados de Recebimento do Produtor?",
            "label.form.physicalUnitAddressSameAsProducer": "Morada da Instalação igual à do Produtor?",
            "label.form.tariffModelType": "Tipo de Modelo Tarifário",
            "label.form.tariffPlan": "Plano Tarifário",
            "label.form.businessType": "Tipo de Negócio",
            "label.form.autoRenew": "Renovação Automática",
            "label.form.backofficeEmail": "Email Financeiro",
            "label.form.supportEmail": "Email de Contacto",
            "label.form.offerUnitType": "Tipo de Unidade de Oferta",
            "label.form.physicalUnitType": "Tipo de Unidade Física",
            "label.form.offerUnit": "Unidade de Oferta",
            "label.form.assignedDate": "Data de Associação",
            "label.form.networkArea": "Área de Rede",
            "label.form.offeringType": "Tipo de Oferta",
            "offering_type.venda": "Venda",
            "offering_type.compra": "Compra",
            "label.form.systemServiceMarket": "Mercado de Serviços de Sistema",
            "label.form.offerAreaType": "Tipo de Área de Oferta",
            "label.form.offerArea": "Codigo Área de Oferta",
            "label.form.optimizeSolution": "Solução de Otimização",
            "label.form.divisibleOffer": "Oferta Indivisível",
            "label.form.ddIBAN": "IBAN",
            "label.form.ddMandateReference": "Autorização de Débito em Conta (ADC)",
            "label.form.ddMaxValue": "Valor Máximo (€)",
            "label.form.sepaCreditorID": "ID do Credor SEPA",
            "label.title.generalInformation": "Informações Gerais",
            "label.title.physicalUnitConfiguration": "Configuração da Unidade Física",
            "label.title.systemServicesMarkets": "Mercados de Serviços de Sistema",
            "label.title.optimizationAndForecasts": "Otimização e Previsões",
            "label.title.deleteRecord": "Apagar Registo",
            "label.title.newBilateralContract": "Nova Contratação Bilateral",
            "label.title.entityInformation": "Informação de Entidades",
            "label.title.purchasingEntityInformation": "Entidade Compradora",
            "label.title.sellingEntityInformation": "Entidade Vendedora",
            "label.title.marketInformation": "Informação de Mercado",
            "label.title.contractIdentity": "Identidade do Contrato",
            "label.bilateralContract.isActive": "Ativo",
            "label.bilateralContract.isInactive": "Inativo (sem código de contrato)",
            "label.text.confirmDeleteRecord": "Tem a certeza que deseja apagar o registo?",
            // uom
            "label.uom.kw": "kW",
            "label.uom.mw": "MW",
            "label.uom.kwh": "kWh",
            "label.uom.mwh": "MWh",
            // Labels Side Menus
            "label.menu.inactivate": "Inativar",
            "label.menu.delete": "Remover",
            "label.menu.copy": "Copiar",
            "label.menu.tariffsPlans": "Planos Tarifários",
            "label.menu.clients": "Clientes",
            "label.menu.powertrading": "Agregação",
            "label.menu.communities": "Comunidades",
            "label.menu.energy": "Energia",
            "label.menu.tariffModels": "Modelos",
            "label.menu.entities": "Entidades",
            "label.menu.fiscalAuthority": "Autoridade Tributária",
            "label.menu.userSettings": "Definições de Utilizador",
            "label.menu.energyAgent": "Agente",
            "label.menu.sendRegistrationEmail": "Enviar Email de Registo",
            "label.menu.sendPasswordResetEmail": "Enviar Email de Reposição de Password",
            "label.menu.energyAgents": "Agentes",
            "label.menu.settlements": "Liquidações",
            "label.menu.dataUpload": "Carregamento de Dados",
            "label.menu.userDetails": "Perfil de Utilizador",
            "label.menu.invoicingDetails": "Informação de Recebimentos",
            "label.menu.voidDocument": "Anular Documento",
            "label.menu.newDocument": "Novo Documento Financeiro",
            "label.menu.marketAgent": "Agente de Mercado",
            "label.menu.viewContract": "Ver Contrato",
            "label.menu.clientArea": "Instalações",
            "label.menu.energyMarkets": "Mercados",
            "label.menu.dailyMarkets": "Mercado Diário",
            "label.menu.intraDayMarkets": "Mercado Intradiário",
            "label.menu.intraDayContinuosMarkets": "Mercado Contínuo",
            "label.menu.integrations": "Integrações",
            "label.menu.attributes": "Atributos",
            "label.menu.powertradingDocuments": "Faturação",
            "label.menu.locations": "Localizações",
            "label.menu.viewClient": "Ver Cliente",
            "label.menu.invoicingClients": "Clientes",
            "label.menu.details": "Detalhes",
            "label.menu.addressInfo": "Detalhes da Morada",
            "label.menu.addCommunity": "Nova Comunidade",
            "label.menu.aggregator": "Agregador",
            "label.menu.techInformation": "Informação Técnica",
            "label.menu.productionUnitDetails": "Detalhes",
            "label.menu.registrationInfo": "Dados de Registo",
            "label.menu.solarPanels": "Painéis Solares",
            "label.menu.inverters": "Inversores",
            "label.menu.identity": "Identificação",
            "label.menu.others": "Outros",
            "label.menu.profile": "Perfil",
            "label.menu.additional": "Outros",
            "label.menu.consumptionInstallation": "Instalação de Consumo",
            "label.menu.viewCommunity": "Ver Comunidade",
            "label.menu.productionUnit": "Unidade de Produção",
            "label.menu.storageUnit": "Unidade de Armazenamento",
            "label.menu.invoicing": "Faturação",
            "label.menu.production": "Produção",
            "label.menu.consumption": "Consumo",
            "label.menu.sales": "Faturação",
            "label.menu.documents": "Documentos",
            "label.menu.members": "Membros",
            "label.menu.invoices": "Faturas",
            "label.menu.kpis": "Indicadores",
            "label.menu.payments": "Pagamentos",
            "label.menu.paymentsAndReceipts": "Pagamentos e Recebimentos",
            "label.menu.networkAccess": "Acesso à Rede",
            "label.menu.surplus": "Excedente",
            "label.menu.dashboards": "Indicadores",
            "label.menu.management": "Gestão",
            "label.menu.marketAgents": "Agentes de Mercado",
            "label.menu.marketUnits": "Unidades Físicas",
            "label.menu.offerUnits": "Unidades de Oferta",
            "label.menu.offerAreas": "Áreas de Oferta",
            "label.menu.powerManagement": "Gestão de Energia",
            "label.menu.forecastTypes": "Tipos de Previsão",
            "label.menu.markets": "Mercados",
            "label.menu.home": "Início",
            "label.menu.purchasing": "Compra de Energia",
            "label.menu.memberArea": "Área de Membro",
            "label.menu.promotorArea": "Área do Promotor",
            "label.menu.egacArea": "Área da EGAC",
            "label.menu.myCommunities": "Minhas Comunidades",
            "label.menu.myData": "Conta",
            "label.menu.myAccount": "A minha Conta",
            "label.menu.myInvoices": "Minhas Faturas",
            "label.menu.myDocuments": "Meus Documentos",
            "label.menu.energyPrices": "Preços de Energia",
            "label.menu.energySales": "Venda de Energia",
            "label.menu.energyPurchases": "Compra de Energia",
            "label.menu.salesInvoices": "Venda de Energia",
            "label.menu.purchasesInvoices": "Compra de Energia",
            "label.menu.invoicingInformation": "Dados para Rec. / Pagamentos",
            "label.menu.egac": "Entidade Gestora (EGAC)",
            "label.menu.community": "Comunidade",
            "label.menu.receiptsPayments": "Recebimentos e Pagamentos",
            "label.menu.agentCosts": "Serviços de Gestão",
            "label.menu.balance": "Conta Corrente",
            "label.menu.aggregation": "Agregação",
            "label.menu.aggregators": "Agregadores",
            "label.menu.producers": "Produtores",
            "label.menu.contracts": "Contratos",
            "label.menu.physicalUnits": "Instalações",
            "label.menu.invoicingClient": "Clientes",
            "label.text.agentLogoNote": "Esta imagem será utilizada nos emails enviados aos clientes quando utilizar o domínio do agente.",
            "label.title.emailConfiguration": "Configuração de Envio de Email",
            "label.form.senderType": "Tipo de Remetente",
            "label.option.senderType.indie": "Serviço Indie Energy",
            "label.option.senderType.smtp": "Servidor SMTP",
            "label.text.agentEmailLogoNote": "Carregue um logótipo para aparecer nos emails (250x100 px).",
            "label.form.primaryColor": "Cor Primária da Marca",
            "label.title.smtpSettings": "Definições do Servidor SMTP",
            "label.form.smtpHost": "Host SMTP",
            "label.form.smtpPort": "Porta SMTP",
            "label.form.smtpUser": "Utilizador SMTP",
            "label.form.smtpPassword": "Password SMTP",
            "label.form.smtpSenderEmail": "Email de Envio",
            "label.form.smtpSenderName": "Nome de Envio",
            "label.menu.agents": "Agentes Comerciais",
            "label.menu.contact": "Contacto",
            "label.menu.products": "Produtos e Serviços",
            "label.menu.physicalunit": "Instalação",
            "label.menu.receipts": "Recebimentos",
            "label.menu.agent": "Agente Comercial",
            "label.menu.agentAdmin": "Administração Agente",
            "label.menu.saftFiles": "Ficheiros SAF-T",
            "label.menu.communications": "Comunicações",
            "label.menu.installationRegistration": "Registo da Instalação",
            "label.menu.installationMembers": "Instalações Membro",
            "label.menu.viewTable": "Ver Tabela",
            "label.menu.viewChart": "Ver Gráfico",
            "label.menu.termsAndConditions": "Termos e Condições",
            "label.menu.communitiesInvoicing": "Faturação de Comunidades",
            "label.menu.addCommunityInvoice": "Importar Faturas de Uso de Redes",
            "label.menu.networkUse": "Uso de Redes",
            "label.menu.networkUseInvoices": "Importação de faturas do uso de redes",
            "label.menu.communitiesTariffPlans": "Planos Tarifários de Comunidades",
            "label.menu.addCommunityTariffPlan": "Novo Plano Tarifário",
            "label.menu.changeInstallationOwner": "Transferir Titularidade da Instalação",
            "label.menu.systemServiceMarket": "Mercado Serviços Sistema",
            "label.menu.afrrDailyBand": "Banda Diária de AFRR",
            "label.menu.security": "Segurança",
            "label.menu.faqs": "Perguntas Frequentes",
            "label.menu.personalData": "Dados Pessoais",
            "label.menu.language": "Idioma",
            "label.menu.fiscalData": "Dados Fiscais e de Contacto",
            "label.menu.receiptMethods": "Métodos de Recebimento",
            "label.menu.billingAgreements": "Acordos de Autofaturação",
            // Page Titles
            "label.page.producerContracts": "Contratos do Produtor",
            "label.page.newContract": "Novo Contrato",
            "label.page.forecastTypes": "Tipos de Previsão",
            "label.page.viewForecastType": "Ver Tipo de Previsão",
            "label.page.addForecastTypeInstance": "Nova Previsão",
            // Labels Table Headers
            "label.table.header.clientName": "Nome do Cliente",
            "label.table.header.clientFiscalNumber": "NIF do Cliente",
            "lable.table.footer.rowsPerPage": "Linhas por Página",
            "lable.table.footer.of": "de",
            "label.table.header.relatedDeliverypoint": "Instalação Relacionada",
            "label.table.header.relatedType": "Tipo de Membro",
            "label.table.header.consumptionDeliverypoint": "CPE de Consumo",
            "label.table.header.connectionPower": "Potência de Ligação (kW)",
            "label.table.header.productionDeliverypoint": "CPE de Produção",
            "label.table.header.zipCode": "Código Postal",
            "label.table.header.locality": "Concelho",
            "label.table.header.agent": "Agente",
            "label.table.header.address": "Morada",
            "label.table.header.atcud": "ATCUD",
            "label.table.header.reportedSerie": "Série Comunicada",
            "label.table.header.autoInvoicing": "Autofaturação",
            "label.table.header.fixPriceValue": "Gestão - Termo Fixo",
            "label.table.header.powerFee": "Taxa de Potência",
            "label.table.header.fiscalRegime": "Regime Fiscal",
            "label.table.header.community": "Comunidade",
            "label.table.header.communityType": "Tipo de Comunidade",
            "label.table.header.communityNumber": "Código da Comunidade",
            "label.table.header.totalMembers": "Número de Membros",
            "label.table.header.totalCertifiedPower": "Potência certificada das IC (kW)",
            "label.table.header.totalProductionInstallations": "Número de UPAC(s)",
            "label.table.header.totalConnectionPower": "Potência de ligação (kW)",
            "label.table.header.totalStoragePower": "Potência de Armazenamento (kW)",
            "label.table.header.totalStorageCapacity": "Capacidade de Armazenamento (kWh)",
            "label.table.header.respName": "Nome do Responsável",
            "label.table.header.agentNIF": "NIPC do Agente",
            "label.table.header.registered": "Registado?",
            "label.table.header.hasIndieAccount": "Tem conta na Indie?",
            "label.table.header.phone": "Telefone",
            "label.table.header.email": "Email",
            "label.table.header.period": "Período",
            "label.table.header.validation": "Validação",
            "label.table.header.timestamp": "Timestamp",
            "label.table.header.reference": "Referência",
            "label.table.header.drop": "DR/OP",
            "label.table.header.receivingDate": "Data de Recebimento",
            "label.table.header.startDate": "Início Horizonte Semanal",
            "label.table.header.endDate": "Fim Horizonte Semanal",
            "label.table.header.energyTransaction": "Transação de Energia",
            "label.table.header.totalDeviationEnergy": "Total Desvio",
            "label.table.header.totalDeviationAmount": "Total Desvio (€)",
            "label.table.header.pdbf": "PDBF",
            "label.table.header.dayaheadOffer": "Oferta Diário",
            "label.table.header.pdbc": "PDBC",
            "label.table.header.cb": "CB",
            "label.table.header.technicalConstraints": "Restrições Técnicas",
            "label.table.header.pdvp": "PDVP",
            "label.table.header.intraday1Offer": "Oferta Intradiário 1",
            "label.table.header.pibci1": "PIBCI 1",
            "label.table.header.pibca1": "PIBCA 1",
            "label.table.header.intraday2Offer": "Oferta Intradiário 2",
            "label.table.header.pibci2": "PIBCI 2",
            "label.table.header.pibca2": "PIBCA 2",
            "label.table.header.intraday3Offer": "Oferta Intradiário 3",
            "label.table.header.pibci3": "PIBCI 3",
            "label.table.header.pibca3": "PIBCA 3",
            "label.table.header.pdvd": "PDVD",
            "label.table.header.planType": "Tipo de Modelo",
            "label.table.header.product": "Produto",
            "label.table.header.transaction": "Transação",
            "label.table.header.energy": "Energia",
            "label.table.header.plan": "Plano",
            "label.table.header.energyTariff": "Termo Variável de Energia",
            "label.table.header.fixedTerm": "Termo Fixo de Gestão",
            "label.table.header.variableTerm": "Termo Variável de Gestão",
            "label.table.header.plannedEnergy": "Posição Final",
            "label.table.header.actualEnergy": "Quantidade Verificada",
            "label.table.header.deviationType": "Desvio",
            "label.table.header.deviationEnergy": "Quantidade Desvio",
            "label.table.header.receiptDate": "Data de Recebimento",
            "label.table.header.horizon": "Horizonte",
            "label.table.header.offerDate": "Data da Oferta",
            "label.table.header.offerCode": "Código Oferta",
            "label.table.header.offerUnit": "Unidade de Oferta",
            "label.table.header.totalOffer": "Total da Oferta (MWh)",
            "label.table.header.programme": "Programa",
            "label.table.header.time": "Hora",
            "label.table.header.minAvailable": "Mín. Disp. (MW)",
            "label.table.header.maxAvailable": "Máx. Disp. (MW)",
            "label.table.header.afrrUp": "aFRR ↑",
            "label.table.header.afrrDown": "aFRR ↓",
            "label.table.header.code": "Código",
            "label.table.header.minPower": "Pot. Mín. (MW)",
            "label.table.header.maxPower": "Pot. Máx. (MW)",
            "label.table.header.partition": "Partição (MW)",
            "label.table.header.afrrBand": "aFRR",
            "label.table.header.minQty": "Qtd. Mín. (MW)",
            "label.table.header.maxQty": "Qtd. Máx. (MW)",
            "label.table.header.bidId": "Bid ID",
            "label.table.header.divisible": "Divisível",
            "label.table.header.regulation": "Regulação",
            "label.table.header.minQuantity": "Qtd. Mín. mFRR (MW)",
            "label.table.header.maxQuantity": "Qtd. Máx. mFRR (MW)",
            "label.table.header.offerPrice": "Preço da Oferta (€/MWh)",
            "label.table.header.periodStartTime": "Início do Período",
            "label.table.header.periodEndTime": "Fim do Período",
            "label.table.header.dateTimeAccepted": "Data/Hora Aceitação",
            "label.table.header.activationStartTime": "Início Ativação",
            "label.table.header.activationEndTime": "Fim Ativação",
            "label.table.header.volumeAccepted": "Volume Aceite (MW)",
            "label.table.header.priceAccepted": "Preço Aceite (€/MWh)",
            "label.table.header.mrid": "mRID",
            "label.table.header.session": "Sessão",
            "label.table.header.requestDate": "Data do Pedido",
            "label.table.header.createdBy": "Criado Por",
            "label.table.header.actions": "Ações",
            "label.table.header.referenceStartDate": "Início de Período",
            "label.table.header.referenceEndDate": "Fim de Período",
            "label.table.header.price": "Preço Energia (€/MW)",
            "label.table.header.physicalUnit": "Unidade Física",
            "label.table.header.forecastInstance": "Previsão",
            "label.table.header.regulatorRefID": "# DGEG",
            "label.table.header.companyName": "Empresa",
            "label.table.header.deliveryPoint": "CPE",
            "label.table.header.title": "Título",
            "label.table.header.billingPeriodStart": "Início Período de Faturação",
            "label.table.header.total": "Valor s/ IVA (€)",
            "label.table.header.totalWTaxes": "Valor c/ IVA (€)",
            "label.table.header.status": "Estado",
            "label.table.header.situation": "Situação",
            "label.table.header.step": "Passo",
            "label.table.header.description": "Descrição",
            "label.table.header.message": "Mensagem",
            "label.table.header.fiscalNumber": "NIF",
            "label.table.header.issueDate": "Data de Emissão",
            "label.table.header.cpe": "CPE",
            "label.table.header.invoiceNumber": "Fatura Nº",
            "label.table.header.dueDate": "Data de Vencimento",
            "label.table.header.name": "Nome",
            "label.table.header.createdOn": "Criado em",
            "label.table.header.contractActData": "Data Ativação",
            "label.table.header.contractEndData": "Data de Cessação",
            "label.table.header.cycle": "Ciclo",
            "label.table.header.documentNumber": "Documento",
            "label.table.header.documentType": "Tipo Documento",
            "label.table.header.details": "Detalhes",
            "label.table.header.month": "Mês",
            "label.table.header.surplus": "Excedente",
            "label.table.header.surplusEuro": "Excedente (€)",
            "label.table.header.corrections": "Correções (€)",
            "label.table.header.pending": "Pendente (€)",
            "label.table.header.paymentDate": "Data de Pagamento",
            "label.table.header.settlementDocument": "Nota de Pagamento",
            "label.table.header.pendingSettlement": "Pendente c/ IVA (€)",
            "label.table.header.omieReference": "Ref. OMIE",
            "label.table.header.orm": "Ref. REN",
            "label.table.header.processCode": "Código de Processo",
            "label.table.header.createDate": "Criado Em",
            "label.table.header.offeringUnit": "Unidade de Oferta",
            "label.table.header.maxPowerMW": "Potência Máxima (MW)",
            "label.table.header.maxSites": "Nº Máximo de Instâncias",
            "label.table.header.totalSites": "Total de Instâncias",
            "label.table.header.installationType": "Tipo de Instalação",
            "label.table.header.installedPowerkWh": "Potência Instalada (kW)",
            "label.table.header.aggregation": "É Agregação?",
            "label.table.header.physicalUnitType": "Tipo de Unidade Física",
            "label.table.header.systemServiceMarkets": "Mercados Serviços de Sistema",
            "label.table.header.offeringArea": "Código Área de Oferta",
            "label.table.header.optimizationSolution": "Solução de Otimização",
            "label.table.rowsPerPage": "Linhas por Página",
            "label.table.header.dateTime": "Data / Hora",
            "label.table.header.marketHour": "Hora de Mercado",
            "label.table.header.marketSession": "Sessão de Mercado",
            "label.table.header.marketType": "Tipo de Mercado",
            "label.table.header.version": "Versão",
            "label.table.header.fileName": "Nome do Ficheiro",
            "label.table.header.dcop": "DC/OP",
            "label.table.header.totalValue": "Total (€)",
            "label.table.header.magnitude": "Energia (MWh)",
            "label.date": "Data",
            "label.table.header.date": "Data",
            "label.table.header.sessionName": "Programa",
            "label.table.header.forecastValue": "Previsão (MWh)",
            "label.table.header.programmingValue": "Programação (MWh)",
            "label.table.header.productionValue": "Produção (MWh)",
            "label.table.header.deviationsValue": "Desvios (MWh)",
            "label.table.market.session.MD": "Mercado Diário",
            "label.table.market.session.MI1": "Mercado Intra-Diário: Sessão 1",
            "label.table.market.session.MI2": "Mercado Intra-Diário: Sessão 2",
            "label.table.market.session.MI3": "Mercado Intra-Diário: Sessão 3",
            "label.table.market.session.MI4": "Mercado Intra-Diário: Sessão 4",
            "label.table.market.session.MI5": "Mercado Intra-Diário: Sessão 5",
            "label.table.market.session.MI6": "Mercado Intra-Diário: Sessão 6",
            "label.table.market.programme.pdbf": "PDBF",
            "label.table.market.programme.pdvd": "PDVD",
            "label.table.market.programme.pdbc": "PDBC",
            "label.table.market.programme.phf": "PHF",
            "label.table.market.programme.pibci": "PIBCI",
            "label.table.market.programme.pibca": "PIBCA",
            "label.table.market.programme.pibcac": "PIBCAC",
            "label.table.market.session.MC1": "Ronda 1",
            "label.table.market.session.MC2": "Ronda 2",
            "label.table.market.session.MC3": "Ronda 3",
            "label.table.market.session.MC4": "Ronda 4",
            "label.table.market.session.MC5": "Ronda 5",
            "label.table.market.session.MC6": "Ronda 6",
            "label.table.market.session.MC7": "Ronda 7",
            "label.table.market.session.MC8": "Ronda 8",
            "label.table.market.session.MC9": "Ronda 9",
            "label.table.market.session.MC10": "Ronda 10",
            "label.table.market.session.MC11": "Ronda 11",
            "label.table.market.session.MC12": "Ronda 12",
            "label.table.market.session.MC13": "Ronda 13",
            "label.table.market.session.MC14": "Ronda 14",
            "label.table.market.session.MC15": "Ronda 15",
            "label.table.market.session.MC16": "Ronda 16",
            "label.table.market.session.MC17": "Ronda 17",
            "label.table.market.session.MC18": "Ronda 18",
            "label.table.market.session.MC19": "Ronda 19",
            "label.table.market.session.MC20": "Ronda 20",
            "label.table.market.session.MC21": "Ronda 21",
            "label.table.market.session.MC22": "Ronda 22",
            "label.table.market.session.MC23": "Ronda 23",
            "label.table.market.session.MC24": "Ronda 24",
            "label.table.market.session.MC25": "Ronda 25",
            "label.table.market.session.MC26": "Ronda 26",
            "label.table.market.session.MC27": "Ronda 27",
            "label.table.market.session.MC28": "Ronda 28",
            "label.table.market.session.MC29": "Ronda 29",
            "label.table.market.session.MC30": "Ronda 30",
            "label.table.market.session.MC31": "Ronda 31",
            "label.table.market.session.MC32": "Ronda 32",
            "label.table.market.session.MC33": "Ronda 33",
            "label.table.market.session.MC34": "Ronda 34",
            "label.table.market.session.MC35": "Ronda 35",
            "label.table.market.session.MC36": "Ronda 36",
            "label.table.market.session.MC37": "Ronda 37",
            "label.table.market.session.MC38": "Ronda 38",
            "label.table.market.session.MC39": "Ronda 39",
            "label.table.market.session.MC40": "Ronda 40",
            "label.table.market.session.MC41": "Ronda 41",
            "label.table.market.session.MC42": "Ronda 42",
            "label.table.market.session.MC43": "Ronda 43",
            "label.table.market.session.MC44": "Ronda 44",
            "label.table.market.session.MC45": "Ronda 45",
            "label.table.market.session.MC46": "Ronda 46",
            "label.table.market.session.MC47": "Ronda 47",
            "label.table.market.session.MC48": "Ronda 48",
            "label.table.market.session.MC49": "Ronda 49",
            "label.table.market.session.MC50": "Ronda 50",
            "label.table.market.session.MC51": "Ronda 51",
            "label.table.market.session.MC52": "Ronda 52",
            "label.table.market.session.MC53": "Ronda 53",
            "label.table.market.session.MC54": "Ronda 54",
            "label.table.market.session.MC55": "Ronda 55",
            "label.table.market.session.MC56": "Ronda 56",
            "label.table.market.session.MC57": "Ronda 57",
            "label.table.market.session.MC58": "Ronda 58",
            "label.table.market.session.MC59": "Ronda 59",
            "label.table.market.session.MC60": "Ronda 60",
            "label.table.market.session.MC61": "Ronda 61",
            "label.table.market.session.MC62": "Ronda 62",
            "label.table.market.session.MC63": "Ronda 63",
            "label.table.market.session.MC64": "Ronda 64",
            "label.table.market.session.MC65": "Ronda 65",
            "label.table.market.session.MC66": "Ronda 66",
            "label.table.market.session.MC67": "Ronda 67",
            "label.table.market.session.MC68": "Ronda 68",
            "label.table.market.session.MC69": "Ronda 69",
            "label.table.market.session.MC70": "Ronda 70",
            "label.table.market.session.MC71": "Ronda 71",
            "label.table.market.session.MC72": "Ronda 72",
            "label.table.market.session.MC73": "Ronda 73",
            "label.table.market.session.MC74": "Ronda 74",
            "label.table.market.session.MC75": "Ronda 75",
            "label.table.market.session.MC76": "Ronda 76",
            "label.table.market.session.MC77": "Ronda 77",
            "label.table.market.session.MC78": "Ronda 78",
            "label.table.market.session.MC79": "Ronda 79",
            "label.table.market.session.MC80": "Ronda 80",
            "label.table.market.session.MC81": "Ronda 81",
            "label.table.market.session.MC82": "Ronda 82",
            "label.table.market.session.MC83": "Ronda 83",
            "label.table.market.session.MC84": "Ronda 84",
            "label.table.market.session.MC85": "Ronda 85",
            "label.table.market.session.MC86": "Ronda 86",
            "label.table.market.session.MC87": "Ronda 87",
            "label.table.market.session.MC88": "Ronda 88",
            "label.table.market.session.MC89": "Ronda 89",
            "label.table.market.session.MC90": "Ronda 90",
            "label.table.market.session.MC91": "Ronda 91",
            "label.table.market.session.MC92": "Ronda 92",
            "label.table.market.session.MC93": "Ronda 93",
            "label.table.market.session.MC94": "Ronda 94",
            "label.table.market.session.MC95": "Ronda 95",
            "label.table.market.session.MC96": "Ronda 96",
            "label.table.market.session.MC97": "Ronda 97",
            "label.table.market.session.MC98": "Ronda 98",
            "label.table.market.session.MC99": "Ronda 99",
            "label.table.market.session.MC100": "Ronda 100",
            "label.table.header.egacName": "EGAC",
            "label.table.header.communityName": "Comunidade",
            "label.table.header.documentDate": "Data do Documento",
            "label.table.header.invoicingStartDate": "Data Inicial",
            "label.table.header.invoicingEndDate": "Data Final",
            "label.table.header.valueExcludingIVA": "Valor s/IVA (€)",
            "label.table.header.valueWithIVA": "Valor c/IVA (€)",
            "label.table.header.averagePrice": "Preço médio (€/kWh)",
            "label.table.header.selfConsumptionRESP": "Autoconsumo RESP (kWh)",
            "label.table.header.processId": "ID Fatura",
            "label.table.header.unit": "Unidade",
            "label.table.header.quantity": "Quantidade",
            "label.table.header.invoicePrice": "Preço (€)",
            "label.table.header.iva": "Taxa de IVA (%)",
            // Labels KPIs
            "label.kpi.averagePrice": "Preço Médio Desvio (€)",
            "label.kpi.totalQuantity": "Desvio Energia(MWh)",
            "label.kpi.totalSettlement": "Desvio Energia (€)",
            "label.kpi.group.excessDeviations": "Desvios por Excesso",
            "label.kpi.group.defectDeviations": "Desvios por Defeito",
            "label.kpi.group.balanceSummary": "Balanço",
            "label.kpi.averageExcessPrice": "Preço Médio dos Desvios por Excesso",
            "label.kpi.averageDefectPrice": "Preço Médio dos Desvios por Defeito",
            "label.kpi.totalExcessQuantity": "Desvios por Excesso de Energia (MWh)",
            "label.kpi.totalDefectQuantity": "Desvios por Defeito de Energia (MWh)",
            "label.kpi.totalExcessSettlement": "Desvios por Excesso de Energia (€)",
            "label.kpi.totalDefectSettlement": "Desvios por Defeito de Energia (€)",
            "label.kpi.totalDeviationEnergy": "Saldo (MWh)",
            "label.kpi.totalDeviationSettlement": "Saldo (€)",
            "label.kpi.total": "Total",
            "label.kpi.salesTotal": "Total",
            "label.kpi.dueInvoices": "Faturas Vencidas",
            "label.kpi.expiredInvoices": "Faturas Expiradas",
            "label.kpi.salesSurplus": "Excedente",
            "label.kpi.salesCommunity": "Comunidade",
            "label.kpi.salesSelfConsumption": "Autoconsumo",
            "label.kpi.costsTotal": "Custos",
            "label.kpi.capacity": "Potência",
            "label.kpi.internal": "Rede Interna",
            "label.kpi.externalNetwork": "Rede Externa",
            "label.kpi.prosumers": "Produtores",
            "label.kpi.members": "Membros",
            "label.kpi.storage": "Armazenamento",
            "label.kpi.sharedEnergy": "Energia Partilhada",
            "label.kpi.surplus": "Excedente",
            "label.kpi.networkCosts": "Acesso Redes",
            "label.kpi.managementCosts": "Custos de Gestão",
            "label.kpi.selfConsumption": "Autoconsumo",
            "label.kpi.community": "Comunidade",
            "label.kpi.supplier": "Comercializador",
            "label.kpi.totalConsumption": "Consumo Total",
            "label.kpi.totalProduction": "Produção Total",
            // I2 - Produção Total na UPAC
            "label.kpi.i2": "Produção Total",
            // I4 - Energia Partilhada pela IC
            "label.kpi.i4": "Energia Partilhada",
            // I8 - Excedente de Energia na IC
            "label.kpi.i8": "Excedente",
            // I9 - Consumo Fornecido à IC pelo Comercializador
            "label.kpi.i9": "Comercializador",
            // I10 - Autoconsumo na IC
            "label.kpi.i10": "Autoconsumo",
            // I11 - Autoconsumo através da RESP
            "label.kpi.i11": "Comunidade",
            // I13 - Faturação do Autoconsumo na IC
            "label.kpi.i13": "Autoconsumo (€)",
            // I14 - Faturação do Autoconsumo através da RESP na IC
            "label.kpi.i14": "Comunidade (€)",
            // I17 - Faturação de Energia Autoconsumida pela CE
            "label.kpi.i17": "Comunidade (€)",
            // I19 - Faturação do Excedente de Energia na CE
            "label.kpi.i19": "Excedente (€)",
            // I21 - Custos de Acesso à Rede
            "label.kpi.i21": "Custos com Acesso às Redes (€)",
            // I22 - Custos de Gestão da Comunidade
            "label.kpi.i22": "Custos com Gestão da Comunidade (€)",
            // I23 - Pagamento de Energia Vendida
            "label.kpi.i23": "Venda de Energia (€)",
            // I26 - Excedente de Energia na CE partilhada pela IC
            "label.kpi.i26": "Energia Partilhada através da RESP (MWh) Excedente",

            // Chart Labels
            "label.chart.networkAccessConsumption": "Custos com Acesso às Redes da Energia Consumida (€)",
            "label.chart.networkAccessShared": "Custos com Acesso às Redes da Energia Partilhada (€)",
            "label.chart.surplus": "Excedente (€)",
            "label.chart.sales": "Compra de Energia (€)",
            "label.chart.payments": "Venda de Energia (€)",
            "label.chart.receipts": "Recebimentos (€)",
            "label.chart.revenueCosts": "Faturação de Energia Partilhada e Custos (€)",
            "label.chart.title.programmingVsForecasts": "Comparação de Previsão e Programação (MWh)",
            "label.chart.title.receipts": "Recebimentos (€)",
            "label.chart.title.production": "Produção (MWh)",
            "label.chart.series.forecasts": "Previsão (MWh)",
            "label.chart.series.programming": "Programação (MWh)",
            "label.chart.series.prices": "Preço (€/MWh)",
            "label.chart.series.production": "Energia Produzia (MWh)",
            "label.chart.series.deviations": "Desvios (MWh)",
            // Navigation Labels
            "label.nav.home": "Início",
            "label.nav.consumptionInstallations": "Instalações de Consumo",
            // Fixed Options
            "label.option.upac": "UPAC",
            "label.option.upacia": "UPAC+IA",
            "label.option.ia": "IA",
            "label.option.ip": "IP",
            "label.option.ic": "IC",
            // Deviation Types
            "label.deviation.defect": "Defeito",
            "label.deviation.excess": "Excesso",
            "label.drop.payment": "Pagamento",
            "label.drop.receiving": "Recebimento",
            // Document Void Stepper
            "label.step.confirmDocument": "Confirmar Documento a Anular",
            "label.step.warningConfirmation": "Confirme que este é o documento a anular, depois de realizada esta ação não será possível voltar atrás. Será criada uma nota de crédito que anula este documento na totalidade.",
            // Document Create Stepper
            "label.step.confirmDocumentToCreate": "Confirmar Dados Documento",
            "label.step.confirmDocumentDates": "Confirmar Datas do Documento",
            // Registration Form
            "label.step.termsAndConditions": "Termos e Condições",
            "label.step.userRegistration": "Dados de Registo",
            "label.step.userRegistrationComplete": "Registo Completo",
            "label.step.chooseReport": "Escolher o Relatório",
            "label.step.configureReport": "Configurar o Relatório",
            "label.step.confirmReport": "Confirmar o Relatório",
            // Create Autoinvoice Agreement
            "label.step.newAutoinvoiceAgreement.selectAgentEntity": "Selecionar Entidade",
            // New Community Form
            "label.step.newCommunity.communityDataStep": "Identificação da Comunidade",
            "label.step.newCommunity.communityDataStep.subtitle": "Introduza os dados de identificação da comunidade na DGEG.",
            "label.step.newCommunity.communityTypeStep": "Tipo de Comunidade",
            "label.step.newCommunity.communityTypeStep.subtitle": "Vamos começar por definir o tipo de comunidade a criar. Que tipo de comunidade pretende criar?",
            "label.step.newAgentCommunity.communityTypeStep.subtitle": "Que tipo de comunidade pretende criar?",
            "label.step.newAgentCommunity.communityBusinessTypeStep.subtitle": "Vamos começar por definir o tipo de negócio. Que tipo de negócio pretende?",
            "label.step.newCommunity.communitySharingTypeStep": "Modo de Partilha",
            "label.step.newCommunity.communitySharingTypeStep.subtitle": "As As comunidades podem ter diferentes modos de partilha. Qual o modo de partilha que pretende selecionar?",
            "label.step.newCommunity.communityStatusStep": "Estado da Comunidade",
            "label.step.newCommunity.communityStatusStep.subtitle": "Identifique por favor em que estado se encontra o processo de registo da comunidade.",
            "label.step.newCommunity.communityEGACStep": "Entidade Gestora",
            "label.step.newCommunity.communityEGACStep.subtitle": "Quem será a entidade gestora desta comunidade?",
            "label.step.newCommunity.confirmationStep": "Confirmação",
            "label.step.newCommunity.confirmationStep.subtitle": "Confirme os dados da comunidade a criar.",
            "label.step.newCommunity.respParty": "Responsável",
            "label.step.newCommunity.bannerUploadStep": "Imagem de Perfil",
            "label.step.newCommunity.bannerUpload.subtitle": "Adicione uma imagem de perfil para a comunidade.",
            "label.step.newCommunity.businessModelStep": "Tipo de Modelo de Plano Tarifário",
            "label.step.newCommunity.businessModelStep.subtitle": "Selecione o tipo de modelo de plano tarifário que deverá ser aplicado à energia partilhada na comunidade.",
            "label.step.newCommunity.communityNetworkCostsStep": "Faturação",
            "label.step.newCommunity.communityNetworkCostsStep.subtitle": "Indique como será realizada a faturação de uso de redes na comunidade o ciclo de faturação e as condições de pagamento dos documentos.",
            // New Community Member Form
            "label.step.newCommunityMember.introduction": "Introdução",
            "label.step.newCommunityMember.introduction.subtitle": "Antes de começar, confirme por favor que tem acesso a todos os dados necessários para completar o registo de um novo membro de comunidade.",
            "label.step.newCommunityMember.introduction.text": "<ul><li>Dados de Registo do Cliente na DGEG</li><li>Tipo de Instalação / Tipo de Produção</li><li>Morada da Instalação</li><li>Dados de Licenciamento da Instalação</li></ul>",
            "label.step.newCommunityMember.selectCommunityStep": "Comunidade",
            "label.step.newCommunityMember.selectCommunityStep.subtitle": "Selecione a comunidade à qual pretende adicionar um novo membro.",
            "label.step.newCommunityInstallation.selectCommunityStep.subtitle": "Selecione a comunidade à qual pretende adicionar uma nova instalação.",
            "label.step.newCommunityMember.memberDataStep": "Dados do Membro",
            "label.step.newCommunityMember.memberDataStep.subtitle": "Introduza por favor a informação base relativa ao novo membro da comunidade..",
            "label.step.newCommunityMember.installationClassificationStep": "Classificação da Instalação",
            "label.step.newCommunityMember.installationClassificationStep.subtitle": "Classifique a instalação do novo membro da comunidade.",
            "label.step.newCommunityMember.installationAddressStep": "Morada da Instalação",
            "label.step.newCommunityMember.installationAddressStep.subtitle": "Introduza por favor a morada da instalação do novo membro da comunidade.",
            "label.step.newCommunityMember.installationDetailsStep": "Detalhes da Instalação",
            "label.step.newCommunityMember.installationDetailsStep.subtitle": "Introduza por favor os detalhes da instalação do novo membro da comunidade.",
            "label.step.newCommunityMember.installationDetailsStep.installationData": "Instalação",
            "label.step.newCommunityMember.installationDetailsStep.productionInstallationData": "Produção",
            "label.step.newCommunityMember.installationDetailsStep.storageInstallationData": "Armazenamento",
            "label.step.newCommunityMember.physicalUnitOwnerStep": "Titular da Instalação",
            "label.step.newCommunityMember.physicalUnitOwnerStep.subtitle": "Introduza por favor os dados do titular da instalação do novo membro da comunidade.",
            "label.step.newCommunityMember.installationDetailsStep.licensingDetails": "Licenciamento da Instalação",
            "label.step.newCommunityMember.elctricityMarketDataStep": "Dados de Mercado de Eletricidade",
            "label.step.newCommunityMember.elctricityMarketDataStep.subtitle": "Introduza por favor os dados de mercado de eletricidade do novo membro da comunidade.",
            "label.step.newCommunityMember.confirmationStep": "Confirmação",
            "label.step.newCommunityMember.confirmationStep.subtitle": "Confirme os dados do novo membro da comunidade.",
            "label.step.newCommunityMember.installationTypeStep": "Tipo de Instalação",
            "label.step.newCommunityMember.installationTypeStep.subtitle": "Selecione o tipo de instalação do novo membro da comunidade.",
            // New Community Tariff Plan Form
            "label.step.newCommunityTariffPlan.communityCodeStep": "Comunidade",
            "label.step.newCommunityTariffPlan.communityCodeStep.subtitle": "Selecione a Comunidade onde vai criar o plano tarifário.",
            "label.step.newCommunityTariffPlan.tariffModelStep": "Modelo de Plano Tarifário",
            "label.step.newCommunityTariffPlan.tariffModelStep.subtitle": "Selecione o modelo de plano tarifário pretendido.",
            "label.step.newCommunityTariffPlan.communityMembersStep": "Membros da Comunidade",
            "label.step.newCommunityTariffPlan.communityMembersStep.subtitle": "Para que membros da comunidade pretende associar este plano?",
            "label.step.newCommunityTariffPlan.activationDateStep": "Data de Ativação",
            "label.step.newCommunityTariffPlan.confirmationStep": "Confirmação",
            "label.step.newCommunityTariffPlan.confirmationStep.subtitle": "Confirme os dados do plano a criar.",

            "label.step.selectInstallation": "Instalação",
            "label.step.selectConsumerMember": "Membro Consumidor",
            "label.step.selectProducerMember": "Membro Produtor",
            "label.step.confirm": "Confirmação",
            "label.step.confirm.subtitle": "Confirme os dados do cliente da instalação.",

            "label.installationType.consumptionInstallation": "Instalação de Consumo (IC)",
            "label.installationType.consumptionInstallationDescription": "Instalação elétrica que pode consumir, armazenar ou produzir energia elétrica para autoconsumo.",
            "label.installationType.productionInstallation": "Instalação de Produção (IPr)",
            "label.installationType.productionInstallationDescription": "Instalação elétrica licenciada para efeitos de produção de energia elétrica.",
            "label.installationType.batteryInstallation": "Instalação de Armazenamento (IA)",
            "label.installationType.batteryInstallationDescription": "Instalação elétrica licenciada para efeitos de armazenamento de energia renovável",

            "label.installationClassification.consumptionInstallationNoProductionWithStorage": "Instalação de Consumo com Armazenamento",
            "label.installationClassification.consumptionInstallationNoProductionWithStorageDescription": "Consome e armazena energia elétrica da rede.",
            "label.installationClassification.consumptionInstallationNoProduction": "Instalação de Consumo",
            "label.installationClassification.consumptionInstallationNoProductionDescription": "Apenas consome energia elétrica da rede",
            "label.installationClassification.consumptionInstallationWithProduction": "Instalação de Consumo com UPAC",
            "label.installationClassification.consumptionInstallationWithProductionDescription": "Consome e produz energia elétrica para autoconsumo.",
            "label.installationClassification.consumptionInstallationWithProductionAndStorage": "Instalação de Consumo com UPAC e Armazenamento",
            "label.installationClassification.consumptionInstallationWithProductionAndStorageDescription": "Consome, armazena e produz energia elétrica para autoconsumo.",
            "label.installationClassification.productionInstallationNoConsumption": "Instalação de Produção",
            "label.installationClassification.productionInstallationNoConsumptionDescription": "Instalação que apenas produz energia.",
            "label.installationClassification.productionInstallation": "Instalação de Produção",
            "label.installationClassification.productionInstallationDescription": "Produz energia elétrica para injeção total na rede.",
            "label.installationClassification.productionInstallationWithStorage": "Instalação de Produção com Armazenamento",
            "label.installationClassification.productionInstallationWithStorageDescription": "Produz e armazena energia elétrica para injeção total na rede.",
            "label.installationClassification.storageInstallation": "Instalação de Armazenamento",
            "label.installationClassification.storageInstallationDescription": "Instalação que armazena energia.",
            "label.form.selectInstallationTypeFirst": "Selecione o Tipo de Instalação",
            "label.form.installationClassification": "Classificação da Instalação",
            "label.form.totalMembers": "Número de Membros",
            "label.form.client": "Cliente",
            // Viewable Secret 
            "label.step.secret.insertCode": "Inserir Código de Autenticação Dois Fatores",
            "label.step.secret.viewData": "Visualizar Informação",
            // Success Messages
            "success.api.delete": "Registo removido com sucesso!",
            "success.api.create": "Registo criado com sucesso!",
            "success.api.save": "Registo atualizado com sucesso!",
            "api.success.save": "Registo atualizado com sucesso!",
            "api.success.sentRegistrationEmail": "Email de registo enviado com sucesso!",
            "success.message.foundProgramme": "Programa já existente foi encontrado.",
            "success.message.programProcessed": "Programa processado e informação atualizada.",
            "success.message.passwordResetEmail": "Foi enviado um email com as instruções para reset de password.",
            "success.message.registrationEmail": "Foi enviado um email com as instruções para registo de utilizador.",
            "success.message.offerCreated": "Oferta criada com sucesso.",
            "success.message.marketSessionInfoLoaded": "Carregada informação de sessões de mercado.",
            "success.message.agentEntityCreated": "Entidade criada com sucesso.",
            "success.message.filesUploaded": "Ficheiros enviados com sucesso.",
            "message.agent.emailSent": "Email de registo enviado com sucesso.",
            "success.api.submittingFile": "Submissão realizada com sucesso.",
            // Error Messages
            "error.forms.maxLength": "O campo deve ter no máximo {{max}} caracteres.",
            "errors.forms.minimumLength": "O campo deve ter pelo menos {{min}} caracteres.",
            "error.api.marketSessionLoadingError": "Não foi possível carregar informação de sessões de mercado.",
            "error.pages.notFound": "A página que procura não foi encontrada!",
            "error.forms.latitudeFormat": "A latitude deve ter no máximo 5 casas decimais e ser um valor entre 90 e -90",
            "error.forms.longitudeFormat": "A latitude deve ter no máximo 5 casas decimais e ser um valor entre 180 e -180",
            "error.forms.errors": "Existem erros no formulário. Corrija-os e volte a tentar!",
            "error.forms.mandatory": "Este campo é obrigatório!",
            "error.forms.email": "Endereço de email inválido",
            "error.forms.numeric": "Este campo é numérico!",
            "error.forms.positiveNumber": "Este campo deve ser um número positivo!",
            "error.forms.negativeNumber": "Este campo deve ser um número negativo!",
            "error.forms.nonZeroNumber": "Este campo não pode ser 0!",
            "error.forms.commaNumber": "Este campo deve ser um número positivo! Se for o caso, substitua a vírgula por um ponto.",
            "error.forms.emailFormat": "Formato de Email inválido!",
            "error.forms.caeFormat": "Formato do CAE inválido!",
            "error.forms.zipCodeFormat": "Formato do Código Postal inválido!",
            "error.forms.maxDecimalPlaces": "O número de casas decimais não pode ser superior a {{decimalPlaces}}.",
            "error.api.save": "Ocorreu um erro ao gravar este registo!",
            "error.api.loadingList": "Ocorreu um erro ao carregar a lista!",
            "error.api.generic": "Ocorreu um erro na comunicação com o servidor.",
            "error.forms.contracts.deliveryPointContractExists": "Já existe um contrato ativo para o CPE/Produto selecionados e não é possível ter dois contratos ativos. Corrija o CPE ou o Produto.",
            "error.forms.contracts.minActDate": "Data de Ativação tem de ser posterior à data de assinatura.",
            "error.form.findocs.notProcessed": "Não foi possível processar os documentos.",
            "error.form.positiveNumber": "Deve ser um número superior a 0",
            "error.forms.installationTypeRequired": "Tipo de Instalação é de preenchimento obrigatório.",
            "error.forms.aggregationTypeRequired": "Indicação de Agregação é de preenchimento obrigatório.",
            "error.forms.datesMandatory": "As datas de Início e fim são de preenchimento obrigatório.",
            "error.forms.maxPeriodTwelveMonths": "O período máximo de pesquisa são 12 meses.",
            "error.forms.endDateSuperiorStartDate": "A Data Fim deve ser superior à Data de Início.",
            "error.forms.endDateAfterStartDate": "A Data Fim deve ser superior à Data de Início.",
            "error.forms.startDateInFuture": "A data de início deve ser no futuro.",
            "error.forms.fiscalNumber": "Número de identificação fiscal (NIF) inválido.",
            "error.forms.maxPeriodOneMonth": "O período máximo de pesquisa é de 1 mês.",
            "error.api.contract.productionDeliveryPointExists": "O CPE de Produção já se encontra associado a outra instalação.",
            "error.api.contract.consumptionDeliveryPointExists": "O CPE de Consumo já se encontra associado a outra instalação.",
            "error.api.mandatoryClosingDate": "Data de Fecho é de preenchimento obrigatório.",
            "error.api.closingDateInFuture": "Data de Fecho deve ser menor ou igual à data atual.",
            "error.forms.marketagent.passwordIdentical": "As passwords têm de ser idênticas.",
            "error.api.contract.physicalUnitAlreadyAtUse": "Unidade Física já se encontra associada a outra Instalação.",
            "error.forms.findocs.noContractInfo": "Sem dados de contrato. A redirecionar para a página de contrato.",
            "error.forms.dateInFuture": "Esta data não pode estar no futuro",
            "error.forms.register.fiscalNumberNotFound": "Dados de Registo Inválidos.",
            "error.forms.fiscalNumberDigits": "NIF tem de ter 9 dígitos.",
            "error.forms.fiscalNumberInvalid": "NIF é inválido.",
            "error.forms.register.tokenFiscalNumberCombinationNotValid": "Autorização de registo expirada ou inválida.",
            "errors.forms.minimumLengthTen": "A password deve ter um minimo de 10 caracteres.",
            "error.forms.invalidIBAN": "IBAN inválido. Verifique pff que inseriu corretamente o IBAN.",
            "error.forms.invalidCPE": "CPE inválido.",
            "error.forms.missingContractID": "ID de Contrato é obrigatório para atualizar o contrato.",
            "errors.forms.passwordComplexity": "A password deve conter pelo menos: uma letra minuscula/maiscula, um digito e um caracter especial (!@#\$%^&*_). ",
            "error.forms.newCommunity.noEGACEntities": "Não existem entidades gestoras disponíveis. Aceda à sua área de Agente e configure entidades gestoras de comunidades.",
            "error.forms.newInstallation.noEntityClients": "Não existem clientes disponíveis para o Agente selecionado.",
            "error.forms.newProducer.noAggregatorEntities": "Não existem entidades agregadoras disponíveis. Aceda à sua área de Agente e configure entidades agregadoras.",
            "error.api.loadingContract": "Erro a carregar os dados do contrato. Atualize a página e tente novamente.",
            "error.forms.onlyOneItemcanBeDefault": "Só pode escolher uma entrada por omissão!",
            "error.forms.mustHaveOneDefault": "Tem de escolher uma entrada por omissão!",
            "error.api.fetchEntity": "Erro ao buscar entidade:",
            "error.api.submitingFile": "Ocorreu um erro ao submeter ficheiro. Por favor contacte o suporte.",
            "error.api.minBandwidthExceedsMax": "O valor mínimo de largura de banda não pode ser superior ao valor máximo.",
            "error.api.trading.physicalUnitNameExists": "Já existe uma unidade fisíca com o mesmo nome.",
            "error.api.trading.offerAlreadyExists": "Oferta já existente para a Unidade de Oferta selecionada.",
            "error.api.trading.offerTotalValueZero": "Para submeter em mercado, o valor total da oferta não pode ser 0.",
            "error.api.trading.offerSessionAlreadyClosed": "Sessão de mercado já fechada. Não é possível submeter a oferta.",
            "error.api.trading.phfNotAvailable": "Resultados de Programa ainda não estão disponíveis, não é possível criar a oferta.",
            "error.api.fiscalNumberNotFound": "NIF não identificado. Contacte o seu Agente de Mercado.",
            "error.api.registrationProcessNotStarted": "Processo de Registo não concluído para o NIF em causa. Solicite uma nova Chave de Registo.",
            "error.api.userAlreadyRegistered": "Processo de Registo já realizado para este NIF. Avance para o Login ou Pedido de nova Senha",
            "error.api.tokenExpired": "Chave de Registo expirada. Utilize o link para Pedir Email de Registo.",
            "error.api.unexpectedError": "Ocorreu um erro inesperado. Contacte o suporte da Plataforma.",
            "error.api.registrationNotComplete": "Processo de Registo não concluído para o NIF em causa. Solicite uma nova Chave de Registo.",
            "error.api.loginNotAuthorized": "Utilizador não registado ou combinação utilizador/password inválida.",
            "error.api.loginUnknown": "Ocorreu um erro desconhecido ao realizar o início de sessão. Contacte pff o nosso Suporte.",
            "error.api.fiscalNumbernoContracts": "Não foi encontrado nenhum contrato associado ao NIF. Contacte o seu agente de mercado.",
            "error.api.contractHasNoReceiptEntity": "É obrigatório definir uma entidade de recebimentos para o contrato.",
            "error.api.receiptEntityNoTaxRegime": "É obrigatório selecionar um Regime de Impostos para a entidade de recebimentos.",
            "error.api.contractTermsAfterClosingDate": "A data de fecho tem de ser superior ao ínicio dos últimos termos contratuais.",
            "error.api.contractFinancialDocsAfterClosingDate": "A data de fecho tem de ser superior ao último período faturado.",
            "error.api.activationDateBeforeSignDate": "Data de ativação tem de ser superior à data de assinatura.",
            "error.api.cannotUpdateActDateHasRenewal": "Não é possível alterar a data de ativação pois o contrato já foi renovado.",
            "error.api.contractTermsStartBeforeContractStart": "Data de ínicio não pode ser inferior à data de ativação do contrato.",
            "error.api.moreThanOneActiveTermsInPeriod": "Já existem termos contratuais ativos para o período selecionado.",
            "error.api.trading.noDeliveryPointsFoundPhysicalUnit": "Não existem pontos de entrega associados à unidade física.",
            "error.api.financialDocumentsAfterClosingDate": "Existem documentos financeiros emitidos após a data de encerramento pretendida.",
            "error.api.termsExistAfterStartDate": "Termos existem após a data selecionada.",
            "error.api.cannotHaveGapBetweenTerms": "Existe um período de tempo sem termos contratuais entre os existentes e os novos. Por favor corrija este erro.",
            "error.api.b021p.missingCae": "É obigatório preencher o CAE do Produtor ou da Unidade Fisíca.",
            "error.api.b021p.missingConnectionPowerInformation": "É obrigatório preencher a informação de potência de ligação.",
            "error.api.b021p.missingInstalledPowerInformation": "É obrigatório preencher a informação de potência instalada.",
            "error.api.b021p.missingProductionType": "É obrigatório preencher o tipo de produção.",
            "error.api.b021p.missingTechnologyType": "É obrigatório preencher o tipo de tecnologia.",
            "error.api.b021p.producerMissingCompleteAddressInformation": "É obrigatório preencher a informação completa de morada do produtor.",
            "error.api.b021p.missingContractActDate": "É obrigatório preencher a data de ativação pretendida para o contrato.",
            "error.api.b021p.missingAggregatorDsoId": "Falta preencher o código de referência do agregador.",
            "error.api.trading.communicationErrorWithOMIE": "Ocorreu um erro na comunicação com o OMIE. Contacte o suporte ou volte a tentar mais tarde.",
            "error.api.trading.noOffersFound": "Não foram encontradas ofertas para a Unidade de Oferta selecionada ou estas não se encontram no estado que permite a pesquisa de programa.",
            "error.api.trading.offerNotLatestVersion": "A oferta selecionada não é a última versão. Por favor atualize a página e tente novamente.",
            "errors.api.paymentMethodAlreadyExists": "Um método de pagamento já existe para a entidade selecionada.",
            "error.forms.newCommunityTariffPlan.noCommunities": "Não existem comunidades disponíveis. Aceda à área de Comunidades de Energia e configure uma nova comunidade.",
            "error.forms.newCommunityTariffPlan.noTariffModels": "Não existem modelos tarifários disponíveis. Aceda à área de Modelos Tarifários e configure um novo modelo.",
            "error.forms.newCommunityTariffPlan.noConsumers": "Não existem membros consumidores. Aceda à área de Membros dentro das Comunidades e crie um novo membro consumidor.",
            "error.forms.newCommunityTariffPlan.noProducers": "Não existem membros produtores. Aceda à área de Membros dentro das Comunidades e crie um novo membro produtor.",
            "error.forms.newCommunityTariffPlan.atLeastOneMember": "É necessário selecionar pelo menos 1 membro.",
            "error.forms.newCommunityTariffPlan.membersRequired": "São necessários membros.",
            "error.forms.invalidLimit": "O número deve ter no máximo 2 casas decimais e ser positivo!",
            "error.forms.invalidSepaCreditorID": "O ID do Credor SEPA é inválido!",
            "error.message.noRENProgrammesFound": "Não foi possivel encontrar programa para a data selecionada.",
            // Agent Validation Messages
            "error.validation.agentType": "Antes de avançar, selecione pelo menos um tipo de Agente.",
            // Contract Validation Messages
            "error.api.contract.activate.contractNotInPreStatus": "O contrato já não se encontra em estado de Pré-Registo ou Em Ativação.",
            "error.api.contract.activate.activationDateNotReached": "Data de Ativação ainda não foi atingida.",
            "error.api.contract.activate.physicalUnitNotFound": "Unidade Física não encontrada.",
            "error.api.contract.activate.connectionPowerNotFound": "A Potência de Ligação na Unidade Física ainda não foi preenchida.",
            "error.api.contract.activate.connectionGreater1MWAndNoMeterId": "Potência de Ligação superior ou igual a 1MW e sem identificação GGS.",
            "error.api.contract.activate.receiptEntityNotFound": "Cliente de Faturação não encontrado.",
            "error.api.contract.activate.noContractTerms": "Não existem termos contratuais para o contrato.",
            // Member Installation Errors
            "error.api.communities.memberAlreadyInCommunity": "A instalação que se encontra a registar já se encontra associada a outra comunidade.",
            "error.api.communities.extMemberIdAlreadyInUse": "O ID DGEG que está a tentar utilizar já está em uso.",
            // 2Fa Errors
            "error.api.verificationCodeFailed": "Código de autenticação inválido. Por favor tente novamente.",
            // Axios Errors
            "Request failed with status code 500": "Ocorreu um erro na comunicação com o servidor. Contacte o suporte.",

            // Messages
            "message.forms.noFiles": "Não foi selecionado nenhum ficheiro!",
            "message.forms.files": "Ficheiros Selecionados:",
            "message.form.contracts.lodadedDeliveryPoint": "Informação da Unidade Física carregada automaticamente.",
            "message.form.contracts.loadedProducerData": "Informação carregada a partir do Produtor.",
            "message.form.contracts.entityData": "Entidade já existe, dados carregados a partir da entidade.",
            "message.form.editModeActive": "Modo de Edição ativo",
            "message.form.recordSaved": "Alterações gravadas!",
            "message.form.recordCreated": "Alterações gravadas!",
            "message.form.findocs.processed": "Documentos Processados e enviados para o ERP",
            "message.table.noData": "Ainda não realizou qualquer consulta ou a consulta realizada não devolveu resultados. Altere os parâmetros de pesquisa e procure novamente.",
            "message.table.loadError": "Não foi possível carregar os dados.",
            "label.button.tryAgain": "Tentar novamente",
            "label.title.fileImport": "Importação de Ficheiros",
            "label.fileImport.tab.ord": "Ficheiros de dados ORD",
            "label.fileImport.col.fileName": "Nome do ficheiro",
            "label.fileImport.col.community": "Comunidade",
            "label.fileImport.col.agentEntity": "Entidade do agente",
            "label.fileImport.col.type": "Tipo",
            "label.fileImport.col.status": "Estado",
            "label.fileImport.col.records": "Registos",
            "label.fileImport.col.received": "Recebido",
            "label.fileImport.col.loaded": "Carregado",
            "label.fileImport.type.DAILY": "Diário",
            "label.fileImport.type.MONTHLY": "Mensal",
            "label.fileImport.type.EXTRAORDINARY": "Extraordinário",
            "label.fileImport.status.PENDING": "Pendente",
            "label.fileImport.status.LOADED": "Carregado",
            "label.fileImport.status.FAILED": "Falhado",
            "label.fileImport.status.QUARANTINED": "Em quarentena",
            "label.fileImport.clearFilters": "Limpar filtros",
            "label.fileImport.retry": "Repetir",
            "label.fileImport.rowActions": "Ações para {{file}}",
            "label.fileImport.download": "Descarregar CSV",
            "message.fileImport.empty": "Sem ficheiros ORD para mostrar. Os ficheiros diários são mantidos 31 dias, os mensais e extraordinários 13 meses. Os ficheiros falhados e em quarentena são mantidos até serem resolvidos.",
            "message.fileImport.noMatch": "Nenhum ficheiro corresponde aos filtros.",
            "message.fileImport.noAccess": "Não tem acesso a esta página. Contacte um administrador.",
            "message.fileImport.retryConfirm": "Repetir o carregamento de {{file}} para {{community}}? Todos os ficheiros falhados desta execução da comunidade são colocados em fila com ele. Os dados já carregados não são duplicados.",
            "message.fileImport.retryRequested": "Repetição pedida. O estado será atualizado em breve.",
            "api.error.ord.notRetryable": "O ficheiro não está em estado falhado. Nada foi colocado em fila.",
            "api.error.ord.copyNotAvailable": "A cópia CSV deste ficheiro já não está disponível.",
            "message.table.customNoData": "Ainda não existem modelos de plano tarifário criados para o agente selecionado. Aceda ao menu de planos tarifários e crie um novo modelo.",
            "message.info.noContracts": "Não tem nenhum contrato associado.",
            "message.info.noProgrammeFound": "Não foi encontrado nenhum programa para o período selecionado.",
            "message.info.dataLoaded": "Dados carregados com sucesso.",
            "message.form.login.sucess": "Login Realizado com Sucesso",
            "message.forms.fileSizeExceeded": "Tamanho do ficheiro excede o limite permitido de 10MB.",
            "message.dialog.2FACode": "Por favor insira o seu código de autenticação de dois fatores. Caso não tenha ainda configurado a autenticação de dois fatores, terá de configurar em Conta > Definições de Utilizador.",
            "message.form.xmlfiles": "Apenas ficheiros com a extensão .xml são permitidos.",
            "message.form.250kbfilesize": "O ficheiro deve ter um tamanho inferior a 250KB.",
            // Backend Options
            "Quarterly": "Trimestral",
            "Monthly": "Mensal",
            "Monthly (15th)": "Mensal / Meio do Mês",
            "Monthly (2nd)": "Mensal / Início do Mês",
            "No Billing Period": "Sem Ciclo / Ato Único",
            "Weekly": "Semanal",
            "Yearly": "Anual",
            "Validation": "Em Validação",
            "Approved": "Aprovada",
            "Prospecting": "Construção",
            "Operating": "Em Operação",
            "label.status.member.prerecord": "Pré-Registo",
            "label.status.member.active": "Ativo",
            "label.status.member.registered": "Registado",
            "label.status.member.suspended": "Suspenso",
            "label.status.member.inactive": "Inativo",
            "label.status.member.certification": "Certificação",
            "label.status.receipt.DUE": "Por Pagar",
            "label.status.report.PENDING": "Pendente",
            "label.status.report.COMPLETED": "Concluído",
            "label.status.report.ERROR": "Com Erro",
            "label.status.report.RUNNING": "Em Curso",
            "label.status.offer.UNSENT": "Não Enviada",
            "label.status.offer.SENT": "Enviada",
            "label.status.offer.SUBMITTED": "Submetida",
            "label.status.offer.VOIDED": "Anulada",
            "label.status.offer.REJECTED": "Recusada",
            "label.status.offer.REFUSED": "Recusada",
            "label.status.offer.UPDATED": "Pendente",
            "label.status.offer.PENDING": "Pendente",
            "label.status.offer.ARCHIVED": "Arquivada",
            "label.status.contract.ATI": "Ativo",
            "label.status.contract.PRE": "Pré-Registo",
            "label.status.contract.PEN": "Pendente",
            "label.status.contract.REC": "Recusado",
            "label.status.contract.FEC": "Fechado",
            "label.type.offer.C": "Compra",
            "label.type.offer.V": "Venda",
            "label.status.agent.PREREG": "Pré-Registo",
            "label.status.agent.ACTIVE": "Ativo",
            // Community Status
            "label.community.status.dgegRegistrationgGroup": "Registo na DGEG",
            "label.community.status.prerecord": "Pré-Registo",
            "label.community.status.active": "Ativa",
            "label.community.status.submitted": "Projeto submetido",
            "label.community.status.analyzing": "Em Análise",
            "label.community.status.partialReview": "Pronúncia parcial do ORD",
            "label.community.status.totalReview": "Pronúncia total do ORD",
            "label.community.status.waitingAcceptance": "Aguarda aceitação p/ Cadastro",
            "label.community.status.cadastreAssignment": "Atribuição de Cadastro",
            "label.community.status.certificationDGEG": "Certificação DGEG",
            "label.community.status.certificationORD": "Certificação ORD",
            "label.community.status.suspended": "Partilha Suspensa",
            "label.community.status.certification": "Certificação",
            "label.community.status.registering": "Em Registo na DGEG",
            "label.community.type.acc": "Autoconsumo Coletivo",
            "label.community.type.cer": "Comunidade de Energia Renovável",
            // Invoices Status
            "Paid": "Pago",
            "Paid Off": "Pago",
            "Pending": "Pendente",
            "Void": "Anulada",
            "Processed": "Processada",
            "Issued": "Emitida",
            "Unpaid": "Por Pagar",
            "Approval": "Aprovada",
            // Producer Status
            "Pre-Record": "Pré-Registo",
            "Active": "Ativo",
            "Inactive": "Inativo",
            "Refused": "Recusado",
            "Pending Contract": "Pendente",
            "No Contracts": "Sem Contrato",
            "Activating": "Em Ativação",
            // Financial Document Types
            "Auto Invoice": "Autofatura",
            "Purchase Document": "Documento de Compra",
            "Sales Document": "Fatura",
            "Credit Note": "Nota de Crédito",
            // Payment TErms
            "20 Days": "20 Dias",
            "30 Days": "30 Dias",
            "60 Days": "60 Dias",
            // Long Text Messages
            "label.message.producerExists": "Um produtor com o NIF inserido já existe e não é possível criar dois registos de produtor para o mesmo NIF. Deseja inserir outro NIF ou ser redirecionado para a página do produtor existente?",
            "label.message.goBackConfirmation": "Ao voltar atrás irá perder todas as alterações realizadas, este registo não foi gravado!",
            "label.message.deleteConfirmation": "Ao remover, irá eliminar de forma definitiva e perde todos os registos!",
            "label.message.recordsProcessedSuccess": "Registos processados com sucesso.",
            "label.message.noActiveAutoInvoiceAgreements": "Não existem acordos de autofaturação ativos para este cliente.",
            "label.message.noActivePaymentMethods": "Não existem métodos de Pagamento ativos para este cliente.",
            "label.contract.action.REOPEN": "Reabertura",
            "label.contract.action.RENEW": "Renovação",
            "label.contract.action.CLOSE": "Cessação",
            "label.contract.action.CREATE": "Criação",
            "label.contract.action.UPDATE": "Atualização",
            "label.contract.action.UPDATE_ACTDATE": "Alterar Assinatura / Cessação Contrato",
            "label.contract.action.ACTION_UPD_TERMS": "Atualização Termos",
            "label.contract.action.SCHED_CLOSE": "Agendamento Cessação",

            "label.message.agent.referenceCodesUpdated": "Códigos de Referência atualizados com sucesso.",
            "label.message.agent.certificateUploaded": "Certificado carregado com sucesso.",
            "label.message.agent.certificatePasswordUpdated": "Password do Certificado atualizada com sucesso.",

            "label.message.dialog.closingIn": "Esta janela irá fechar em {{seconds}} segundos.",
            "message.dialog.valueCopied": "Valor copiado para a área de transferência.",
            "label.message.noData": "Sem dados.",

            "label.dialog.changeOwner.title": "Transferir Titularidade",
            "label.dialog.changeOwner.step1.title": "Dados do Novo Titular",
            "label.dialog.changeOwner.step1.subtitle": "Insira o Número Fiscal e o Nome do novo titular da instalação.",
            "label.dialog.changeOwner.step2.title": "Confirmar Novo Titular",
            "label.dialog.changeOwner.step2.sectionTitle": "Dados do Titular",

            "label.dialog.confirmContinueToMemberConfiguration.message": "Parabéns! Concluiu a configuração da instalação na comunidade. Deseja continuar para a configuração do cliente associado à instalação?",
            "label.dialog.confirmContinueToCommunityConfiguration.message": "Parabéns! Concluiu a configuração de uma nova instalação. Deseja associá-la a uma comunidade?",
            "label.dialog.confirmContinueToTariffPlanConfigurationDialog.message": "Concluiu a configuração de um cliente da instalação! Deseja continuar para a configuração do plano tarifário?",
            "label.tariffPlanType.consumer": "Consumidor",
            "label.tariffPlanType.producer": "Produtor",
            "label.tariffPlanType.egac": "Cliente EGAC",
            "label.tariffPlanType.consumer.description": "Plano tarifário aplicado à venda da energia consumida pelo Consumidor, partilhada pela Comunidade através da rede ou fornecida pela UPAC.",
            "label.tariffPlanType.producer.description": "Plano tarifário aplicado à compra da energia injetada na rede pelo Produtor, para partilha com a Comunidade ou transação nos mercados de energia.",
            "label.tariffPlanType.egac.description": "Plano tarifário aplicado à compra da energia excedente da Comunidade.",
            "label.tariffPlanType.producers_2_consumer": "Todos os Produtores para Consumidor",
            "label.tariffPlanType.producers_2_consumer.description": "Plano tarifário aplicado à energia partilhada entre cada Produtor e cada Consumidor.",
            "label.tariffPlanType.pairs": "Par Consumidor - Produtor",
            "label.tariffPlanType.pairs.description": "Plano tarifário aplicado à compra e venda da energia partilhada entre cada par Produtor – Consumidor existente numa Comunidade.",
            "label.step.newTariffModel.tariffPlanType.subtitle": "Selecione o tipo de modelo de plano tarifário.",
            "label.step.newTariffModel.tariffs": "Tarifas",
            "label.step.newTariffModel.duration": "Duração",
            "label.step.newTariffModel.duration.subtitle": "Defina a duração do plano tarifário e o número de dias de antecedência com os quais deverá ser comunicada a rescisão de contrato.",
            "label.step.newTariffModel.tariffType": "Tarifa de Energia",
            "label.step.newTariffModel.tariffType.subtitle": "Defina os termos da tarifa de energia.",
            "label.step.newTariffModel.fees": "Tarifa de Gestão",
            "label.step.newTariffModel.fees.subtitle": "Defina os termos da tarifa de gestão.",
            "label.step.newTariffModel.paymentsAndReceipts": "Pagamentos e Recebimentos",
            "label.step.newTariffModel.payments": "Pagamentos",
            "label.step.newTariffModel.payments.subtitle": "Esta secção permite configurar os métodos de pagamento, as condições de pagamento e os ciclos de faturação que podem ser disponibilizados ao Cliente.",
            "label.step.newTariffModel.receipts": "Recebimentos",
            "label.step.newTariffModel.receipts.subtitle": "Esta secção permite configurar os métodos de recebimento, as condições de recebimento e os ciclos de faturação que podem ser disponibilizados ao Cliente.",
            "label.step.newTariffModel.paymentsAndReceipts.subtitles": "Defina os valores por omissão para pagamentos e recebimentos.",
            "label.step.newTariffModel.confirmationStep": "Confirmação dos Dados",
            "label.step.newTariffModel.confirmationStep.subtitle": "Confirme os dados do plano tarifário.",

            "label.step.newProducer.agentEntityStep": "Agente",
            "label.step.newCommunity.newProducer.subtitle": "Vamos começar por definir qual a entidade de agregação responsável pela gestão do produtor.",
            "label.step.newProducer.entityData": "Dados do Produtor",
            "label.step.newCommunity.newProducer.entityData": "Pode pesquisar um entidade já existente através do NIF / NIPC ou criar uma nova entidade.",
            "label.step.newProducer.confirmData": "Validar Dados",
            "label.step.newTariffPlan.confirmationStep.subtitle": "Confirme os dados do plano tarifário a criar.",
            "label.product.CVE": "Compra e Venda de Energia",
            "label.product.VE": "Venda de Energia",
            "label.product.CE": "Compra de Energia",
            "label.product.CAR": "Custos de Acesso às Redes",
            "label.product.CGE": "Custos de Gestão da EGAC",
            "label.product.CGA": "Custos de Gestão do Agregador",
            "label.energyTransaction.shared": "Energia Partilhada",
            "label.energyTransaction.surplus": "Energia Excedente",
            "label.energyTransaction.production": "Energia Produzida",
            "label.energyTransaction.selfconsumption": "Autoconsumo",
            "label.energyTransaction.consumption": "Autoconsumo através da Rede",
            "label.energyTransaction.trader": "Comercializador",
            "label.energyTransaction.shared_consumed": "Energia Partilhada",
            "label.energyTransaction.shared_surplus": "Energia Excedente",
            "label.energyTransaction.total_surplus": "Energia Excedente Total",
            "label.tariffPlans.ATI": "Ativo",
            "label.tariffPlans.PRE": "Pré-Registo",
            "label.tariffPlans.EAC": "Em Ativação",
            "label.tariffPlans.PEN": "Pendente",
            "label.tariffPlans.REC": "Recusado",
            "label.tariffPlans.FEC": "Fechado",
            // New Powertrading Contract Stepper
            "label.newPowerTradingTariff.introductionStep": "Introdução",
            "label.newPowerTradingTariff.agentEntityStep": "Agente",
            "label.newPowerTradingTariff.physicalUnitDataStep": "Dados da Instalação",
            "label.newPowerTradingTariff.physicalUnitAddressStep": "Morada da Instalação",
            "label.newPowerTradingTariff.contactDataStep": "Dados de Contacto",
            "label.newPowerTradingTariff.receiptsStep": "Recebimentos e Faturação",
            "label.newPowerTradingTariff.documentsStep": "Documentos",
            "label.newPowerTradingTariff.confirmationStep": "Validar Dados",
            "label.form.renRegistration": "Dados de Registo na REN",
            "label.form.geoCoding": "Geo Localização",

            "label.dialog.confirmContinueToInstallationConfigurationDialog.message": "Parabéns! Concluiu a configuração da comunidade. Deseja continuar para a configuração de uma instalação para esta comunidade?",


            "label.communities.tariffModel.title.independent": "Tarifários Independentes",
            "label.communities.tariffModel.description.independent": "Este modelo permite aplicar planos tarifários independentes à energia partilhada com cada consumidores e à energia partilhada por cada produtor.",

            "label.communities.tariffModel.title.pairs": "Pares Consumidor - Produtor",
            "label.communities.tariffModel.description.pairs": "Este modelo permite aplicar um plano tarifário à energia partilhada entre cada produtor e cada consumidor.",

            "label.communities.tariffModel.title.producers_2_consumer": "Todos os Produtores para um Consumidor",
            "label.communities.tariffModel.description.producers_2_consumer": "Neste modelo todos os produtores aplicam o mesmo plano tarifário à energia partilhada com um determinado consumidor.",

            "label.businessType.aggregation": "Agregação",
            "label.businessType.communities": "Comunidades",

            "label.step.newPaymentMethod.selectAgentEntity": "Selecionar Agente",
            "label.step.newPaymentMethod.selectPaymentMethod": "Selecionar Método de Pagamento",

            "label.title.configureInstallation": "Configurar Instalação",
            "api.error.alreadyHasTariffPlan": "Já existe um plano tarifário ativo para esta instalação e para a transação de energia selecionada.",
            "api.error.datesGreaterThanToday": "Por favor selecione uma data igual ou inferior à data atual.",
            "api.error.physicalUnitNotFound": "Não foi possível encontrar a instalação selecionada.",

            "label.title.clientData": "Dados do Cliente",
            "label.title.documentData": "Dados do Documento",
            "label.title.energyProduction": "Produção de Energia",
            "label.title.energyConsumption": "Consumo de Energia",
            "label.title.energySurplus": "Excedente de Energia",
            "label.title.sharedEnergy": "Energia Partilhada",
            "label.title.sharedEnergyConsumed": "Energia Partilhada Consumida",
            "label.title.sharedEnergySurplus": "Energia Partilhada Excedente",
            "label.title.selfConsumptionResp": "Autoconsumo através da RESP",
            "label.title.selfConsumptionRi": "Autoconsumo através da RI",
            "label.title.consumptionByCommercializer": "Consumo fornecido pelo Comercializador",
            "label.title.totalConsumption": "Consumo da Rede",
            "label.title.networkConsumption": "Autoconsumo através da Rede",
            "label.title.totalProduction": "Produção Total",
            "label.title.totalNetworkInjection": "Total Injetado na Rede",
            "label.title.surplusEnergy": "Energia Excedente",
            "label.title.UPACConsumptionEnergy": "Autoconsumo da UPAC Integrada",

            "label.relatedType.P": "Produtor",
            "label.relatedType.C": "Consumidor",

            "api.error.activeEnergyPurchasePlan": "Já existe um plano tarifário ativo de compra de energia para esta instalação.",
            "api.error.activeEnergySalePlan": "Já existe um plano tarifário ativo de venda de energia para esta instalação.",
            "api.error.noConsumptionData": "Não existem dados para o período indicado ou não tem acesso.",
            "api.info.noProductionData": "Não existem dados de produção para o período indicado ou não tem acesso.",
            "api.info.noPEnergySurplusData": "Não existem dados de energia excedente para o período indicado ou não tem acesso.",
            "label.title.renSFTPConfiguration": "Configuração Ligação SFTP REN",
            "label.title.eredesSFTPConfiguration": "Configuração Ligação SFTP E-Redes",
            "label.title.energyDataSftpConfiguration": "SFTPs Contagens",
            "label.title.systemServicesMarketConfiguration": "SFTP Gestor Global Sistema",
            "label.form.host": "Host",
            "label.form.port": "Porta",
            "label.form.sourcePath": "Pasta de Origem",
            "label.form.submissionPath": "Pasta de Submissão",
            "label.form.destinationPath": "Pasta de Destino",

            "label.message.agent.renSftpConfigurationUpdated": "Configuração SFTP REN atualizada com sucesso.",
            "label.message.agent.eredesSftpConfigurationUpdated": "Configuração SFTP E-Redes atualizada com sucesso.",
            "label.newPowerTradingTariff.productsServicesStep": "Produtos e Serviços",

            "label.form.autoinvoicingAgreements": "Acordo prévio de Autofaturação",
            "label.table.header.useAutoInvoicing": "Regime de Autofaturação?",
            "label.table.header.hasValidationCode": "Séries Comunicadas?",

            "label.tab.approval": "Aprovação",
            "label.tab.pending": "Pendentes",
            "label.tab.processed": "Processadas",
            "label.tab.issued": "Emitidas",
            "label.tab.void": "Anuladas",
            "label.tab.settled": "Pagas",
            "label.title.selectAggregator": "Selecionar Agregador",
            "label.title.editAutoInvoiceAgreement": "Alterar Acordo de Autofaturação",
            "label.title.marketSessionConfiguration": "Configuração da Sessão de Mercado",

            "api.error.agentEntityDoesNotHaveCertificate": "A entidade selecionada não tem um certificado digital do OMIE associado. Por favor, carregue um certificado digital para esta entidade na sua conta.",
            "error.api.trading.cantSendRejectedOffer": "Não é possível enviar uma oferta recusada. Edite a oferta para corrigir os erros antes de enviar.",
            "api.error.errorFetchingOpenMarketSession": "Não foi possível confirmar se existe uma sessão de mercado aberta. Por favor, tente novamente mais tarde.",
            "error.api.trading.voidOfferNotSuccessful": "Não foi possível anular a oferta. Por favor, tente novamente mais tarde.",
            "error.api.trading.offerAlreadySent": "A oferta já foi submetida para o mercado. Para enviar novamente crie uma nova versão alterando os dados da oferta.",
            "api.error.noOmieReferenceId": "O agente de mercado selecionado não tem o ID de referência do OMIE preenchido. Não é possível completar a ação.",

            //Physical Unit Update
            "api.error.physicalUnitsUpdate.consumptionDeliverypointAlreadyUsed": "O CPE de Consumo já se encontra associado a outra instalação.",
            "api.error.physicalUnitsUpdate.productionDeliverypointAlreadyUsed": "O CPE de Produção já se encontra associado a outra instalação.",
            "api.error.physicalUnitsUpdate.ownerNotFound": "O Titular da Instalação não foi encontrado na plataforma.",

            //Physical Unit Change Owner
            "api.error.physicalUnitsChangeOwner.ownerNotFound": "O Titular da Instalação não foi encontrado na plataforma.",

            // Financial Document Manual Creation
            "api.error.finDoc.manualCreationDisabled": "Funcionalidade da criação manual de documentos está desativada.",
            "api.error.finDoc.invalidClassificationForSurplusCommunity": "Para faturar a comunidade, o documento tem de ser Compra de Energia.",
            "api.error.finDoc.onlyEPForAggregation": "O documento tem de ser Compra de Energia.",
            "api.error.finDoc.invalidClassificationForRole": "Classificação do documento escolhida inválida.",
            "api.error.finDocPrepare.contractNotFound": "Plano Tarifário não encontrado.",

            // Physical Unit Classifications
            "label.physicalUnitClassification.ip": "IP",
            "label.physicalUnitClassification.ic": "IC",
            "label.physicalUnitClassification.ic_prod": "IC / Produção",
            "label.physicalUnitClassification.ic_prod_strg": "IC / Produção / Armazenamento",
            "label.physicalUnitClassification.ic_strg": "IC / Armazenamento",
            "label.physicalUnitClassification.ip_strg": "IP / Armazenamento",
            "label.physicalUnitClassification.ia": "Instalação de  Armazenamento",

            "error.api.trading.notLatestVersionOffer": "A oferta selecionada não é a última versão. Por favor, atualize a página e tente novamente.",
            "label.title.forecastProgramme": "Programação",
            "error.api.trading.finalOfferAlreadySubmitted": "A oferta final já foi submetida para o mercado. Não é possível anular.",

            "label.title.selectEGAC": "Selecionar Entidade Gestora",
            "label.menu.financialDocuments": "Documentos Financeiros",
            "label.title.selectedAgentEntity": "Entidade Selecionada",
            "api.error.invalidPlanTypeForCommunity": "O tipo de plano tarifário selecionado não é válido para a comunidade selecionada.",
            "label.agentEntity.egacCode": "Código EGAC",
            "label.table.header.productionDeliveryPoint": "CPE de Produção",
            "label.table.header.consumptionDeliveryPoint": "CPE de Consumo",
            "label.button.runInvoiceCycle": "Correr Ciclo de Faturação",

            "label.dialog.runInvoiceCycle.title": "Correr Ciclo de Faturação",
            "label.dialog.runInvoiceCycle.selectCycle": "Selecionar Ciclo de Faturação",
            "label.dialog.runInvoiceCycle.confirmData": "Confirmar Pedido de Processamento de Ciclo de Faturação",

            "api.error.invoiceProcessRequestExists": "Já existe um pedido de processamento de ciclo de faturação para o Agente e Ciclo selecionados.",
            "label.menu.invoicingCycleRequests": "Pedidos de Processamento de Faturação",
            "label.table.header.createdDate": "Data de Criação",
            "label.table.header.updatedDate": "Data de Atualização",
            "label.status.invoiceCyleRequest.PN": "Pendente",
            "label.status.invoiceCyleRequest.PR": "Em Processamento",
            "label.status.invoiceCyleRequest.CP": "Completo",
            "label.status.invoiceCyleRequest.FL": "Erro",

            "error.api.communityWithDsoIDAlreadyExists": "Já existe uma comunidade registada com o ID DSO. Por favor modifique o valor e tente novamente.",
            "label.table.header.businessType": "Tipo de Negócio",

            // Financial Documents Status
            "label.financialDocuments.status.AP": "Em Aprovação",
            "label.financialDocuments.status.PN": "Pendente",
            "label.financialDocuments.status.PR": "Processado",
            "label.financialDocuments.status.IS": "Emitido",
            "label.financialDocuments.status.VD": "Anulado",
            "label.financialDocuments.status.RJ": "Rejeitado",
            "label.financialDocuments.status.PD": "Pago",

            // Financial Documents Menu Actions
            "label.financialDocument.menu.downloadSettlementNote": "Nota de Liquidação",
            "label.financialDocument.menu.downloadSettlementDocument": "Nota de Pagamento",
            "label.financialDocument.menu.uploadDocument": "Upload Documento",
            "label.financialDocument.menu.voidDocument": "Anular Documento",
            "label.financialDocument.menu.publishDocument": "Publicar Documento",
            "label.financialDocument.menu.uploadDocuments": "Upload de Documentos",
            "label.financialDocument.menu.fileSelected": "Ficheiro Selecionado:",
            "label.financialDocument.menu.noFileSelected": "Nenhum ficheiro selecionado",

            "label.table.header.documents": "Documentos",
            "api.error.validation": "Ocorreu um erro de validação. Por favor verifique os dados introduzidos.",
            "api.error.afrrBlock1Required": "O bloco 1 tem de ser criado antes de adicionar blocos com número superior ao período.",
            "api.error.afrrMaxPower": "A potência total oferecida para este período excede a potência máxima da unidade física.",
            "errors.api.financialDocument.documentExistsForPeriod": "Já existe um documento financeiro para o período selecionado. Anule primeiro o documento existente.",
            "errors.api.financialDocumentAlreadyVoided": "Não foi possível anular o documento por já se encontrar anulado.",
            "error.api.existingTariffPlan": "Já existe um plano tarifário ativo para esta instalação e para a transação de energia selecionada.",

            "label.title.tariffPlans": "Planos Tarifários",
            "label.title.viewTariffPlan": "Ver Plano Tarifário",
            "label.table.header.energyTariffEuro": "Tarifa de Energia (€/MWh)",
            "label.table.header.tariffPlan": "Plano Tarifário",
            "label.table.header.periodStart": "Data de Ínicio",
            "label.table.header.periodEnd": "Data Fim",
            "label.table.header.mgmtEnergyTariffEuro": "Tarifa de gestão (€/MWh)",
            "label.table.header.mgmtEnergyTariffPerc": "Tarifa de gestão (%)",
            "label.table.header.powerTariffEuro": "Tarifa de gestão (€/kW/dia)",
            "label.table.header.acceptNegPrices": "Aceita?",
            "label.menu.generalInfo": "Dados Gerais",
            "label.menu.tariffs": "Tarifas",
            "label.title.planDates": "Datas e Duração",
            "label.title.changeTariffPeriod": "Alterar Termos Tarifários",
            "label.title.newTariffPeriod": "Novos Termos Tarifários",
            "api.error.contract.updatePlanDates.moreThanOneTariffPeriodFound": "Foi encontrado mais do que um peróodo tarifário associado ao plano. Não é possível alterar a data de ativação quando existe mais do que um período tarifário.",
            "api.error.contract.updatePlanDates.startDateMustBeAfterSignatureDate": "A data de ativação tem de ser posterior à data de assinatura.",
            "label.dialog.deleteTariffPeriod.title": "Remover Período Tarifário",
            "label.dialog.deleteTariffPeriod.confirmQuestion": "Confirme que quer, mesmo assim, proceder à remoção do período tarifário.",
            "label.dialog.deleteTariffPeriod.affectedDocumentsIntro": "Foram identificados os seguintes documentos emitidos associados ao período que está a ser removido.",
            "label.dialog.deleteTariffPeriod.content": "Confirma que pretende remover o período de {{start}} a {{end}}?",
            "label.dialog.confirmAffectedDocuments.title": "Documentos Financeiros Existentes",
            "label.dialog.confirmAffectedDocuments.intro": "Os documentos financeiros abaixo listados foram encontrados associados a este intervalo de datas.",
            "label.dialog.confirmAffectedDocuments.confirmQuestion": "Tem a certeza que quer confirmar?",
            "label.dialog.confirmAffectedDocuments.footnote": "Os documentos continuarão sempre disponíveis na plataforma para serem anulados manualmente mais tarde, se assim pretender.",
            "label.table.header.erpId": "ID ERP",
            "label.table.header.referenceStartDate": "Início",
            "label.table.header.referenceEndDate": "Fim",
            "api.error.contract.deleteTariffPeriod.cannotDeleteLastTariffPeriod": "Não é possível remover este período tarifário. O plano tarifário tem de ter pelo menos um período tarifário.",
            "label.common.loading": "A carregar...",
            "label.common.noDataAvailable": "Sem dados disponíveis",
            "error.api.tariffPeriod.deleteFailed": "Não foi possível remover o registo. Por favor tente novamente.",
            "error.api.existingTariffPeriodForContract": "Não foi possível gravar as alterações: Já existe outro período tarifário para as datas selecionadas.",
            "error.api.contract.createTariffPeriod.newPeriodMustStartAfterTheLastOneEnds": "Não foi possível gravar as alterações: as datas de períodos tarifários devem ser contínuas.",
            "error.api.createTariffModel.agentNotFound": "Falha ao criar o modelo de plano tarifário: não foi possível determinar o agente associado à sua conta.",

            // Void Financial Documents
            "label.button.voidFinDocNoSubstitution": "Anular Documento sem Documento de Substituição",
            "label.button.voidFinDocWithSubstitution": "Anular Documento e Criar Documento de Substituição",
            "label.voidFinDoc.stepSubsDocument": "Criar Documento de Substituição",
            "label.button.goBack": "Regressar ao Passo Anterior",
            "label.button.submitVoidAndSubsDoc": "Submeter Anulação de Documento e Documento de Substituição",

            "Limit": "Limite",
            "label.title.editPaymentMethod": "Editar Método de Pagamento",

            // Financial Documents Classifications
            "label.table.header.classification": "Classificação",
            "label.financialDocumentClassification.EP": "Compra de Energia",
            "label.financialDocumentClassification.ES": "Venda de Energia",
            "label.financialDocumentClassification.AC": "Serviços de Gestão",
            "label.financialDocumentClassification.client.EP": "Venda de Energia",
            "label.financialDocumentClassification.client.ES": "Compra de Energia",
            "label.financialDocumentClassification.client.AC": "Serviços de Gestão",

            "error.api.managingEntityNotFoundOrNotAuthorized": "A Entidade Gestora selecionada não foi encontrada ou não tem permissão para gerir esta entidade.",

            // Área de Cliente
            "placeholder.search.physicalUnit": "Procurar CPE, Morada ou Nome",
            "placeholder.search.community": "Procurar Nome ou Código",
            "placeholder.search.communityAlt": "Procurar Nome ou ID da DGEG",
            "info.search.failed": "Pesquisa não devolveu resultados ou nem tem nenhum contrato ativo disponível.",
            "search.physicalUnit.btn.text": "Ver Todas",
            "card.physicalUnit.name": "Nome da Instalação",
            "card.physicalUnit.address": "Morada da Instalação",
            "card.physicalUnit.locality": "Localidade da Instalação",
            "card.physicalUnit.noName": "Nome da Instalação não definido",
            "card.physicalUnit.noLocality": "Localidade da Instalação não definida",
            "btn.physicalUnit.details": "Detalhes da Instalação",
            "btn.community.details": "Detalhes da Comunidade",
            "btn.physicalUnit.energy": "Energia",
            "btn.physicalUnit.billing": "Faturação",
            "btn.physicalUnit.tariffPlans": "Planos Tarifários",
            "btn.physicalUnit.saft": "SAF-T",
            "cardsSection.clientDashboard.community": "Energia da Comunidade",
            "cardsSection.clientDashboard.egac": "Entidade Gestora (EGAC)",
            "cardsSection.clientDashboard.client": "Cliente",
            "cardsSection.clientDashboard.billingAddress": "Morada de Faturação",
            "cardsSection.clientDashboard.buyEnergy": "Compra de Energia",
            "cardsSection.clientDashboard.paymentMethod": "Método de Pagamento",
            "cardsSection.clientDashboard.consumption": "Consumo (kWh) dos últimos meses da Comunidade",
            "cardsSection.clientDashboard.recentBilling": "Faturação mais recente",
            "btnText.contacts": "Ver Contactos",
            "btnText.modifyContacts": "Alterar Contactos",
            "btnText.modifyAddress": "Alterar Morada",
            "btnText.modifyBillingAddress": "Alterar Morada de Faturação",
            "btnText.modifyLimit": "Alterar Limite",
            "btnText.modifyIBAN": "Alterar IBAN",
            "btnText.invoice": "Fatura",
            "cardsSection.clientDashboard.debit": "Débito Direto",
            "cardsSection.clientDashboard.limit": "Limite",
            "cardsSection.clientDashboard.valueToPay": "Valor a Pagar",
            "cardsSection.clientDashboard.valueToReceive": "Valor a Receber",
            "cardsSection.clientDashboard.valueToCredit": "Valor a Devolver",
            "chartConsumption.autoConsumptionNet": "Autoconsumo através da Rede",
            "chartConsumption.autoConsumption": "Autoconsumo",

            "physicalUnits.everyPhysicalUnit": "Todas as Instalações",

            "physicalUnit.editName": "Alterar Nome da Instalação",

            "dashboardDialogs.egacContacts": "Contactos da EGAC",
            "dashboardDialogs.addressData": "Dados de Morada",
            "dashboardDialogs.paymentInfo": "Dados de Pagamento",
            "dashboardDialogs.modifyPayment": "Alterar Dados de Pagamento",
            "dashboardDialogs.doorNumber": "Nº da Porta",
            "dashboardDialogs.apartmentNumber": "Nº do Apartamento",

            "physicalUnitDetails.idMember": "ID Membro",
            "physicalUnitDetails.noData": "Sem dados da instalação",
            "physicalUnitDetails.invoices.paymentMethod.SEPA": "SEPA Débito Direto",
            "physicalUnitDetails.invoices.paymentMethod.bankTransfer": "Transferência Bancária",

            "error.api.managingEntityNotFoundOrNotAuthorized": "A Entidade Gestora selecionada não foi encontrada ou não tem permissão para gerir esta entidade.",
            "label.table.header.periodNumber": "Nº Período",
            "label.table.header.periodCode": "Código Período",
            "label.table.header.totalPowerUp": "Total Subir (MW)",
            "label.table.header.totalPowerDown": "Total Descer (MW)",
            "label.table.header.powerUp": "Subir (MW)",
            "label.table.header.powerDown": "Descer (MW)",
            "label.table.header.quarter": "Periodo Horário",
            "label.table.header.bandUpNeedMw": "Banda de aFRR a Subir (MW)",
            "label.table.header.bandDownNeedMw": "Banda de aFRR a Baixar (MW)",
            "label.table.header.bandTotalNeedMw": "Banda Total (MW)",
            "label.table.header.bandMinimumMw": "Minimo admissível por bloco (MW)",
            "label.table.header.offerUp": "Oferta Subir (MW)",
            "label.table.header.offerDown": "Oferta Descer (MW)",
            "label.table.header.priceUp": "Preço Subir (€/MW)",
            "label.table.header.priceDown": "Preço Descer (€/MW)",
            "label.table.header.assignedBandUp": "Banda a subir (MW)",
            "label.table.header.assignedBandDown": "Banda a baixar (MW)",
            "label.table.header.bandPriceUp": "Preço a subir (€/MW)",
            "label.table.header.bandPriceDown": "Preço a baixar (€/MW)",
            "label.filter.assignedOnly": "Atribuídas",
            "label.view.grid": "Tabela",
            "label.view.chart": "Gráfico",
            "label.table.header.session": "Sessão",
            "label.table.header.energyMWh": "Energia (MWh)",
            "label.table.header.power": "Potência (MW)",
            "label.table.header.tpRed": "TpRed",
            "label.table.header.tpTrns": "TpTrns",
            "label.table.pdvpuf": "Programa Diário Viável Provisional por Unidade Física",
            "label.table.pdvp": "Programa Diário Viável Provisional",
            "label.title.renProgrammeLines": "Linhas do Programa REN",
            "label.lines": "linhas",
            "message.selectMarketAgentAndSession": "Selecione um Agente de Mercado e uma Sessão",
            "message.loadingRENData": "A carregar dados da REN...",
            "message.noRENDataFound": "Não foram encontrados dados para o programa selecionado",

            "invoicesTab.method.sdd": "SEPA Débito Direto",
            "invoicesTab.method.rmb": "Referência Multibanco",
            "invoicesTab.method.TRF": "Transferência Bancária",

            "dashboard.updatePayments": "Atualizar dados de Pagamentos e Recebimentos",
            "Update": "Alterar",
            "dashboard.updateProfile": "Atualizar Perfil",

            "dashboard.info.noDataAvailable": "Não existe ainda informação disponível relativa ao seu plano tarifário.",

            "physicalUnits.details.noImage": "Sem imagem disponível",
            "physicalUnits.details.imageTitle": "Imagem da Instalação",

            // Edit Tariff Period
            "error.api.contract.updateTariffPeriod.canOnlyUpdateEndDateOfLastTariffPeriod": "Só é possível atualizar a data de fim do último período tarifário.",
            "error.api.contract.updateTariffPeriod.startDateAndEndDateMustBeWithinContract": "A data de início e a data de fim do período tarifário devem estar dentro das datas do contrato. Para extender o contrato deve criar um novo Período Tarifário.",
            // Close Tariff Plan
            "label.tariffPlan.close.title": "Fechar Plano Tarifário",
            "label.tariffPlan.close.confirmQuestion": "Confirme que quer, mesmo assim, proceder ao encerramento do plano tarifário.",
            "label.tariffPlan.close.affectedDocumentsIntro": "Foram identificados os seguintes documentos emitidos após a data de fecho do plano tarifário.",
            "label.tariffPlan.close.closeDate": "Fechar Plano Tarifário",
            "label.tariffPlan.close.confirmation": "Confirmar Dados",
            "api.error.contract.close.contractAlreadyClosed": "Não é possível encerrar o plano, pois este já se encontra fechado.",
            "api.error.contract.close.invoicesExistAfterCloseDate": "Não é possível encerrar o plano. Existem faturas após a data de encerramento.",
            "api.error.contract.close.termsExistAfterCloseDate": "Não é possível encerrar o plano. Existem períodos tarifários após a data de encerramento. Remova os períodos tarifários futuros antes de encerrar o plano.",
            // Remove Tariff Plan
            "error.api.tariffPlan.deleteFailed": "Não foi possível remover o plano tarifário devido a um erro. Por favor contacte o suporte da plataforma.",
            "label.dialog.deleteTariffPlan.title": "Remover Plano Tarifário",
            "label.dialog.deleteTariffPlan.content": "Confirma que pretende remover o plano tarifário para a instalação {{deliverypoint}} de {{start}} a {{end}}?",
            "error.api.contract.deleteContract.cannotDeleteContractWhenDocumentsHaveBeenCreated": "Não é possível remover o Plano Tarifário. Já existem documentos financeiros associados ao Plano.",

            "dashboard.detailsSection.noBillingData": "O seu plano tarifário não tem faturação recente",
            "dashboard.detailsSection.noEnergyData": "O seu plano tarifário não tem dados de energia recentes",

            "communities.memberDetails.deliverypoint": "CPE Produção / Consumo",

            // Client Document Statuses
            "label.financialDocuments.status.client.notPaid": "Por Pagar",
            "label.financialDocuments.status.client.paid": "Pago",
            "label.financialDocuments.status.client.notReceived": "Não Recebido",
            "label.financialDocuments.status.client.received": "Recebido",
            "label.financialDocuments.status.client.void": "Anulado",

            //Market Session / Offers
            "label.button.createEmptyOffers": "Criar Ofertas Vazias",
            "label.button.createTotalOffer": "Criar Oferta Total",
            "label.button.createIncrementalOffer": "Criar Oferta Incremental",
            "success.message.previousSessionStatusLoaded": "O resultado dos programas relativos à sessão anterior foram sincronizados.",
            "title.incrementalProgramme.confirmation": "Confirmar criação do programa incremental",
            "title.incrementalProgramme.noAvailableProgramme": "Não existe nenhum programa disponível para criar a oferta incremental. Confirme se deseja criar uma oferta pela totalidade da programação ou oferta vazia.",
            "title.incrementalProgramme.referenceProgrammeAvailable": "O programa de referência <b>{{programme_name}}</b> está disponível para criar a oferta incremental. Confirme a criação da oferta incremental.",
            "title.incrementalProgramme.referenceProgrammeNotAvailable": "O programa de referência <b>{{programme_name}}</b> não está disponível para criar a oferta incremental. Confirme se deseja utilizar o programa <b>{{replacement_programme_name}}</b> para criar a oferta incremental.",

            "clientDetails.fiscalData": "Dados Fiscais",
            "clientDetails.noData": "Não foi possível carregar a informação do utilizador. Por favor faça logout e login novamente.",
            "clientDetails.invalidImageFormat": "Formato inválido. Só são permitidas imagens JPEG ou PNG.",
            "clientDetails.invalidImageSize": "A imagem não pode ter mais de 5MB.",

            // Profile Popover
            "label.role.admin": "Administrador",
            "label.role.agent": "Agente",
            "label.role.client": "Cliente",

            "Admin": "Admin",

            "languages.portuguese": "Português",
            "languages.english": "Inglês",

            "communityMember.status.description.prerecord": "Membro não registado no Portal da DGEG",
            "communityMember.status.description.registered": "Membro com registo efetuado no Portal da DGEG",
            "communityMember.status.description.active": "Após a certificação pela DGEG e a celebração do contrato de uso de redes inicia-se a partilha de energia",
            "communityMember.status.description.suspended": "Partilha suspensa motivada pelas situações regulamentarmente previstas no RAC",

            "markets.copyValues.block": "Bloco",
            "markets.copyValues.hours": "Períodos",
            "markets.offers.missingData": "Não existe informação de oferta a apresentar.",
            "markets.offers.copiedData": "Dados copiados para Área de Transferência.",

            // User Registration
            "label.userRegistration.viewTermsAndConditions": "Consulte aqui os nossos Termos e Condições",
            "label.userRegistration.registrationComplete": "Completou o seu registo! Pode seguir para a página de login aqui",
            "label.registration.loginLink": "aqui",
            "label.userRegistration.loginWithFiscalNumber": "e realizar o login com o seu NIF.",
            "label.step.userProfile": "Perfil do Utilizador",
            "label.step.userProfilePicture": "Foto de Perfil",
            "label.step.userAddress": "Morada",
            "label.step.userSecurityConfiguration": "Configuração de Segurança",

            "label.table.paymentMethods.bankName": "Nome do Banco",
            "label.table.paymentMethods.swift": "Swift",

            "communities.communityImage": "Imagem da Comunidade",

            "agentDetails.renSettlement.title": "Liquidação REN",
            "label.message.agent.renSettlementUpdated": "Dados para Liquidação da REN atualizados com sucesso.",
            "label.message.agent.renSftpSystemServicesMarketUpdated": "SFTP Serviços do Sistema atualizada com sucesso.",
            "btnLabel.addCClient": "Novo Cliente",
            "addClient.clientType": "Tipo de Cliente",
            "addClient.clientType.subtitle": "O cliente pode ser de vários tipos. Quais os tipos de cliente que pretende selecionar?",
            "addClient.clientType.producerOrEgac": "Cliente Produtor/EGAC",
            "addClient.clientType.consumer": "Cliente Consumidor",
            "addClient.clientType.noProducerOrEgac": "O cliente não é Produtor nem EGAC. Não é necessário preencher esta informação.",
            "addClient.clientType.noConsumer": "O cliente não é Consumidor. Não é necessário preencher esta informação.",
            "addClient.clientType.confirmationStep.subtitle": "Confirme os dados do cliente a criar.",
            "addClient.clientType.confirmationStep.consumerData": "Dados do Cliente Consumidor",
            "addClient.clientType.confirmationStep.producerData": "Dados do Cliente Produtor/EGAC",
            "addClient.clientType.confirmationStep.autoInvoiceRegime": "Regime de Autofaturação",

            "taxRegimes.ISN": "Regime de Isenção de IVA",
            "taxRegimes.NRM": "Regime Normal de IVA",
            "taxRegimes.ATL": "Regime de Autoliquidação do IVA",

            "clientsFilter.selectEntity": "Selecione uma entidade",
            "clientsFilter.selectAgent": "Selecione um agente",
            "clientList.hasValidationCode": "Séries Comunicadas",

            "consumer": "Consumidor",
            "producer": "Produtor",
            "egac": "Entidade Gestora (EGAC)",

            "clientDetails.clientTypes": "Tipos de Cliente",
            "agentEntity.contactData": "Dados de Contacto da Entidade do Agente",

            "label.success.passwordReset.completed": "A sua palavra-passe foi alterada com sucesso. Pode agora fazer login com a nova palavra-passe.",
            "label.error.passwordReset.tokenExpired": "O link para alterar a palavra-passe expirou. Por favor solicite novamente a alteração da palavra-passe.",
            "label.error.passwordReset.failed": "Não foi possível alterar a palavra-passe. Por favor tente novamente mais tarde.",

            "api.error.createClient.clientAlreadyExists": "Já existe um cliente com o NIF/NIPC indicado. Feche esta janela e pesquise por esse NIF na tabela de clientes para o selecionar.",

            "btnLabel.addPhysicalUnit": "Nova Instalação",

            "installationClassification.ic": "Instalação de Consumo",
            "installationClassification.ic_prod": "Instalação de Consumo com UPAC",
            "installationClassification.ic_prod_strg": "Instalação de Consumo com UPAC e Armazenamento",
            "installationClassification.ic_strg": "Instalação de Consumo com Armazenamento",
            "installationClassification.ip": "Instalação de Produção (IPr)",
            "installationClassification.ip_strg": "Instalação de Produção com Armazenamento",
            "installationClassification.ia": "Instalação de Armazenamento",

            "newAgentCommunity.ownerAgentNotRequired": "Este campo não é necessário para o tipo de negócio selecionado.",
            "newAgentCommunity.projectSummary": "Resumo do Projeto",
            "newAgentCommunity.registrationData": "Dados de Registo",
            "newAgentCommunity.projectSummary.subtitle": "Introduza os valores do projeto.",
            "newAgentCommunity.clientEGAC": "Cliente EGAC",
            "newAgentCommunity.egacRegisteredDGEG": "EGAC Registada na DGEG",
            "newAgentCommunity.egacRegisteredDGEG.subtitle": "Insira os dados da Entidade Gestora registado na DGEG",
            "newAgentCommunity.confirmStep.businessType.aggregation": "Agregação",
            "newAgentCommunity.confirmStep.businessType.communities": "Comunidades",
            "newAgentCommunity.isEGACInDGEG": "O agente selecionado é a EGAC registada na DGEG",

            "noConsumptionDeliverypoint": "Sem CPE de Consumo",

            "communityDetail.searchEGACClient": "Pesquisar por Cliente EGAC...",
            "communityDetail.onlyUpdateClientEGAC": "O cliente que está a tentar editar não se encontra registado para este agente",

            "api.error.createPhysicalUnit.alreadyExists": "O CPE já existe para este agente",
            "api.error.updatePhysicalUnit.alreadyExists": "O CPE já existe para este agente",
            "api.error.createPhysicalUnit.sameDeliverypoints": "Os CPEs de Consumo e de Produção não podem ser iguais",

            "api.error.createCommunity.alreadyExists": "Já existe uma comunidade registada com este código",

            "newTarriffPlan.contractInfo": "Informação Contratual",
            "newTarriffPlan.tariffPlanType": "Instalações / Comunidades",
            "newTarriffPlan.seeInstallations": "Ver Instalações",
            "newTarriffPlan.seeCommunities": "Ver Comunidades",
            "newTarriffPlan.initialAgentData": "O agente associado é:",
            "newTarriffPlan.initialClientData": "O cliente associado é:",
            "newTarriffPlan.initialMemberData": "O membro associado é:",
            "newTarriffPlan.initialInstallationData": "A instalação associada é:",
            "newTarriffPlan.initialCommunityData": "A comunidade associada é:",

            "communityDetails.activateCommunityManagement": "Ativar Gestão Comunidade",
            "communityDetails.activateCommunityManagement.confirmText": "Esta ação irá definir o agente {{agentName}} como Entidade Gestora da Comunidade e permitir a gestão de membros e faturação da comunidade na plataforma da Indie Energy. Deseja continuar?",
            "communityDetails.activateCommunityManagement.activation": "A comunidade {{communityName}} encontra-se disponível para gestão na plataforma Indie Energy. Deverá preencher a informação de Data de Ativação, Modo de Partilha e Modelo Tarifário e Faturação nos detalhes da comunidade para poder dar início à faturação dos membros.",

            "error.forms.newCommunityTariffPlan.noAgentOrCommunity": "Não foi possível determinar o agente.",

            "egacClient.communities.dgegName": "Nome EGAC DGEG",
            "egacClient.communities.dgegNIF": "NIF EGAC DGEG",

            "tariffs.acceptNegPrices": "Aceita Preços Negativos",
            "api.error.createCommunity.alreadyExists": "Já existe uma comunidade registada com este código",

            "label.status.processed": "Processado",
            "label.status.pending": "Pendente",
            "label.status.archived": "Arquivado",
            "label.status.error": "Erro",

            "label.installationMemberType.consumer": "Consumidoras",
            "label.installationMemberType.producer": "Produtoras",

            "errors.api.reports.settlement.dateRangeOver30Days": "O intervalo de datas deve ter no máximo 30 dias. Por favor, crie um novo relatório com um intervalo de datas menor.",
            // Delete Client Dialog
            "label.title.deleteClient": "Remover Cliente",
            "label.message.confirmDeleteClient": "Tem a certeza que pretende remover o cliente {{clientName}} (NIF: {{clientNIF}})? Esta ação é irreversível.",
            "errors.api.client.deleteBlocked": "Não foi possível remover o cliente. Verifique se existem Instalações, Planos Tarifários, Documentos ou outros registos associados a este cliente.",
            "errors.api.client.deleteIntegrityError": "Não foi possível remover o cliente devido a uma restrição de integridade dos dados. Por favor contacte o suporte.",
            "errors.api.client.deleteFailed": "Ocorreu um erro inesperado ao remover o cliente.",

            // Delete Physical Unit Dialog
            "label.title.deletePhysicalUnit": "Remover Instalação",
            "label.message.confirmDeletePhysicalUnit": "Tem a certeza que pretende remover a instalação com CPE {{deliveryPoint}}? Esta ação é irreversível.",
            "errors.api.physicalUnit.deleteFailed": "Não foi possível remover a instalação. Verifique se existem Planos Tarifários ou outros registos associados a esta instalação.",

            // Delete Community Member Dialog
            "label.title.deleteCommunityMember": "Remover Membro da Comunidade",
            "label.message.deleteCommunityMember": "Tem a certeza que pretende remover o membro da comunidade? Esta ação é irreversível.",
            "label.members.deleteCommunityMember.extMemberId": "ID DGEG",
            "label.members.deleteCommunityMember.consumptionDeliverypoint": "CPE Consumo",
            "label.members.deleteCommunityMember.productionDeliverypoint": "CPE Produção",
            "asset": "Ativo",

            "aggregatorDeliverypoint": "CPE Agregador",
            "api.error.createCommunity.aggregatorDeliveryPointAlreadyExists": "O CPE Agregador já se encontra associado a outra comunidade.",

            "dailyMarket.programmingHorizon": "Horizonte de Programação",
            "dailyMarket.openSession": "Sessão Aberta",
            "dailyMarket.programmingPeriod": "Período de Programação",
            "dailyMarket.programmingPUnit": "Unidade de Programação",
            "dailyMarket.programmingPUnits": "Unidades de Programação",

            "market.aFRRBand": "Banda de aFRR",
            "market.afrr.fullName": "Reserva de Restabelecimento de Frequência Automática",
            "market.aFRRBand.necessities": "Necessidades de Banda",
            "market.aFRRBand.change": "Troca de Banda",
            "market.aFRRBand.energy": "Energia",
            "market.aFRRBand.band": "Banda",
            "market.afrr.energy.selectAgentAndUnit": "Por favor selecione um Agente e Unidade Física primeiro.",
            "market.afrr.energy.selectPeriod": "Selecione um período para ver as ofertas.",
            "market.afrr.energy.bid.create": "Criar Oferta",
            "market.afrr.energy.bid.edit": "Editar Oferta aFRR Energia",
            "market.afrr.energy.bid.periodImmutable": "O período não pode ser alterado depois de a oferta ser criada.",
            "market.afrr.energy.bid.warning.exceedsTechnicalLimit": "A quantidade ultrapassa o limite técnico da plataforma de aFRR (9999 MW).",
            "market.afrr.energy.bid.warning.exceedsAvailableUp": "A quantidade ultrapassa a margem disponível (Potência Disponível menos Repartição/Programação) para uma oferta a subir.",
            "market.afrr.energy.bid.warning.exceedsAvailableDown": "A quantidade ultrapassa a Repartição/Programação atual para uma oferta a baixar.",
            "market.afrr.energy.bid.warning.belowContractedBand": "A quantidade é inferior à Banda de aFRR contratada para este período.",
            "market.afrr.energy.bid.warning.belowMandatoryCapacity": "Esta Unidade Física está sujeita a obrigação de prestação de serviço de aFRR — a quantidade é inferior à potência tecnicamente exequível.",
            "market.afrr.energy.bid.confirmWarningsTitle": "Reveja antes de submeter",
            "market.afrr.energy.bid.confirmAndSave": "Confirmar e Guardar",
            "market.afrr.energy.bid.clickAgainToConfirm": "Foram encontrados avisos — clique novamente no botão para confirmar e avançar.",
            "market.afrr.energy.bid.error.negativeQty": "A quantidade não pode ser negativa.",
            "market.afrr.energy.band.assigned": "Atribuída",
            "market.afrr.energy.band.pending": "Pendente",
            "market.mfrr": "Reserva de Restabelecimento de Frequência Manual",
            "market.mfrr.energy": "Energia",
            "market.mfrr.bid.create": "Criar Oferta",
            "market.mfrr.bid.edit": "Editar Oferta mFRR Energia",
            "market.mfrr.bid.save": "Guardar",
            "market.mfrr.bid.saveAndSubmit": "Guardar e Submeter",
            "market.mfrr.bid.submit": "Submeter",
            "market.mfrr.bid.submitted": "Oferta submetida com sucesso",
            "market.mfrr.bid.submitError": "Erro na submissão",
            "market.mfrr.bid.error.periodsNotOpen": "Um ou mais períodos selecionados já não estão abertos para ofertas.",
            "market.mfrr.bid.rejectionReason": "Oferta rejeitada pelo SIME",
            "market.mfrr.activationType.programada": "Programada",
            "market.mfrr.activationType.direta": "Direta",
            "market.mfrr.divisible": "Divisível",
            "market.mfrr.nonDivisible": "Não Divisível",
            "market.mfrr.direction.up": "Subir",
            "market.mfrr.direction.down": "Baixar",
            "market.mfrr.physicalUnits": "Unidades Físicas",
            "market.mfrr.minQtyNote": "Min/Max Qty são as quantidades oferecidas por unidade",
            "market.mfrr.viewLevel.offeringArea": "Área de Oferta",
            "market.mfrr.viewLevel.physicalUnit": "Unidade Física",
            "market.mfrr.selectPeriod": "Selecione um período para ver as ofertas",
            "market.mfrr.bid.newVersion": "Nova Versão",
            "market.mfrr.bid.selectAllOpen": "Selec. Todos Abertos",
            "market.mfrr.bid.hideClosedPeriods": "Esconder Fechados",
            "market.mfrr.selectAgentAndArea": "Selecione primeiro um Agente e uma Área de Oferta.",
            "market.mfrr.period.status.open": "Aberto",
            "market.mfrr.period.status.pending": "Pendente",
            "market.mfrr.period.status.closed": "Encerrado",
            "market.mfrr.bid.error.priceRange": "O preço deve estar entre -15000 e 15000 €/MWh.",
            "market.mfrr.bid.error.qtyRange": "Os valores de potência devem estar entre 0 e 9999 MW.",
            "market.mfrr.bid.error.minGreaterMax": "A quantidade mínima não pode ser superior à máxima.",
            "market.mfrr.dispatchOrders": "Instruções de Despacho",
            "market.mfrr.dispatchOrders.code": "Código da Instrução de Despacho",
            "market.mfrr.dispatchOrders.column.offerArea": "Área de Oferta",
            "market.mfrr.dispatchOrders.column.activationType": "Tipo de Ativação",
            "market.mfrr.dispatchOrders.column.regulationDirection": "Sentido de Regulação",
            "market.mfrr.dispatchOrders.column.volume": "Volume (MW)",
            "market.mfrr.dispatchOrders.column.createDate": "Data de Criação da DI",
            "market.mfrr.dispatchOrders.column.startDate": "Data de Início da DI",
            "market.mfrr.dispatchOrders.column.ramp1Start": "Início da Rampa 1",
            "market.mfrr.dispatchOrders.column.ramp1End": "Fim da Rampa 1",
            "market.mfrr.dispatchOrders.column.ramp2Start": "Início da Rampa 2",
            "market.mfrr.dispatchOrders.column.ramp2End": "Fim da Rampa 2",
            "label.status.bid.PENDING": "Pendente",
            "label.status.bid.RECEIVED": "Recebida",
            "label.status.bid.SUBMITTED": "Submetida",
            "label.status.bid.VALID": "Válida",
            "label.status.bid.ACCEPTED": "Aceite",
            "label.status.bid.REJECTED": "Rejeitada",
            "label.status.bid.EXPIRED": "Expirada",
            "label.status.bid.INVALID": "Inválida",
            "label.status.bid.ARCHIVED": "Arquivada",
            "label.status.bid.AVAILABLE": "Disponível",
            "label.status.bid.UNAVAILABLE": "Indisponível",
            "label.status.bid.WITHDRAWN": "Retirada",
            "label.status.bid.CONDITIONALLY_AVAILABLE": "Condicionalmente Disponível",
            "label.status.bid.CONDITIONALLY_UNAVAILABLE": "Condicionalmente Indisponível",
            "market.bilateralContracts": "Contratação Bilateral",
            "market.bilateralContracts.contract": "Contrato Bilateral",
            "market.bilateralContracts.contract.submitted": "Submetida",
            "market.bilateralContracts.contract.pending": "Pendente",
            "market.bilateralContracts.contract.archived": "Arquivado",
            "market.bilateralContracts.generate": "Gerar Comunicação",
            "market.bilateralContracts.submit": "Submeter Comunicação",
            "market.bilateralContracts.noData": "Nenhuma comunicação encontrada para esta data e BSP.",
            "market.bilateralContracts.pending": "Pendente",
            "market.bilateralContracts.submitted": "Submetida",
            "market.bilateralContracts.archived": "Arquivada",
            "market.bilateralContracts.contract.rejected": "Rejeitada",
            "market.bilateralContracts.contract.accepted": "Aceite",
            "market.bilateralContracts.active": "Ativo",
            "market.bilateralContracts.downloadSubmission": "Submissão",
            "market.bilateralContracts.downloadResponse": "Resposta",
            "market.bilateralContracts.version": "Versão",
            "market.bilateralContracts.valueMW": "Potência (MW)",
            "label.bilateralComms": "Comunicações",
            "label.bilateralContract.purchaseOfferingUnit": "Unidade de Oferta de Compra",
            "label.bilateralContract.saleOfferingUnit": "Unidade de Oferta de Venda",
            "market.unavailabilities": "Indisponibilidades",
            "market.unavailabilities.physicalUnit": "Unidade Física",
            "market.unavailabilities.agentEntity": "Agente de Mercado",
            "market.unavailabilities.startTimestamp": "Início ",
            "market.unavailabilities.endTimestamp": "Fim",
            "market.unavailabilities.type": "Tipo",
            "market.unavailabilities.networkRisk": "Risco de Rede",
            "market.unavailabilities.deleted": "Estado",
            "market.unavailabilities.tab.records": "Registos",
            "market.unavailabilities.tab.communications": "Comunicações",
            "market.unavailabilities.comm.code": "Código",
            "market.unavailabilities.comm.version": "Versão",
            "market.unavailabilities.comm.action": "Acção",
            "market.unavailabilities.comm.actionInsert": "Inserir/Actualizar",
            "market.unavailabilities.comm.actionDelete": "Eliminar",
            "market.unavailabilities.comm.status": "Estado",
            "market.unavailabilities.comm.date": "Data",
            "market.limitations": "Condicionamentos",
            "market.limitations.physicalUnit": "Unidade Física",
            "market.limitations.agentEntity": "Entidade",
            "market.limitations.startTimestamp": "Início",
            "market.limitations.endTimestamp": "Fim",
            "market.limitations.classification": "Classificação",
            "market.limitations.limitationType": "Tipo",
            "market.limitations.maxValue": "Máx (MW)",
            "market.limitations.minValue": "Mín (MW)",
            "market.limitations.networkRisk": "Risco de Rede",
            "market.limitations.deleted": "Estado",
            "market.limitations.tab.records": "Registos",
            "market.limitations.tab.communications": "Lotes TSO",
            "market.limitations.comm.code": "Código",
            "market.limitations.comm.date": "Data",
            "market.limitations.comm.version": "Versão",
            "market.limitations.comm.action": "Acção",
            "market.limitations.comm.actionInsert": "Inserir/Actualizar",
            "market.limitations.comm.actionDelete": "Eliminar",
            "market.limitations.comm.status": "Estado",
            "market.unavailabilities.create": "Nova Indisponibilidade",
            "market.unavailabilities.edit": "Editar Indisponibilidade",
            "market.unavailabilities.history": "Histórico de Comunicações",
            "market.unavailabilities.cancelTitle": "Cancelar Indisponibilidade",
            "market.unavailabilities.cancelConfirm": "Marcar esta indisponibilidade como inactiva? Esta acção não pode ser desfeita.",
            "market.unavailabilities.submitTitle": "Submeter ao GGS",
            "market.unavailabilities.submitConfirm": "Submeter esta indisponibilidade ao GGS? Será criada uma nova comunicação.",
            "market.unavailabilities.submitSuccess": "Submetido ao GGS.",
            "market.unavailabilities.type.PL": "Plano de Manutenção (PL)",
            "market.unavailabilities.type.PG": "Programada (PG)",
            "market.unavailabilities.type.FT": "Fortuita (FT)",
            "market.unavailabilities.status.pending": "Planeada",
            "market.unavailabilities.status.ongoing": "Em curso",
            "market.unavailabilities.status.ended": "Concluída",
            "market.unavailabilities.status.cancelled": "Cancelada",
            "market.unavailabilities.step.basic": "Informação Básica",
            "market.unavailabilities.step.descriptions": "Descrições",
            "market.unavailabilities.publicDescPt": "Descrição Pública (PT)",
            "market.unavailabilities.publicDescEn": "Descrição Pública (EN)",
            "market.unavailabilities.sensitiveDescPt": "Descrição Sensível (PT, opcional)",
            "market.unavailabilities.isDefinitive": "Definitiva",
            "market.unavailabilities.flagGb": "Flag GB",
            "market.unavailabilities.valueGb": "Potência Máxima Disponível",
            "market.unavailabilities.flagTlr": "Flag TLR",
            "market.unavailabilities.statusTlr": "Estado TLR",
            "market.unavailabilities.flagCompSinc": "Flag COMP SINC",
            "market.unavailabilities.statusCompSinc": "Estado COMP SINC",
            "market.unavailabilities.technicalFlags": "Flags técnicas",
            "market.unavailabilities.startTimestamp": "Início",
            "market.unavailabilities.endTimestamp": "Fim",
            "market.unavailabilities.timezoneNote": "As horas são reportadas no fuso horário da unidade física selecionada",
            "market.unavailabilities.dstAmbiguous": "Hora ambígua (mudança de hora) — selecione a ocorrência:",
            "market.unavailabilities.dstSummer": "Antes de recuar o relógio (UTC+1)",
            "market.unavailabilities.dstWinter": "Após recuar o relógio (UTC+0)",
            "market.limitations.create": "Novo Condicionamento",
            "market.limitations.edit": "Editar Condicionamento",
            "market.limitations.history": "Histórico de Comunicações",
            "market.limitations.cancelTitle": "Cancelar Condicionamento",
            "market.limitations.cancelConfirm": "Marcar este condicionamento como inactivo? Esta acção não pode ser desfeita.",
            "market.limitations.comment": "Comentário",
            "market.tradingOutlook": "Perspectiva de Trading",
            "market.tradingOutlook.comingSoon": "Perspectiva de Trading",
            "market.tradingOutlook.description": "Visualização temporal de indisponibilidades e condicionamentos por intervalos de programação. Em breve.",
            "market.tradingOutlook.selectBspAndDate": "Selecione um BSP e uma data para carregar a perspectiva de trading.",
            "market.tradingOutlook.capacidade": "Capacidade",
            "market.tradingOutlook.totalPower": "Potência Total",
            "market.tradingOutlook.availablePower": "Potência Disponível",
            "market.tradingOutlook.unavailablePower": "Potência Indisponível",
            "market.tradingOutlook.physicalUnit": "Unidade Física",
            "market.tradingOutlook.maxPower": "Pot. Máxima (MW)",
            "market.tradingOutlook.availablePowerCol": "Disponível (MW)",
            "market.tradingOutlook.offeringArea": "Área de Oferta",
            "market.tradingOutlook.noUnits": "Nenhuma unidade física encontrada para os filtros selecionados.",
            "market.tradingOutlook.period": "Período",
            "market.tradingOutlook.kpi.nominalCapacity": "Capacidade Nominal",
            "market.tradingOutlook.kpi.maxDeviation": "Desvio Máximo de Potência",
            "market.tradingOutlook.kpi.actualCapacity": "Capacidade Real",
            "market.tradingOutlook.kpi.maxAvailablePower": "Potência Máx. Disponível",
            "market.tradingOutlook.kpi.minAvailablePower": "Potência Mín. Disponível",
            "market.tradingOutlook.kpi.minPowerTotal": "Potência Mín. Total",
            "market.tradingOutlook.kpi.maxOfferTotal": "Potência Máx. Total",
            "market.tradingOutlook.kpi.minPowerAvailable": "Potência Mín. Disponível",
            "market.tradingOutlook.kpi.maxPowerAvailable": "Potência Máx. Disponível",
            "market.tradingOutlook.kpi.totalCapacity": "Capacidade Total",
            "market.tradingOutlook.kpi.availablePower": "Potência Disponível",
            "market.tradingOutlook.kpi.minPower": "Potência Mín.",
            "market.tradingOutlook.kpi.maxPower": "Potência Máx.",
            "market.tradingOutlook.col.periodNumber": "Período #",
            "market.tradingOutlook.col.periodName": "Período",
            "market.tradingOutlook.col.minPowerTotal": "Potência Mín. Total (MW)",
            "market.tradingOutlook.col.maxOfferTotal": "Oferta Máx. Total (MW)",
            "market.tradingOutlook.col.minPowerAvailable": "Potência Mín. Disponível (MW)",
            "market.tradingOutlook.col.maxPowerAvailable": "Potência Máx. Disponível (MW)",
            "market.tradingOutlook.allOfferingAreas": "Todas as Áreas de Oferta",
            "market.tradingOutlook.selectAgentAndDate": "Deve selecionar o agente e a data.",
            "market.tradingOutlook.onlyWithUnavailabilities": "Mostrar apenas unidades com indisponibilidades",
            "market.comm.code": "Código",
            "market.comm.version": "Versão",
            "market.comm.action": "Acção",
            "market.comm.actionInsert": "Inserir/Actualizar",
            "market.comm.actionDelete": "Eliminar",
            "market.comm.status": "Estado",
            "market.comm.date": "Data",
            "market.comm.document": "Documento",
            "label.button.history": "Histórico",
            "label.noRecords": "Sem registos.",
            // Old Status LAbels
            "market.offersSubmitted": "Submetida",
            "market.offersNotSubmitted": "Pendente",
            "market.offersRejected": "Rejeitada",
            "market.offersArchived": "Arquivada",
            "market.offersAccepted": "Aceite",
            // New Status Labels
            "status.offer.pending": "Pendente",
            "status.offer.not_submitted": "Not Submetida",
            "status.offer.submitted": "Submetida",
            "status.offer.archived": "Arquivada",
            "status.offer.accepted": "Aceite",
            "status.offer.rejected": "Rejeitada",
            // End New Status Labels
            "market.noOfferInfo": "Sem Informação",
            "market.partition.selectFilters": "Selecione uma data, BSP e unidade de programação para ver os detalhes da repartição.",
            "market.afrr.selectFilters": "Selecione uma data e BSP para ver os detalhes da oferta de banda.",
            "market.afrr.selectPhysicalUnit": "Selecione uma unidade física para ver os períodos.",
            "market.afrr.validation.row": "Linha {{row}}: {{message}}",
            "market.afrr.validation.physicalUnit": "unidade física é obrigatória",
            "market.afrr.validation.period": "período deve estar entre 1 e 96",
            "market.afrr.validation.block": "bloco deve ser ≥ 1",
            "market.afrr.validation.avgPower": "potência média deve estar entre 0 e 9999.9 MW",
            "market.afrr.validation.avgPowerMax": "potência média excede o máximo da unidade",
            "market.afrr.validation.bandPrice": "preço da banda deve estar entre 0 e 999.99 €/MW",
            "market.afrr.validation.energyPrice": "preço da energia deve estar entre -9999.99 e 9999.99 €/MWh",
            "market.afrr.periodsWithErrors": "Com Alertas / Erros",
            "market.noSwitchingRequestInfo": "Sem Informação",
            "market.switchingRequestPending": "Pendente",
            "market.switchingRequestSubmitted": "Submetido",
            "market.switchingRequestAccepted": "Aceite",
            "market.switchingRequestRejected": "Rejeitado",
            "market.switchingRequestArchived": "Arquivado",
            "market.submissionDate": "Hora de submissão",
            "market.blockOffer": "Bloco de oferta",
            "market.direction": "Sentido",
            "market.averagePowerMW": "Potência média (MW)",
            "market.energyPrice": "Preço da energia (€/MWh)",
            "market.up": "Subir",
            "market.down": "Baixar",
            "market.offerOrigin.automatic": "Automática",
            "market.offerOrigin.manual": "Manual",
            "label.button.modifyPeriods": "Modificar Períodos",
            "send": "Enviar",
            "currentTime": "Hora atual",
            "label.form.syncMssRenPowertradingData": "Sincronizar dados de GGS?",
            "label.form.mssParticipation": "Participa no MSS?",
            "actions": "Ações",
            "delete": "Eliminar",
            "edit": "Editar",
            "physicalUnit.addCommunity": "Associar Comunidade",

            "error.api.updateInvoicingCycle.invoicingCycleRequested": "Ocorreu um erro ao atualizar o ciclo de faturação",
            "error.api.updateInvoicingCycle.invoicingCycleNotFound": "O ciclo de faturação selecionado não foi encontrado",
            "error.api.updateInvoicingCycleFailed": "Ocorreu um erro ao atualizar o ciclo de faturação",

            "label.message.confirmNewAutoInvoiceAgreement": "Tem a certeza que pretende registar um novo acordo de autofaturação com o agente {{agentEntity}}?",
            "label.menu.communication": "Comunicação",
            "label.text.agentLogoNote": "Esta imagem será utilizada nos e-mails enviados aos clientes quando estiver a utilizar o domínio do agente.",
            "label.action.uploadLogo": "Carregar Logótipo",
            "label.action.removeLogo": "Remover Logótipo",
            "label.message.agent.logoUpdated": "Logótipo do agente atualizado com sucesso.",
            "label.message.agent.logoRemoved": "Logótipo do agente removido com sucesso.",
            "label.message.agent.certificateUploaded": "Certificado carregado com sucesso.",
            "label.message.agent.certificatePasswordUpdated": "Password do certificado atualizada com sucesso.",
            "label.message.agent.referenceCodesUpdated": "Códigos de referência atualizados com sucesso.",
            "label.message.agent.renSettlementUpdated": "Dados de liquidação REN atualizados com sucesso.",
            "label.message.agent.renSftpConfigurationUpdated": "Configuração SFTP REN atualizada com sucesso.",
            "label.message.agent.eredesSftpConfigurationUpdated": "Configuração SFTP E-Redes atualizada com sucesso.",
            "label.message.agent.renSftpSystemServicesMarketUpdated": "Configuração SFTP Mercado de Serviços de Sistema atualizada com sucesso.",
            "label.message.agent.emailConfigurationTested": "Configuração de email testada com sucesso.",
            "label.dialog.title.testEmailConfiguration": "Testar Configuração de Email",
            "label.dialog.description.testEmailConfiguration": "Indique o endereço de email para onde deseja enviar o email de teste.",
            "label.button.sendTestEmail": "Enviar Email de Teste",
            "label.form.toEmail": "Email de Destino",
            "api.error.emailSendFailed": "Ocorreu um erro ao enviar o email de teste.",
            "api.error.userEmailAlreadyExists": "Já existe um utilizador com o endereço de email indicado. Por favor verifique os dados e tente novamente.",
            "api.error.usernameAlreadyExists": "Já existe um utilizador com o nome de utilizador indicado. Por favor escolha outro nome de utilizador.",
            "form.error.newTariffPlan.missingTariffplanType": "Não foi possível determinar o tipo de plano tarifário. Por favor contacte o suporte.",
            "label.title.confirmationStep": "Confirmação",
            "bsp": "BSP",
            "market.bandPrice": "Preço da Banda (€/MW)",
            "indivisible": "Indivisível",
            "market.insertPhysicalUnit": "Inserir Unidade Física",
            "api.error.offeringUnit.delete.activePhysicalUnits": "Não é possível remover uma Unidade de Oferta com Unidades Físicas ativas.",
            "label.timezone.market": "Horas apresentadas no fuso horário de mercado.",

            // Page Titles
            "label.page.physicalUnits": "Instalações",
            "label.page.marketOfferingUnits": "Mercados - Unidades de Oferta",
            "label.page.marketPhysicalUnits": "Mercados - Unidades Físicas",
            "form.error.reissueFinancialDocument.noData": "Não foram encontrados dados para o período selecionado. Não é possível gerar um novo documento.",

            "label.menu.list": "Lista",
            "label.search": "Procurar",

            "label.menu.market.mfrr": "mFRR",
            "label.menu.market.afrr": "aFRR",

            "afrr.columnTitle.bandMW": "Banda (MW)",
            "label.button.addOffers": "Adicionar Ofertas",

            "label.button.contractedBand": "Banda Contratada",
            "label.button.bandUp": "Banda a subir",
            "label.button.bandDown": "Banda a baixar",

            // Manual Document Creation
            "label.title.newDocument": "Novo Documento",
            "label.title.installation": "Instalações",
            "label.title.surplusCommunity": "Comunidades",
            "label.title.targetType": "Tipo de Ativo",
            "label.step.selectTarget": "Selecionar Instalação ou Comunidade",
            "label.step.selectClassifications": "Selecionar Classificações dos Documentos",
            "label.step.selectPeriod": "Selecionar Período",
            "label.step.previewAndApprove": "Pré-visualizar e Criar",
            "label.info.selected": "Selecionado",
            "label.info.autoClassification": "Classificação automática",
            "label.info.preparingDocuments": "A preparar documentos...",
            "label.info.noDocumentsForPeriod": "Não foram gerados documentos para o período selecionado. Verifique se as datas estão corretas e se existe um plano tarifário ativo que abranja este período.",
            "label.info.allDocumentsProcessed": "Todos os documentos foram criados.",
            "label.dialog.title.confirmCompletion": "Confirmar Conclusão",
            "label.info.documentsApproved": "Criados com sucesso:",
            "label.info.documentsWithErrors": "Documentos com erro na criação:",
            "label.info.documentsNotProcessed": "Não processados:",
            "label.info.confirmCloseAnyway": "Existem documentos não processados ou com erros. Tem a certeza que pretende fechar?",
            "label.info.consultListBelow": "Consulte abaixo a listagem dos documentos.",
            "label.button.closeAnyway": "Fechar na Mesma",
            "label.button.previewDocuments": "Pré-visualizar Documentos",
            "label.button.newDocument": "Novo Documento",
            "label.button.approveDocument": "Criar Documento",
            "label.button.finish": "Concluir",
            "label.status.approved": "Criado",
            "label.status.processing": "A processar",
            // Financial document detail page
            "label.financialDocument.back": "Voltar a {{label}}",
            "label.financialDocument.toolbar.attachments": "Anexos",
            "label.financialDocument.toolbar.relatedDocuments": "Documentos relacionados",
            "label.financialDocument.toolbar.more": "Mais",
            "label.financialDocument.action.createSettlementNote": "Criar nota de liquidação",
            "label.financialDocument.action.void": "Anular",
            "label.financialDocument.action.voidHint": "Mantém o registo com o estado Anulado",
            "label.financialDocument.action.attach": "Anexar",
            "label.financialDocument.banner.voided": "Anulado em {{date}} por {{user}}",
            "label.financialDocument.banner.voidedNoUser": "Anulado em {{date}}",
            "label.financialDocument.banner.voidedNoHistory": "Este documento está anulado.",
            "label.financialDocument.banner.processing": "A aguardar a emissão do documento pelo ERP. Esta página é atualizada automaticamente.",
            "label.financialDocument.field.erpDocumentId": "ID do documento no ERP",
            "label.financialDocument.field.netTotal": "Total líquido",
            "label.financialDocument.field.totalWithTaxes": "Total com Impostos",
            "label.financialDocument.field.agentType": "Tipo de agente",
            "label.financialDocument.field.iban": "IBAN",
            "label.financialDocument.placeholder.erpId": "Atribuído pelo ERP na emissão",
            "label.financialDocument.placeholder.totalWithTaxes": "Devolvido pelo ERP na emissão",
            "label.financialDocument.lines.empty": "Este documento não tem linhas.",
            "label.financialDocument.help.totalWithTaxes": "Este valor é apresentado quando o documento for emitido no ERP.",
            "label.financialDocument.lines.startDate": "Data Início",
            "label.financialDocument.lines.endDate": "Data Fim",
            "label.financialDocument.lines.returnedOnIssue": "Devolvido na emissão",
            "label.financialDocument.history.created": "Criado com o estado {{to}}",
            "label.financialDocument.history.statusChanged": "{{from}} → {{to}}",
            "label.financialDocument.history.statusChangedA11y": "{{from}} para {{to}}",
            "label.financialDocument.history.reprocessed": "Reprocessado",
            "label.financialDocument.history.settlementNoteCreated": "Nota de liquidação criada",
            "label.financialDocument.history.unknownUser": "—",
            "label.financialDocument.history.empty": "Sem histórico registado",
            "label.financialDocument.history.error": "Não foi possível carregar o histórico.",
            "label.financialDocument.notAvailable.title": "Documento não disponível",
            "label.financialDocument.notAvailable.agent": "Os agentes não veem documentos a aguardar aprovação. O documento fica visível depois de um administrador da Indie Energy o aprovar.",
            "label.financialDocument.notAvailable.generic": "O documento não existe ou não tem acesso ao mesmo.",
            "label.financialDocument.loadError": "Não foi possível carregar o documento.",
            "label.button.retry": "Tentar novamente",
            "label.button.create": "Criar",
            "label.financialDocument.dialog.approve.title": "Aprovar documento?",
            "label.financialDocument.dialog.approve.body": "O documento passa para Pendente. Poderá depois ser processado.",
            "label.financialDocument.dialog.process.title": "Processar documento?",
            "label.financialDocument.dialog.process.body": "O documento é enviado para o ERP e passa para Processado até o ERP o emitir. Após a emissão, o ERP devolve o ID do documento e o total com impostos, o PDF da fatura é gerado e o documento fica visível para o cliente. Depois de emitido, o documento pode ser reprocessado ou anulado.",
            "label.financialDocument.dialog.reprocess.title": "Reprocessar {{id}}?",
            "label.financialDocument.dialog.reprocess.titleNoId": "Reprocessar documento?",
            "label.financialDocument.dialog.reprocess.body": "O documento é novamente enviado para o ERP e o PDF devolvido substitui o ficheiro atual. O ID do documento no ERP e o total com impostos mantêm-se.",
            "label.financialDocument.dialog.createSettlementNote.title": "Criar nota de liquidação?",
            "label.financialDocument.dialog.createSettlementNote.body": "A nota de liquidação (Excel) é gerada a partir das linhas do documento e adicionada aos anexos.",
            "label.financialDocument.dialog.attach.title": "Anexar documento",
            "label.financialDocument.dropzone.invoiceHint": "Arraste o PDF para aqui ou clique para procurar · apenas PDF · até 10 MB",
            "label.financialDocument.dropzone.hint": "Arraste um ficheiro para aqui ou clique para procurar · PDF, XLSX, JPG, PNG ou XML · até 10 MB",
            "label.financialDocument.attach.tooManyFiles": "Anexe um ficheiro de cada vez.",
            "label.financialDocument.attachments.subtitle": "Nota de liquidação, fatura, nota de pagamento e ficheiros carregados",
            "label.financialDocument.attachments.empty.title": "Ainda sem anexos",
            "label.financialDocument.attachments.empty.awaitingApproval": "Os documentos a aguardar aprovação não têm ficheiros.",
            "label.financialDocument.attachments.empty.createHint": "A nota de liquidação é criada com Criar nota de liquidação.",
            "label.financialDocument.attachments.error": "Não foi possível carregar os anexos.",
            "label.financialDocument.attachments.download": "Descarregar {{name}}",
            "label.financialDocument.attachments.replace": "Substituir",
            "label.financialDocument.dialog.replaceInvoice.title": "Substituir o PDF do documento?",
            "label.financialDocument.dialog.replaceInvoice.warning": "O PDF atual do documento é removido e substituído por este ficheiro. Esta ação não pode ser desfeita. O cliente não é notificado por email. Se o documento for reprocessado mais tarde, o PDF devolvido pelo ERP substitui este ficheiro.",
            "label.financialDocument.dialog.replaceInvoice.confirm": "Substituir PDF",
            "success.financialDocument.invoiceReplaced": "PDF do documento substituído",
            "label.financialDocument.history.invoiceReplaced": "Fatura / Documento Compra substituído",
            "errors.api.financialDocument.cannotReplaceInvoice": "Só é possível substituir o PDF em documentos emitidos ou pagos que tenham PDF do ERP.",
            "errors.api.financialDocument.invoiceMustBePdf": "O ficheiro tem de ser um PDF.",
            "errors.api.financialDocument.invoiceSingleFile": "Selecione um único ficheiro PDF.",
            "label.financialDocument.attachment.kind.STL": "Nota de liquidação",
            "label.financialDocument.attachment.kind.INV": "Fatura",
            "label.financialDocument.attachment.kind.PRD": "Documento de compra",
            "label.financialDocument.attachment.kind.CRN": "Nota de crédito",
            "label.financialDocument.attachment.kind.YIN": "Fatura do fornecedor",
            "label.financialDocument.attachment.kind.MDR": "Relatório de dados em falta",
            "label.financialDocument.attachment.kind.UPL": "Carregado",
            "label.financialDocument.attachment.kind.PAY": "Nota de pagamento",
            "label.financialDocument.attachment.kind.unknown": "Documento",
            "label.financialDocument.placeholder.settlementNoteHint": "Criada com Criar nota de liquidação",
            "label.financialDocument.placeholder.issuedHint": "Gerado quando o ERP emite o documento",
            "label.financialDocument.placeholder.paymentNoteHint": "Adicionada quando o documento é pago",
            "label.financialDocument.related.subtitle": "Notas de crédito e documentos reemitidos associados a este documento",
            "label.financialDocument.related.column.document": "Documento",
            "label.financialDocument.related.column.relation": "Relação",
            "label.financialDocument.related.column.date": "Data",
            "label.financialDocument.related.column.total": "Total",
            "label.financialDocument.related.column.status": "Estado",
            "label.financialDocument.related.notIssuedYet": "Ainda não emitido",
            "label.financialDocument.related.relation.VOIDS.incoming": "Credita este documento",
            "label.financialDocument.related.relation.VOIDS.outgoing": "Creditado por este documento",
            "label.financialDocument.related.relation.REISSUES.incoming": "Reemissão que substitui este documento",
            "label.financialDocument.related.relation.REISSUES.outgoing": "Documento anulado substituído por este",
            "label.financialDocument.related.empty.title": "Sem documentos relacionados",
            "label.financialDocument.related.empty.body": "As notas de crédito emitidas para este documento e os documentos que o substituem após uma anulação ficam associados aqui.",
            "label.financialDocument.related.error": "Não foi possível carregar os documentos relacionados.",
            "label.financialDocument.related.documentCrumb": "Documento n.º {{id}}",
            "success.financialDocument.approved": "Documento aprovado",
            "success.financialDocument.processing": "Documento em processamento",
            "success.financialDocument.reprocessRequested": "Reprocessamento pedido",
            "label.financialDocument.action.resendEmail": "Reenviar email",
            "label.financialDocument.action.resendEmailHint": "Envia novamente o documento por email ao cliente",
            "label.financialDocument.action.regenerateSettlementNote": "Regenerar nota de liquidação",
            "label.financialDocument.action.regenerateSettlementNoteHint": "Substitui o ficheiro atual da nota de liquidação",
            "label.financialDocument.history.clientInvoiceUploaded": "Fatura do fornecedor carregada",
            "label.financialDocument.menu.uploadReplacesPrevious": "O ficheiro substitui a fatura carregada anteriormente para este documento.",
            "errors.api.financialDocument.cannotUploadInvoice": "Só é possível carregar uma fatura num documento de compra que não esteja anulado.",
            "label.financialDocument.history.emailSent": "Email enviado",
            "label.financialDocument.dialog.regenerateSettlementNote.title": "Regenerar a nota de liquidação?",
            "label.financialDocument.dialog.regenerateSettlementNote.body": "É gerada uma nova nota de liquidação com os dados atuais, que substitui o ficheiro atual da nota de liquidação. O ficheiro atual não é guardado.",
            "label.financialDocument.dialog.regenerateSettlementNote.issuedBody": "O cliente não é notificado por email e o documento emitido no ERP não é alterado. Para enviar o novo ficheiro ao cliente, utilize Reenviar email.",
            "label.financialDocument.dialog.regenerateSettlementNote.confirm": "Regenerar",
            "label.financialDocument.dialog.resendEmail.title": "Reenviar o email do documento?",
            "label.financialDocument.dialog.resendEmail.body": "O cliente recebe novamente o email do documento em {{email}}, com o PDF do documento e os restantes ficheiros, exceto os documentos carregados.",
            "label.financialDocument.dialog.resendEmail.noAddress": "O cliente não tem endereço de email, pelo que não é possível enviar o email.",
            "label.financialDocument.dialog.resendEmail.confirm": "Reenviar email",
            "success.financialDocument.settlementNoteRegenerated": "Nota de liquidação regenerada",
            "success.financialDocument.emailSent": "Email enviado para {{email}}",
            "errors.api.financialDocument.cannotResendEmail": "Só é possível reenviar o email de documentos emitidos ou pagos que tenham PDF do documento.",
            "errors.api.financialDocument.resendEmailBlocked": "O envio de emails a clientes está bloqueado para este agente, por isso o email não foi enviado.",
            "errors.api.financialDocument.resendEmailNoClient": "O documento não tem cliente para enviar o email.",
            "errors.api.financialDocument.resendEmailNoAddress": "O cliente não tem endereço de email.",
            "errors.api.financialDocument.resendEmailNotIssued": "O documento não tem data de emissão, pelo que não é possível enviar o email.",
            "errors.api.financialDocument.resendEmailNoTemplate": "Não existe modelo de email para este tipo de documento.",
            "errors.api.financialDocument.resendEmailFailed": "Não foi possível enviar o email. Tente novamente mais tarde.",
            "success.financialDocument.settlementNoteCreated": "Nota de liquidação criada",
            "success.financialDocument.attached": "Documento anexado",
            "success.financialDocument.issued": "Documento emitido pelo ERP",
            "error.financialDocument.download": "Não foi possível descarregar o ficheiro.",
            "errors.api.financialDocumentAlreadyApproved": "O documento já se encontra aprovado.",
            "errors.api.financialDocument.cannotPublish": "O documento só pode ser processado quando está Pendente ou Processado.",
            "errors.api.financialDocument.cannotReprocess": "Só é possível reprocessar documentos emitidos ou pagos.",
            "errors.api.financialDocument.settlementNoteNeedsContract": "Só é possível criar a nota de liquidação para documentos com contrato.",
            "errors.api.financialDocument.settlementNoteOnCreditNote": "Não é possível criar a nota de liquidação para uma nota de crédito que anula outro documento.",
            "errors.api.financialDocument.attachmentMissing": "Selecione um ficheiro para anexar.",
            "errors.api.financialDocument.attachmentTypeNotAllowed": "Este tipo de ficheiro não é permitido. Utilize PDF, XLSX, JPG, PNG ou XML.",
            "errors.api.financialDocument.attachmentTooLarge": "O ficheiro tem mais de 10 MB.",
            "errors.api.financialDocument.attachmentNameTooLong": "O nome do ficheiro tem mais de 100 caracteres. Mude o nome do ficheiro e tente novamente.",
            "errors.api.financialDocument.documentVoided": "O documento está anulado. Já não é possível anexar ficheiros.",
            "label.title.noEntity": "Sem cliente",
            "api.error.internalServerError": "Ocorreu um erro inesperado no servidor. Por favor, tente novamente mais tarde.",
        }
    }
};
i18next.use(initReactI18next).init({
    resources,
    lng: "pt",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});